(function(){
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  const currency = window.DF_CURRENCY || 'USD';
  const feeHandleNeedle = 'df-exact-delivery-window-fee';
  const balloonUpgradeHandleNeedle = 'df-balloon-design-upgrade';
  const rafThrottle = (callback) => {
    let frame = 0;
    return (...args) => {
      if (frame) return;
      frame = window.requestAnimationFrame(() => {
        frame = 0;
        callback(...args);
      });
    };
  };
  const campaignParams = new URLSearchParams();
  new URLSearchParams(window.location.search).forEach((value, key) => {
    const normalizedKey = String(key).toLowerCase();
    if (/^utm_/i.test(key) || ['gclid', 'gbraid', 'wbraid'].includes(normalizedKey)) campaignParams.append(key, value);
  });
  const withCampaignParams = (value) => {
    if (!value || ![...campaignParams].length) return value;
    const target = new URL(value, window.location.origin);
    if (target.origin !== window.location.origin) return value;
    campaignParams.forEach((paramValue, key) => {
      if (!target.searchParams.has(key)) target.searchParams.append(key, paramValue);
    });
    return `${target.pathname}${target.search}${target.hash}`;
  };
  document.querySelectorAll('a[href]').forEach((link) => {
    const target = new URL(link.href, window.location.origin);
    // Keep attribution when shoppers browse a full collection before choosing a product.
    if (target.origin === window.location.origin && /^\/(?:cart|products|collections)(?:\/|$)/.test(target.pathname)) link.href = withCampaignParams(link.href);
  });
  const measureOpenAIPixel = (eventName, payload) => {
    if (typeof window.oaiq !== 'function') return;
    try { window.oaiq('measure', eventName, payload); }
    catch (error) { console.warn('OpenAI Ads measurement failed', error); }
  };

  measureOpenAIPixel('page_viewed', {
    type: 'contents',
    contents: [{
      id: window.location.pathname || '/',
      name: document.title || 'Dopamine Flowers',
      content_type: 'page'
    }]
  });

  const addedItemsFromResponse = (response) => {
    if (!response) return [];
    return Array.isArray(response.items) ? response.items : [response];
  };

  const measureItemsAdded = (response) => {
    const items = addedItemsFromResponse(response).filter(Boolean);
    if (!items.length) return;
    const contents = items.map(item => {
      const quantity = Math.max(1, Number(item.quantity || 1));
      const unitAmount = Number(item.final_price ?? item.discounted_price ?? item.price ?? 0);
      return {
        id: String(item.variant_id || item.id || ''),
        name: item.product_title || item.title || 'Dopamine Flowers item',
        content_type: 'product',
        quantity,
        amount: Math.round(unitAmount),
        currency
      };
    });
    const amount = items.reduce((sum, item) => {
      const quantity = Math.max(1, Number(item.quantity || 1));
      const lineAmount = item.final_line_price ?? item.original_line_price;
      const unitAmount = item.final_price ?? item.discounted_price ?? item.price ?? 0;
      return sum + Number(lineAmount ?? (Number(unitAmount) * quantity));
    }, 0);
    measureOpenAIPixel('items_added', { type: 'contents', amount: Math.round(amount), currency, contents });
  };

  let checkoutStartedMeasured = false;
  const measureCheckoutStarted = () => {
    if (checkoutStartedMeasured) return;
    checkoutStartedMeasured = true;
    measureOpenAIPixel('checkout_started', { type: 'contents' });
  };

  const money = (cents) => {
    const amount = (Number(cents || 0) / 100);
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format(amount); }
    catch(e) { return '$' + amount.toFixed(2); }
  };

  // "$20" rather than "$20.00" for round amounts (thresholds and flat fees in copy).
  const moneyWhole = (cents) => {
    const amount = (Number(cents || 0) / 100);
    const digits = Number.isInteger(amount) ? 0 : 2;
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency, minimumFractionDigits: digits, maximumFractionDigits: digits }).format(amount); }
    catch(e) { return '$' + amount.toFixed(digits); }
  };

  // Theme settings > Delivery, printed by layout/theme.liquid as window.DF_DELIVERY.
  const deliverySetting = (key, fallback) => {
    const value = Number((window.DF_DELIVERY || {})[key]);
    return Number.isFinite(value) && value >= 0 ? value : fallback;
  };

  const updateFreeDeliveryMeter = (meter, currentSubtotal) => {
    if (!meter) return;
    const threshold = Math.max(1, Number(meter.dataset.threshold || deliverySetting('freeThreshold', 0)));
    const current = Math.max(0, Number(currentSubtotal ?? meter.dataset.currentSubtotal ?? 0));
    const remaining = Math.max(0, threshold - current);
    const progress = Math.min(100, (current / threshold) * 100);
    const unlocked = remaining <= 0;
    meter.classList.toggle('is-unlocked', unlocked);
    const message = meter.querySelector('[data-free-delivery-message]');
    const detail = meter.querySelector('[data-free-delivery-detail]');
    const icon = meter.querySelector('.free-delivery-meter__icon');
    const fill = meter.querySelector('[data-free-delivery-fill]');
    const progressbar = meter.querySelector('[role="progressbar"]');
    const action = meter.querySelector('[data-cart-open-addons]');
    if (message) message.textContent = unlocked ? 'Free Oahu delivery unlocked' : `Only ${money(remaining)} away from free Oahu delivery`;
    if (detail) {
      detail.hidden = unlocked;
      detail.textContent = unlocked ? '' : (meter.classList.contains('free-delivery-meter--modal') ? `Selected extras count toward the ${moneyWhole(threshold)} goal.` : 'A small extra can get this order over the line.');
    }
    if (icon) icon.textContent = unlocked ? '\u2713' : '\u2192';
    if (fill) fill.style.width = `${progress}%`;
    if (progressbar) progressbar.setAttribute('aria-valuenow', String(Math.round(Math.min(current, threshold) / 100)));
    if (action) action.hidden = unlocked;
  };

  const postJSON = async (url, payload) => {
    const res = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(payload) });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
  };

  const getCart = async () => fetch(root + 'cart.js', { headers: { 'Accept':'application/json' } }).then(r => r.json());

  let addonScrollY = 0;
  // A new value on <html> restyles the whole page: write only what changed.
  const appViewportVars = {};
  const setAppViewportVar = (name, value) => {
    if (appViewportVars[name] === value) return;
    appViewportVars[name] = value;
    document.documentElement.style.setProperty(name, value);
  };
  const setAppHeight = () => {
    const viewport = window.visualViewport;
    // Do not turn a deliberate pinch-zoom into a responsive layout change.
    if (viewport && viewport.scale > 1.05) return;
    const height = viewport ? viewport.height : window.innerHeight;
    if (height) setAppViewportVar('--df-app-height', `${Math.round(height)}px`);
    const keyboardOpen = viewport && window.innerHeight - height > 120;
    // Some Safari versions retain a stale offset after dismissing the keyboard.
    setAppViewportVar('--df-viewport-top', `${keyboardOpen ? Math.max(0, Math.round(viewport.offsetTop)) : 0}px`);
  };
  setAppHeight();
  // Only sheets and builders use these values, and each measures again when it opens. While the
  // keyboard is up for a field on the page itself (the cart's gift card, the florist note) the
  // page is left alone: restyling it on every keyboard frame made the cart judder on iPhones
  // (owner, 2026-10-14: "the whole screen shook").
  const typingInPage = () => {
    const active = document.activeElement;
    return Boolean(active && active.matches && active.matches('input, textarea, select, [contenteditable="true"]')
      && !active.closest('[role="dialog"], [data-addon-modal], .balloon-builder, .vase-builder, .plush-picker, .menu-drawer'));
  };
  const scheduleAppHeight = rafThrottle(() => { if (!typingInPage()) setAppHeight(); });
  window.addEventListener('resize', scheduleAppHeight, { passive: true });
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', scheduleAppHeight, { passive: true });
    window.visualViewport.addEventListener('scroll', scheduleAppHeight, { passive: true });
  }

  const lockPageScroll = () => {
    if (document.body.dataset.dfAddonScrollLocked === 'true') return;
    addonScrollY = window.scrollY || document.documentElement.scrollTop || 0;
    document.body.dataset.dfAddonScrollLocked = 'true';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${addonScrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
    document.documentElement.classList.add('df-addon-modal-open');
    document.body.classList.add('df-addon-modal-open');
  };

  const unlockPageScroll = () => {
    // A configurator may have been opened on top of the add-ons dialog.
    if (document.querySelector('.addon-modal:not([hidden]), .balloon-builder:not([hidden]), .vase-builder:not([hidden]), .plush-picker:not([hidden])')) return;
    if (document.body.dataset.dfAddonScrollLocked !== 'true') return;
    const y = Math.abs(parseInt(document.body.style.top || '0', 10)) || addonScrollY || 0;
    delete document.body.dataset.dfAddonScrollLocked;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    document.documentElement.classList.remove('df-addon-modal-open');
    document.body.classList.remove('df-addon-modal-open');
    window.scrollTo(0, y);
  };

  // Shared modal keyboard behaviour (first written for the vase builder): focus moves into
  // the dialog, Tab / Shift+Tab stay inside it, Escape closes it, and focus goes back to the
  // control that opened it.
  const dialogFocusableSelector = 'a[href], button:not([disabled]), textarea:not([disabled]), select:not([disabled]), input:not([disabled]):not([type="hidden"]), [tabindex]:not([tabindex="-1"])';
  const dialogFocusable = (container) => Array.from(container.querySelectorAll(dialogFocusableSelector))
    .filter(element => !element.hidden && element.getClientRects().length);
  const trapDialogKeydown = (event, container, close) => {
    if (event.key === 'Escape') {
      event.preventDefault();
      close();
      return;
    }
    if (event.key !== 'Tab') return;
    const focusable = dialogFocusable(container);
    if (!focusable.length) {
      event.preventDefault();
      return;
    }
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const current = document.activeElement;
    const inside = focusable.includes(current);
    if (event.shiftKey && (current === first || !inside)) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && (current === last || !inside)) { event.preventDefault(); first.focus(); }
  };
  const focusDialog = (dialog, preferred) => {
    if (!dialog) return;
    if (!dialog.hasAttribute('tabindex')) dialog.setAttribute('tabindex', '-1');
    const target = preferred && preferred.getClientRects().length ? preferred : dialog;
    target.focus({ preventScroll: true });
  };
  const restoreDialogFocus = (element) => {
    if (element && element.isConnected && typeof element.focus === 'function') element.focus({ preventScroll: true });
  };

  const isExactFeeItem = (item) => {
    const handle = String(item.handle || item.product_handle || '').toLowerCase();
    const title = String(item.product_title || item.title || '').toLowerCase();
    return handle.includes(feeHandleNeedle) || title.includes('exact delivery window fee') || title.includes('delivery / pickup time window');
  };

  const isBalloonUpgradeItem = (item) => {
    const handle = String(item?.handle || item?.product_handle || '').toLowerCase();
    const title = String(item?.product_title || item?.title || '').toLowerCase();
    return handle.includes(balloonUpgradeHandleNeedle) || title.includes('premium balloon design');
  };

  const isExactWindowValue = (value) => {
    const normalized = String(value || '').toLowerCase().replace(/[–—−]/g, '-');
    if (!normalized || normalized.includes('standard') || /12\s*pm\s*(?:-|to)\s*7\s*pm/.test(normalized)) return false;
    return /exact/.test(normalized) || /(?:9\s*am\s*-\s*12\s*pm|12\s*pm\s*-\s*3\s*pm|3\s*pm\s*-\s*(?:5|6)\s*pm|5\s*pm\s*-\s*7\s*pm|6\s*pm\s*-\s*9\s*pm)/.test(normalized);
  };

  const itemTimeWindow = (item) => {
    const properties = item?.properties || {};
    return properties['Delivery / pickup window'] || properties['delivery / pickup window'] || properties['Delivery window'] || properties['delivery window'] || '';
  };

  const itemNeedsExactFee = (item) => {
    if (!item || isExactFeeItem(item)) return false;
    return isExactWindowValue(itemTimeWindow(item));
  };

  const displayCartCount = (cart) => {
    if (!cart || !Array.isArray(cart.items)) return 0;
    return cart.items.reduce((sum, item) => (isExactFeeItem(item) || isBalloonUpgradeItem(item)) ? sum : sum + Number(item.quantity || 0), 0);
  };

  const refreshCartCount = async () => {
    try {
      const cart = await getCart();
      const count = displayCartCount(cart);
      document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = count; });
      return cart;
    } catch(e) { return null; }
  };





  const initRevealProducts = () => {
    document.querySelectorAll('[data-reveal-products]').forEach(button => {
      button.addEventListener('click', () => {
        const section = button.closest('[data-featured-products]');
        if (!section) return;
        section.querySelectorAll('[data-reveal-item]').forEach(item => {
          item.hidden = false;
          item.classList.remove('is-hidden-product');
          item.classList.add('is-revealed-product');
        });
        if (button.dataset.revealedLabel) button.textContent = button.dataset.revealedLabel;
        button.disabled = true;
        button.classList.add('is-revealed');
      });
    });
  };

  const initProductCardMedia = () => {
    const hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const motionAllowed = !document.body.classList.contains('df-card-motion-off') && hoverCapable.matches && !reducedMotion.matches;

    document.querySelectorAll('.product-card__media').forEach(media => {
      if (media.dataset.mediaCycleInitialized === 'true') return;
      let images = Array.from(media.querySelectorAll('.product-card__image'));
      const imageTemplates = Array.from(media.querySelectorAll('[data-product-card-image-template]'));
      const segments = Array.from(media.querySelectorAll('.product-card__media-segment'));
      if (images.length + imageTemplates.length < 2) return;
      media.dataset.mediaCycleInitialized = 'true';

      let activeIndex = 0;
      let timerId = null;

      const showImage = nextIndex => {
        activeIndex = nextIndex;
        images.forEach((image, index) => image.classList.toggle('is-active', index === activeIndex));
        segments.forEach((segment, index) => {
          segment.classList.toggle('is-active', index === activeIndex);
          segment.classList.toggle('is-past', index < activeIndex);
        });
      };

      const hydrateImages = () => {
        imageTemplates.splice(0).forEach((template) => template.replaceWith(template.content.cloneNode(true)));
        images = Array.from(media.querySelectorAll('.product-card__image'));
      };

      showImage(0);
      if (!motionAllowed) return;

      const stopCycle = (reset = true) => {
        if (timerId !== null) window.clearInterval(timerId);
        timerId = null;
        media.classList.remove('is-cycling');
        if (reset) showImage(0);
      };

      const startCycle = () => {
        hydrateImages();
        stopCycle(false);
        showImage(0);
        void media.offsetWidth;
        media.classList.add('is-cycling');
        timerId = window.setInterval(() => {
          showImage((activeIndex + 1) % images.length);
        }, 2000);
      };

      media.addEventListener('pointerenter', startCycle);
      media.addEventListener('pointerleave', () => stopCycle(true));
      media.addEventListener('focusin', startCycle);
      media.addEventListener('focusout', event => {
        if (!media.contains(event.relatedTarget)) stopCycle(true);
      });
    });
  };

  const initMenuDrawer = () => {
    const drawer = document.querySelector('[data-menu-drawer]');
    if (!drawer || drawer.dataset.drawerInitialized === 'true') return;
    drawer.dataset.drawerInitialized = 'true';
    const openers = document.querySelectorAll('[data-drawer-open]');
    const closers = drawer.querySelectorAll('[data-drawer-close]');
    const panel = drawer.querySelector('.menu-drawer__panel');
    let returnFocus = null;
    const open = event => {
      if (event) event.preventDefault();
      returnFocus = event && event.currentTarget ? event.currentTarget : document.activeElement;
      drawer.hidden = false;
      drawer.setAttribute('aria-hidden', 'false');
      drawer.classList.add('is-open');
      document.documentElement.classList.add('menu-drawer-open');
      document.body.classList.add('menu-drawer-open');
      openers.forEach(button => button.setAttribute('aria-expanded', 'true'));
      window.requestAnimationFrame(() => panel?.focus({ preventScroll: true }));
    };
    const close = () => {
      drawer.classList.remove('is-open');
      drawer.hidden = true;
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('menu-drawer-open');
      document.body.classList.remove('menu-drawer-open');
      openers.forEach(button => button.setAttribute('aria-expanded', 'false'));
      if (returnFocus && typeof returnFocus.focus === 'function') returnFocus.focus({ preventScroll: true });
    };
    openers.forEach(button => button.addEventListener('click', open));
    closers.forEach(button => button.addEventListener('click', close));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !drawer.hidden) close();
    });
    // iOS Safari: with the keyboard up the fixed drawer can slide under the
    // browser chrome. Pin it to the visual viewport instead of the layout one.
    const viewport = window.visualViewport;
    if (viewport) {
      const pinToViewport = () => {
        if (drawer.hidden) {
          drawer.style.top = '';
          drawer.style.height = '';
          return;
        }
        drawer.style.top = `${Math.max(0, viewport.offsetTop)}px`;
        drawer.style.height = `${viewport.height}px`;
      };
      viewport.addEventListener('resize', pinToViewport, { passive: true });
      viewport.addEventListener('scroll', pinToViewport, { passive: true });
      drawer.addEventListener('transitionend', pinToViewport);
      openers.forEach(button => button.addEventListener('click', () => window.requestAnimationFrame(pinToViewport)));
    }
    // Only once the header shows the full menu (wider than 1120 px, dopamine.css): a tablet in
    // landscape (1024–1080 px) still uses this drawer, and Safari's bars moving or the tablet
    // turning closed it under the florist's finger.
    window.addEventListener('resize', rafThrottle(() => {
      if (window.matchMedia('(min-width: 1121px)').matches && !drawer.hidden) close();
    }), { passive: true });
  };

  // A tablet in landscape gets the full menu, whose lists (Occasions, Weddings, Sympathy,
  // Locations) open on hover, and a finger has no hover: on a touch screen the first tap opens the
  // list, a tap on the open heading goes to its page, a tap anywhere else closes it.
  const initNavTouch = () => {
    const items = Array.from(document.querySelectorAll('.site-nav__item--has-menu'));
    if (!items.length || typeof window.matchMedia !== 'function') return;
    const touch = window.matchMedia('(hover: none)');
    const closeOthers = (keep) => items.forEach(item => {
      if (item === keep) return;
      item.classList.remove('is-open');
      item.querySelector('.site-nav__trigger')?.setAttribute('aria-expanded', 'false');
    });
    items.forEach(item => {
      const trigger = item.querySelector('.site-nav__trigger');
      const list = item.querySelector('.site-nav__dropdown');
      if (!trigger || !list) return;
      trigger.addEventListener('click', event => {
        if (!touch.matches) return;
        // Already showing (opened by the last tap, or by Safari's own first-tap hover): go.
        if (item.classList.contains('is-open') || parseFloat(window.getComputedStyle(list).opacity) > 0.5) return;
        event.preventDefault();
        closeOthers(item);
        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      });
    });
    document.addEventListener('click', event => {
      if (!event.target.closest || !event.target.closest('.site-nav__item--has-menu')) closeOthers(null);
    });
  };

  const initFloatingHeader = () => {
    const header = document.querySelector('[data-site-header]');
    if (!header) return;
    const section = header.parentElement;
    let ticking = false;
    let isFloating = header.classList.contains('is-floating');
    let switchAt = 0;
    const measure = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop || 0;
      const announcementHeight = section?.querySelector('.announcement')?.getBoundingClientRect().height || 0;
      const naturalTop = section
        ? section.getBoundingClientRect().top + scrollTop + announcementHeight
        : header.getBoundingClientRect().top + scrollTop;
      const floatingTop = window.matchMedia('(max-width: 760px)').matches ? 8 : 10;
      switchAt = Math.max(0, naturalTop - floatingTop);
      if (section) {
        const headerHeight = header.getBoundingClientRect().height;
        // The capsule adds a top border; reserve the flow height, including
        // fractional announcement pixels, so pinning never moves the content.
        const capsuleBorder = isFloating ? parseFloat(window.getComputedStyle(header).borderTopWidth) || 0 : 0;
        const sectionHeight = announcementHeight + headerHeight - capsuleBorder;
        section.style.setProperty('--site-header-section-height', `${sectionHeight}px`);
      }
    };
    const update = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop || 0;
      const shouldFloat = isFloating ? scrollTop > switchAt - 2 : scrollTop > switchAt + 2;
      if (shouldFloat !== isFloating) {
        isFloating = shouldFloat;
        header.classList.toggle('is-floating', isFloating);
        section?.classList.toggle('has-floating-site-header', isFloating);
      }
      ticking = false;
    };
    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    };
    measure();
    update();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', rafThrottle(() => {
      measure();
      requestUpdate();
    }), { passive: true });
  };

  const selectedVariantIdForCard = (card) => {
    if (card && card._balloonItem) return card._balloonItem.id;
    if (card && card._vaseItem) return card._vaseItem.id;
    if (card && card._plushItems?.length) return card._plushItems[0].id;
    const input = card.querySelector('[data-addon-variant]:checked') || card.querySelector('input[type="hidden"][data-addon-variant]');
    return input ? input.value : null;
  };

  const selectedVariantPriceForCard = (card) => {
    if (card && card._balloonItem) return Number(card._balloonItem.price || 0);
    if (card && card._vaseItem) return Number(card._vaseItem.price || 0);
    if (card && card._plushItems?.length) return Number(card._plushTotal || 0);
    const input = card.querySelector('[data-addon-variant]:checked') || card.querySelector('input[type="hidden"][data-addon-variant]');
    return Number(input ? input.dataset.price : 0);
  };

  const syncAddonVariantCard = (card, input) => {
    if (!card || !input) return;
    const priceEl = card.querySelector('[data-addon-price]');
    if (priceEl) priceEl.textContent = money(input.dataset.price || 0);
    const imageUrl = input.dataset.imageUrl || '';
    if (!imageUrl) return;
    const media = card.querySelector('[data-addon-media]');
    if (!media) return;
    let image = media.querySelector('[data-addon-image], img');
    if (!image) {
      image = document.createElement('img');
      image.dataset.addonImage = '';
      image.loading = 'lazy';
      media.replaceChildren(image);
    }
    // Shopify's image_tag emits a responsive srcset. Updating only `src` leaves
    // the browser free to keep rendering the old candidate from that srcset,
    // which made different add-on variants look like they shared one photo.
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.src = imageUrl;
    image.alt = input.dataset.imageAlt || card.querySelector('h3')?.textContent || 'Add-on';
  };

  const transactionalSmsConsentBlocks = () => Array.from(document.querySelectorAll('[data-transactional-sms-consent]'));
  let transactionalSmsConsentDeclined = false;

  const clearTransactionalSmsConsentChoice = (block) => {
    if (!block) return;
    const checkbox = block.querySelector('[data-transactional-sms-consent-checkbox]');
    const choice = block.querySelector('[data-consent-choice]');
    block.classList.remove('has-choice-error');
    if (checkbox) checkbox.removeAttribute('aria-invalid');
    if (block.dataset.consentUpfront === 'true') {
      // Up-front mode keeps the Yes / No buttons visible and only hides the error line.
      const error = block.querySelector('[data-consent-choice-error]');
      if (error) error.hidden = true;
    } else if (choice) {
      choice.hidden = true;
    }
  };

  const markTransactionalSmsConsentButtons = () => {
    transactionalSmsConsentBlocks().forEach(block => {
      const checkbox = block.querySelector('[data-transactional-sms-consent-checkbox]');
      const accept = block.querySelector('[data-consent-accept]');
      const decline = block.querySelector('[data-consent-decline]');
      const accepted = Boolean(checkbox && checkbox.checked);
      if (accept) accept.setAttribute('aria-pressed', accepted ? 'true' : 'false');
      if (decline && block.dataset.consentUpfront === 'true') decline.setAttribute('aria-pressed', !accepted && transactionalSmsConsentDeclined ? 'true' : 'false');
    });
  };

  const syncTransactionalSmsConsentBlock = (block, checked) => {
    const checkbox = block.querySelector('[data-transactional-sms-consent-checkbox]');
    const hidden = block.querySelector('[data-transactional-sms-consent-hidden]');
    if (checkbox) checkbox.checked = checked;
    if (hidden) hidden.disabled = checked;
    if (checked) clearTransactionalSmsConsentChoice(block);
  };

  const syncTransactionalSmsConsent = (checked) => {
    transactionalSmsConsentBlocks().forEach(block => syncTransactionalSmsConsentBlock(block, checked));
    markTransactionalSmsConsentButtons();
  };

  const initTransactionalSmsConsent = () => {
    const blocks = transactionalSmsConsentBlocks();
    if (!blocks.length) return;
    // Ticked from the start (owner, 2026-10-12); the page says unticked when this customer
    // unticked it before (snippets/transactional-sms-consent.liquid).
    const first = blocks[0].querySelector('[data-transactional-sms-consent-checkbox]');
    syncTransactionalSmsConsent(first ? first.checked : true);
    blocks.forEach(block => {
      const checkbox = block.querySelector('[data-transactional-sms-consent-checkbox]');
      if (!checkbox) return;
      checkbox.addEventListener('change', () => {
        transactionalSmsConsentDeclined = false;
        syncTransactionalSmsConsent(checkbox.checked);
      });
      const accept = block.querySelector('[data-consent-accept]');
      if (accept) {
        // The customer's own tap is the affirmative opt-in; nothing is ever pre-checked.
        accept.addEventListener('click', () => {
          transactionalSmsConsentDeclined = false;
          syncTransactionalSmsConsent(true);
        });
      }
      const decline = block.querySelector('[data-consent-decline]');
      if (decline) {
        decline.addEventListener('click', () => {
          const upfront = block.dataset.consentUpfront === 'true';
          const afterFailedCheckout = block.classList.contains('has-choice-error');
          transactionalSmsConsentDeclined = true;
          syncTransactionalSmsConsent(false);
          clearTransactionalSmsConsentChoice(block);
          // Up front this is just an answer. Only continue to checkout automatically
          // when the customer had already pressed Checkout and was waiting on this.
          if (upfront && !afterFailedCheckout) return;
          const checkoutButton = document.querySelector('[data-cart-section] button[name="checkout"]');
          if (checkoutButton) checkoutButton.click();
        });
      }
    });
  };

  // Ticked means texts, unticked means none: nothing to ask before checkout any more.
  const validateTransactionalSmsConsentChoice = () => {
    clearTransactionalSmsConsentChoice(transactionalSmsConsentBlocks()[0]);
    return true;
  };

  // Run every check in one pass so the customer sees everything that is missing
  // at once, instead of fixing one error only to be stopped by the next. Then one smooth scroll
  // to the first problem: the checks no longer scroll and focus on their own (up to four scrolls
  // and an iPhone keyboard used to pull the page about at once). A text field is not focused on a
  // phone: that would raise the keyboard and move the page again.
  const validateCartForCheckout = (form) => {
    const results = [
      [validateRecipientForCheckout(form), form.querySelector('[aria-invalid="true"]')],
      [validateDeliveryDateForCheckout(form), form.querySelector('[data-date-picker]')],
      [validateScheduleForCheckout(form), form.querySelector('[data-cart-schedule]')],
      [validateCustomVasePairingForCheckout(form), form.querySelector('[data-vase-cart-error]')],
      [validateTransactionalSmsConsentChoice(), transactionalSmsConsentBlocks()[0]]
    ];
    const firstFailure = results.find(result => !result[0]);
    if (!firstFailure) return true;
    const target = firstFailure[1];
    if (target && target.scrollIntoView) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    const control = !target || !target.matches ? null
      : target.matches('[data-date-picker]') ? target.querySelector('[data-date-picker-toggle]')
        : target.matches('[data-cart-schedule]') ? chosenCartWindow(form)
          : target.matches('input, textarea, select, button') ? target : null;
    const typing = control && control.matches('input[type="text"], input:not([type]), textarea');
    const phone = Boolean(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
    if (control && control.focus && !(typing && phone)) control.focus({ preventScroll: true });
    return false;
  };

  const saveTransactionalSmsConsent = async () => {
    const block = transactionalSmsConsentBlocks()[0];
    if (!block) return;
    const checkbox = block.querySelector('[data-transactional-sms-consent-checkbox]');
    const checked = Boolean(checkbox && checkbox.checked);
    const consentValue = block.dataset.consentValue || 'Yes';
    const noValue = block.dataset.consentNoValue || 'No';
    await postJSON(root + 'cart/update.js', {
      attributes: {
        'Transactional SMS consent': checked ? consentValue : noValue
      }
    });
  };

  // A balloon's price in cents for balloons 1–3, 4–6 and 7–10 of a set: the staff app's Balloon
  // picker keeps them in the product metafield dopamine.balloon_pricing (snippets/balloon-builder.liquid
  // passes them on as data.pricing); these are the prices the shop always had.
  const BALLOON_UNIT_CENTS = [1200, 1080, 960];
  const balloonUnitCents = (data) => {
    const list = data && data.pricing && data.pricing.unitCents;
    return Array.isArray(list) && list.length === 3 && list.every(cents => Number(cents) >= 50) ? list.map(Number) : BALLOON_UNIT_CENTS;
  };
  const balloonUnitText = cents => `$${(Number(cents) / 100).toFixed(2).replace(/\.00$/, '')}`;

  const balloonPriceForCount = (count, units = BALLOON_UNIT_CENTS) => {
    const quantity = Math.max(0, Math.min(10, Number(count) || 0));
    if (!quantity) return 0;
    const fullPriceCount = Math.min(quantity, 3);
    const tenPercentCount = Math.min(Math.max(0, quantity - 3), 3);
    const twentyPercentCount = Math.max(0, quantity - 6);
    return (fullPriceCount * units[0]) + (tenPercentCount * units[1]) + (twentyPercentCount * units[2]);
  };

  const balloonVariantForCount = (variants, count) => {
    const matcher = new RegExp(`^${Number(count)}\\s+balloons?`, 'i');
    return (variants || []).find(variant => matcher.test(String(variant.title || ''))) || null;
  };

  const balloonSummary = (selected) => {
    const counts = new Map();
    selected.forEach(design => {
      const current = counts.get(design.key) || { name: design.name, count: 0 };
      current.count += 1;
      counts.set(design.key, current);
    });
    return Array.from(counts.values()).map(item => `${item.count}× ${item.name}`).join(' · ');
  };

  const balloonCartItem = (data, selected) => {
    const count = selected.length;
    const variant = balloonVariantForCount(data.variants, count);
    if (!variant) return null;
    const upgradeVariants = new Map((data.upgradeVariants || []).map(option => [Number(option.cents || 0), Number(option.id || 0)]));
    const premiumGroups = new Map();
    for (const design of selected) {
      const cents = Math.max(0, Number(design.surchargeCents || 0));
      if (!cents) continue;
      const variantId = upgradeVariants.get(cents);
      if (!variantId) return null;
      const group = premiumGroups.get(cents) || { variantId, designs: [] };
      group.designs.push(design);
      premiumGroups.set(cents, group);
    }
    const groupId = `balloons-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
    const properties = {
      'Balloon count': String(count),
      'Balloon set': balloonSummary(selected),
      '_Balloon design keys': selected.map(design => design.key).join('|'),
      '_Balloon group': groupId
    };
    selected.forEach((design, index) => {
      properties[`_Balloon image ${index + 1}`] = design.image;
      properties[`_Balloon name ${index + 1}`] = design.name;
    });
    const premiumTotal = selected.reduce((sum, design) => sum + Math.max(0, Number(design.surchargeCents || 0)), 0);
    const upgradeItems = Array.from(premiumGroups.entries()).map(([cents, group]) => ({
      id: group.variantId,
      quantity: group.designs.length,
      properties: {
        'For balloon design': balloonSummary(group.designs),
        '_Balloon group': groupId,
        '_Balloon design charge': money(cents),
        '_Balloon units per set': String(group.designs.length)
      }
    }));
    properties['_Balloon upgrades'] = JSON.stringify(upgradeItems.map(upgrade => ({
      id: upgrade.id,
      quantity: upgrade.quantity,
      design: upgrade.properties['For balloon design'],
      charge: upgrade.properties['_Balloon design charge']
    })));
    return {
      id: Number(variant.id),
      quantity: 1,
      price: Number(variant.price || balloonPriceForCount(count, balloonUnitCents(data))) + premiumTotal,
      count,
      selected: selected.map(design => ({ ...design })),
      properties,
      upgradeItems
    };
  };

  const balloonCartItems = (item, quantity = 1) => {
    if (!item?.id) return [];
    const setQuantity = Math.max(1, Number.parseInt(quantity, 10) || 1);
    return [
      { id: Number(item.id), quantity: setQuantity, properties: item.properties || {} },
      ...(item.upgradeItems || []).map(upgrade => ({
        id: Number(upgrade.id),
        quantity: Math.max(1, Number(upgrade.quantity || 1)) * setQuantity,
        properties: upgrade.properties || {}
      }))
    ].filter(cartItem => cartItem.id);
  };

  // Gift tiles on flower pages (balloons, plush friends, custom box): the whole tile is the
  // button. Once something is chosen the meta line shows it with the price, the art shows
  // what was picked and the call to action turns into "Edit"; clearing restores the tile.
  const setGiftTileShowcase = (source, items) => {
    if (!source.classList.contains('gift-tile--showcase')) return;
    const art = source.querySelector('[data-gift-tile-art]');
    if (art?.querySelector('[data-gift-showcase]')) {
      source._giftTileArt = art.innerHTML;
      return;
    }
    const featured = items.filter(item => item.image).slice(0, 3);
    if (!art || !featured.length) return;
    const stage = document.createElement('span');
    stage.className = 'gift-tile__showcase';
    stage.dataset.count = String(featured.length);
    featured.forEach(item => {
      const sample = document.createElement('span');
      sample.className = 'gift-tile__sample';
      const image = document.createElement('img');
      image.src = item.image;
      image.alt = '';
      image.width = 240;
      image.height = 240;
      image.loading = 'lazy';
      image.decoding = 'async';
      sample.appendChild(image);
      stage.appendChild(sample);
    });
    art.replaceChildren(stage);
    source._giftTileArt = art.innerHTML;
  };

  // The add-ons popup's balloon and plush cards show the same pictures as the product page's gift
  // tiles (owner, 2026-10-14: "on balloons and toys there are some crappy old pictures").
  const setAddonCardShowcase = (source, items) => {
    const card = source.closest('[data-addon-card]');
    const media = card && card.querySelector('[data-addon-media]');
    if (media?.querySelector('[data-gift-showcase]')) {
      card.classList.add('has-showcase');
      return;
    }
    const featured = items.filter(item => item.image).slice(0, 3);
    if (!media || !featured.length) return;
    const stage = document.createElement('span');
    stage.className = 'gift-tile__showcase addon-card__showcase';
    stage.dataset.count = String(featured.length);
    featured.forEach(item => {
      const sample = document.createElement('span');
      sample.className = 'gift-tile__sample';
      const image = document.createElement('img');
      image.src = item.image;
      image.alt = '';
      image.width = 240;
      image.height = 240;
      image.loading = 'lazy';
      image.decoding = 'async';
      sample.appendChild(image);
      stage.appendChild(sample);
    });
    media.replaceChildren(stage);
    card.classList.add('has-showcase');
  };

  const setGiftTile = (source, { meta = null, picked = false, images = [] } = {}) => {
    if (!source || !source.classList.contains('gift-tile')) return false;
    const metaEl = source.querySelector('[data-gift-tile-meta]');
    const ctaEl = source.querySelector('[data-gift-tile-cta]');
    const art = source.querySelector('[data-gift-tile-art]');
    if (metaEl) {
      if (metaEl.dataset.giftTileDefault == null) metaEl.dataset.giftTileDefault = metaEl.textContent;
      metaEl.textContent = picked && meta ? meta : metaEl.dataset.giftTileDefault;
    }
    if (ctaEl) {
      if (ctaEl.dataset.giftTileDefault == null) ctaEl.dataset.giftTileDefault = ctaEl.textContent;
      ctaEl.textContent = picked ? (source.dataset.giftTileEdit || 'Edit') : ctaEl.dataset.giftTileDefault;
    }
    if (art) {
      if (source._giftTileArt == null) source._giftTileArt = art.innerHTML;
      const shown = picked ? images.filter(Boolean).slice(0, 3) : [];
      if (shown.length) {
        art.replaceChildren(...shown.map((src, index) => {
          const image = document.createElement('img');
          image.src = src;
          image.alt = '';
          image.className = 'gift-tile__pick';
          image.style.setProperty('--pick-index', String(index));
          image.style.setProperty('--pick-count', String(shown.length));
          return image;
        }));
      } else {
        art.innerHTML = source._giftTileArt;
      }
    }
    source.classList.toggle('is-picked', Boolean(picked));
    return true;
  };

  const applyBalloonItemToSource = (source, item) => {
    source._balloonItem = item;
    const button = source.querySelector('[data-balloon-configure]');
    const onTile = setGiftTile(source, { meta: `${item.count} balloons · ${money(item.price)}`, picked: true, images: item.selected.map(design => design.image) });
    if (!onTile && button) {
      if (!button.dataset.balloonOriginalLabel) button.dataset.balloonOriginalLabel = button.textContent.trim();
      // The add-ons popup's row already shows the set's price beside its name, and its button
      // column is narrow: "Edit set · $51.00" ran past the pill's edges (audit 2026-10-25).
      button.textContent = source.dataset.balloonContext === 'addon-modal' ? 'Edit set' : `Edit balloons · ${money(item.price)}`;
    }
    const card = source.closest('[data-addon-card]');
    if (card) {
      card._balloonItem = item;
      card.classList.add('is-picked');
      const price = card.querySelector('[data-addon-price]');
      if (price) {
        if (!price.dataset.balloonOriginalPrice) price.dataset.balloonOriginalPrice = price.textContent.trim();
        price.textContent = money(item.price);
      }
      const media = card.querySelector('[data-addon-media]');
      if (media) {
        if (card._balloonOriginalMedia == null) card._balloonOriginalMedia = media.innerHTML;
        media.innerHTML = '';
        item.selected.slice(0, 3).forEach((design, index) => {
          const image = document.createElement('img');
          image.src = design.image;
          image.alt = design.name;
          image.className = 'addon-card__balloon-preview';
          image.style.setProperty('--preview-index', String(index));
          media.appendChild(image);
        });
      }
      card.closest('[data-addon-modal]')?.dispatchEvent(new CustomEvent('balloon:configured'));
    }
    source.dispatchEvent(new CustomEvent('balloon:configured', { bubbles: true, detail: item }));
  };

  const clearBalloonItemFromSource = (source) => {
    source._balloonItem = null;
    const button = source.querySelector('[data-balloon-configure]');
    if (!setGiftTile(source, { picked: false }) && button?.dataset.balloonOriginalLabel) button.textContent = button.dataset.balloonOriginalLabel;
    const card = source.closest('[data-addon-card]');
    if (card) {
      card._balloonItem = null;
      card.classList.remove('is-picked');
      const price = card.querySelector('[data-addon-price]');
      if (price?.dataset.balloonOriginalPrice) price.textContent = price.dataset.balloonOriginalPrice;
      const media = card.querySelector('[data-addon-media]');
      if (media && card._balloonOriginalMedia != null) media.innerHTML = card._balloonOriginalMedia;
      card.closest('[data-addon-modal]')?.dispatchEvent(new CustomEvent('balloon:configured'));
    }
    source.dispatchEvent(new CustomEvent('balloon:configured', { bubbles: true, detail: null }));
  };

  const syncBalloonItemAcrossSources = (source, data, item) => {
    document.querySelectorAll('[data-balloon-builder-source]').forEach(otherSource => {
      const otherJSON = otherSource.querySelector('[data-balloon-builder-json]');
      if (!otherJSON) return;
      try {
        const otherData = JSON.parse(otherJSON.textContent);
        if (String(otherData.productId) === String(data.productId)) applyBalloonItemToSource(otherSource, item);
      } catch(e) {
        console.warn('Dopamine balloon source could not be synchronized', e);
      }
    });
    if (!source._balloonItem) applyBalloonItemToSource(source, item);
  };

  // Tablets and small laptops: the balloon set is drawn in a 510 × 470 px box (the top balloon rises
  // 279 px above the box's middle, the strings end 212 px below it, the side balloons reach about
  // 274 px to either side) and shrunk as one picture to fit the bouquet panel it sits in, never
  // enlarged. When the panel is short the picture also moves down just enough that the top
  // balloon stays inside (computers with room keep it where it was). Phones keep their own layout.
  // Where the picture really is inside a balloon photo (the design photos keep transparent margins):
  // the ribbon's end must sit exactly where its string starts. Measured once per picture.
  const balloonArtBoxes = new Map();
  const measureBalloonArt = (src) => {
    if (balloonArtBoxes.has(src)) return balloonArtBoxes.get(src);
    const job = new Promise((resolve) => {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => {
        try {
          const size = 96;
          const k = size / Math.max(img.naturalWidth, img.naturalHeight);
          const w = Math.max(1, Math.round(img.naturalWidth * k));
          const h = Math.max(1, Math.round(img.naturalHeight * k));
          const canvas = document.createElement('canvas');
          canvas.width = w; canvas.height = h;
          const g = canvas.getContext('2d');
          g.drawImage(img, 0, 0, w, h);
          const px = g.getImageData(0, 0, w, h).data;
          let x0 = w, y0 = h, x1 = -1, y1 = -1;
          for (let y = 0; y < h; y += 1) for (let x = 0; x < w; x += 1) {
            if (px[(y * w + x) * 4 + 3] > 16) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
          }
          if (x1 < 0) return resolve(null);
          resolve({ left: x0 / w, top: y0 / h, width: (x1 - x0 + 1) / w, height: (y1 - y0 + 1) / h, aspect: ((x1 - x0 + 1) / w * img.naturalWidth) / ((y1 - y0 + 1) / h * img.naturalHeight) });
        } catch (e) {
          resolve(null);
        }
      };
      img.onerror = () => resolve(null);
      img.src = src;
    });
    balloonArtBoxes.set(src, job);
    return job;
  };
  const applyBalloonArt = (node, box) => {
    if (!node || !box) return;
    node.style.setProperty('--art-aspect', box.aspect.toFixed(4));
    node.style.setProperty('--art-left', `${(-box.left / box.width * 100).toFixed(2)}%`);
    node.style.setProperty('--art-top', `${(-box.top / box.height * 100).toFixed(2)}%`);
    node.style.setProperty('--art-width', `${(100 / box.width).toFixed(2)}%`);
    node.style.setProperty('--art-height', `${(100 / box.height).toFixed(2)}%`);
    node.classList.add('is-measured');
  };

  const balloonStageFit = (width, height) => {
    const w = Number(width) - 12;
    const h = Number(height) - 12;
    if (!(w > 0) || !(h > 0)) return { scale: 1, shift: 0 };
    const scale = Math.max(0.3, Math.min(1, Math.floor(Math.min(w / 548, h / 491) * 1000) / 1000));
    const shift = Math.max(0, Math.round(279 * scale - h / 2));
    return { scale, shift };
  };

  const initBalloonBuilder = (source) => {
    if (!source || source.dataset.balloonBuilderReady === 'true') return;
    const json = source.querySelector('[data-balloon-builder-json]');
    const modal = source.querySelector('[data-balloon-builder]');
    const configure = source.querySelector('[data-balloon-configure]');
    if (!json || !modal || !configure) return;
    let data;
    try {
      data = JSON.parse(json.textContent);
    } catch(e) {
      console.warn('Dopamine balloon builder data is invalid', e);
      return;
    }
    const designs = Array.isArray(data.designs) ? data.designs
      .filter(design => design && design.image && (design.quantity == null || Number(design.quantity) > 0))
      .map(design => ({
        ...design,
        quantity: design.quantity == null ? null : Math.max(0, Number(design.quantity)),
        surchargeCents: Math.max(0, Number(design.surchargeCents || 0)),
        priceLabel: String(design.priceLabel || 'Premium').trim() || 'Premium'
      })).sort((a, b) => (Number(a.position) || 1000) - (Number(b.position) || 1000)) : [];
    if (!designs.length) {
      configure.disabled = true;
      const tileMeta = source.classList.contains('gift-tile') ? source.querySelector('[data-gift-tile-meta]') : null;
      if (tileMeta) {
        tileMeta.textContent = 'Temporarily unavailable';
        source.classList.add('is-unavailable');
      } else {
        configure.textContent = 'Temporarily unavailable';
      }
      return;
    }
    setGiftTileShowcase(source, designs);
    setAddonCardShowcase(source, designs);
    source.dataset.balloonBuilderReady = 'true';
    if (modal.parentElement !== document.body) document.body.appendChild(modal);
    const selectedWrap = modal.querySelector('[data-balloon-selected]');
    const stringWrap = modal.querySelector('[data-balloon-strings]');
    const designWrap = modal.querySelector('[data-balloon-designs]');
    const designScrollCue = modal.querySelector('[data-balloon-scroll-cue]');
    const empty = modal.querySelector('[data-balloon-empty]');
    const countEl = modal.querySelector('[data-balloon-count]');
    const footCountEl = modal.querySelector('[data-balloon-foot-count]');
    const totalEl = modal.querySelector('[data-balloon-total]');
    const regularTotalEl = modal.querySelector('[data-balloon-regular-total]');
    const flyingBalloonsEl = modal.querySelector('[data-balloon-flying-balloons]');
    const pricingEl = modal.querySelector('[data-balloon-pricing]');
    const discountEl = modal.querySelector('[data-balloon-discount]');
    const savingEl = modal.querySelector('[data-balloon-saving]');
    const confirm = modal.querySelector('[data-balloon-confirm]');
    const confirmLabel = modal.querySelector('[data-balloon-confirm-label]');
    const clear = modal.querySelector('[data-balloon-clear]');
    const units = balloonUnitCents(data);
    let selected = [];
    let justAdded = -1;
    // Where each balloon's ribbon ends (x %, y % of the set's box) and its tilt; every string runs from
    // there to the weight. Higher balloons stand behind lower ones, so the bunch reads as one bouquet.
    const positions = [
      [50, 58, -1], [33, 63, -6], [67, 63, 5], [42, 47, -3], [58, 47, 3],
      [18, 70, -9], [82, 70, 8], [50, 42, 0], [25, 53, -7], [75, 53, 6]
    ];
    const knot = [50, 90];
    const updateDesignScrollCue = () => {
      if (!designScrollCue) return;
      const remaining = designWrap.scrollWidth - designWrap.clientWidth - designWrap.scrollLeft;
      const atEnd = designWrap.scrollWidth <= designWrap.clientWidth + 6 || remaining <= 6;
      designScrollCue.hidden = atEnd;
      designWrap.closest('.balloon-builder__designs-shell')?.classList.toggle('is-scroll-end', atEnd);
    };

    const render = () => {
      selectedWrap.replaceChildren();
      stringWrap?.replaceChildren();
      selected.forEach((design, index) => {
        const button = document.createElement('button');
        const position = positions[index] || positions[positions.length - 1];
        if (stringWrap) {
          const [startX, startY] = position;
          const bendX = (startX + knot[0]) / 2 + (startX < 50 ? -4 : startX > 50 ? 4 : 0);
          const bendY = (startY + knot[1]) / 2;
          const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
          path.setAttribute('d', `M ${startX} ${startY} Q ${bendX} ${bendY} ${knot[0]} ${knot[1]}`);
          path.setAttribute('class', 'balloon-builder__string');
          path.style.setProperty('--string-delay', `${index === justAdded ? 380 : 0}ms`);
          stringWrap.appendChild(path);
        }
        button.type = 'button';
        button.className = `balloon-builder__selected-item${index === justAdded ? ' is-new' : ''}`;
        button.style.setProperty('--balloon-x', `${position[0]}%`);
        button.style.setProperty('--balloon-y', `${position[1]}%`);
        button.style.setProperty('--balloon-r', `${position[2]}deg`);
        button.style.setProperty('--balloon-z', String(position[1]));
        button.style.setProperty('--balloon-delay', `${(-(index * 0.9) % 6).toFixed(1)}s`);
        button.title = `Remove ${design.name}`;
        button.setAttribute('aria-label', `Remove ${design.name}`);
        button.innerHTML = `<span class="balloon-builder__sway"><img src="${design.image}" alt=""><span class="balloon-builder__remove-mark">&times;</span></span>`;
        measureBalloonArt(design.image).then(box => applyBalloonArt(button, box));
        button.addEventListener('click', () => {
          selected.splice(index, 1);
          render();
        });
        selectedWrap.appendChild(button);
      });
      if (selected.length) {
        const weight = document.createElement('span');
        weight.className = 'balloon-builder__weight';
        weight.setAttribute('aria-hidden', 'true');
        weight.style.setProperty('--knot-x', `${knot[0]}%`);
        weight.style.setProperty('--knot-y', `${knot[1]}%`);
        selectedWrap.appendChild(weight);
      }
      justAdded = -1;
      empty.hidden = selected.length > 0;
      countEl.textContent = `${selected.length} / 10`;
      if (footCountEl) footCountEl.textContent = `${selected.length} balloon${selected.length === 1 ? '' : 's'}`;
      const premiumTotal = selected.reduce((sum, design) => sum + Math.max(0, Number(design.surchargeCents || 0)), 0);
      const total = balloonPriceForCount(selected.length, units) + premiumTotal;
      totalEl.textContent = money(total);
      const regularTotal = (selected.length * units[0]) + premiumTotal;
      const saving = Math.max(0, (selected.length * units[0]) - balloonPriceForCount(selected.length, units));
      if (regularTotalEl) {
        regularTotalEl.hidden = saving < 1;
        regularTotalEl.textContent = money(regularTotal);
      }
      if (flyingBalloonsEl) {
        flyingBalloonsEl.hidden = saving < 1;
        flyingBalloonsEl.classList.remove('is-flying');
        if (saving >= 1) {
          void flyingBalloonsEl.offsetWidth;
          flyingBalloonsEl.classList.add('is-flying');
        }
      }
      if (pricingEl) {
        pricingEl.textContent = selected.length >= 7
          ? `7th+ balloon ${balloonUnitText(units[2])}`
          : selected.length >= 4
            ? `4th–6th balloon ${balloonUnitText(units[1])}`
            : `First 3 × ${balloonUnitText(units[0])}`;
      }
      if (discountEl) {
        const percentOff = Math.round((1 - units[selected.length >= 7 ? 2 : 1] / units[0]) * 100);
        discountEl.hidden = selected.length < 4 || percentOff < 1;
        discountEl.textContent = selected.length >= 7 ? `${percentOff}% OFF · 7TH+` : `${percentOff}% OFF · BALLOONS 4–6`;
        discountEl.classList.toggle('is-best-tier', selected.length >= 7);
      }
      if (savingEl) {
        savingEl.hidden = saving < 1;
        savingEl.textContent = saving >= 1 ? `Save ${money(saving)} on this set` : '';
      }
      const remaining = Math.max(0, 3 - selected.length);
      confirm.disabled = remaining > 0;
      confirm.dataset.cartReady = remaining === 0 && source.dataset.balloonContext === 'direct-product' ? 'true' : 'false';
      confirmLabel.textContent = remaining > 0
        ? `Choose ${remaining} more`
        : source.dataset.balloonContext === 'direct-product'
          ? `Add to · ${money(total)}`
          : `Add ${selected.length}-balloon set · ${money(total)}`;
      designWrap.querySelectorAll('[data-balloon-design]').forEach(button => {
        const count = selected.filter(design => design.key === button.dataset.balloonDesign).length;
        const design = designs.find(option => option.key === button.dataset.balloonDesign);
        const outOfDesignStock = design?.quantity != null && count >= Number(design.quantity);
        button.disabled = selected.length >= 10 || outOfDesignStock;
        button.classList.toggle('is-stock-limit', outOfDesignStock);
        const badge = button.querySelector('[data-balloon-design-count]');
        if (badge) {
          badge.textContent = String(count);
          badge.hidden = count < 1;
        }
      });
    };

    designs.forEach(design => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = `balloon-design-card${design.surchargeCents > 0 ? ' is-premium' : ''}`;
      button.dataset.balloonDesign = design.key;
      const priceLabel = design.surchargeCents > 0 ? `<small>+${money(design.surchargeCents)} · ${design.priceLabel}</small>` : '';
      button.innerHTML = `<img src="${design.image}" alt="${design.name}"><strong>${design.name}</strong>${priceLabel}<span class="balloon-design-card__count" data-balloon-design-count hidden>0</span>`;
      button.addEventListener('click', () => {
        if (selected.length >= 10) return;
        const selectedCount = selected.filter(option => option.key === design.key).length;
        if (design.quantity != null && selectedCount >= design.quantity) return;
        selected.push({ ...design });
        justAdded = selected.length - 1;
        render();
      });
      designWrap.appendChild(button);
    });
    designWrap.addEventListener('scroll', rafThrottle(updateDesignScrollCue), { passive: true });
    designScrollCue?.addEventListener('click', () => {
      designWrap.scrollBy({ left: Math.max(180, designWrap.clientWidth * .72), behavior: 'smooth' });
    });
    // The set follows the panel's size: on opening, when a tablet turns and when Safari's bars move.
    const bouquet = modal.querySelector('.balloon-builder__bouquet');
    const fitStage = () => {
      if (modal.hidden || !bouquet || !bouquet.clientWidth) return;
      const fit = balloonStageFit(bouquet.clientWidth, bouquet.clientHeight);
      modal.style.setProperty('--balloon-stage-scale', String(fit.scale));
      modal.style.setProperty('--balloon-stage-shift', `${fit.shift}px`);
    };
    if (bouquet && 'ResizeObserver' in window) new ResizeObserver(fitStage).observe(bouquet);
    window.addEventListener('resize', rafThrottle(() => { updateDesignScrollCue(); fitStage(); }), { passive: true });
    window.requestAnimationFrame(updateDesignScrollCue);

    const dialog = modal.querySelector('[role="dialog"]') || modal;
    let returnFocus = null;
    const open = () => {
      setAppHeight();
      returnFocus = document.activeElement;
      selected = (source._balloonItem?.selected || []).map(design => ({ ...design }));
      if (clear) clear.hidden = !source._balloonItem || source.dataset.balloonContext === 'direct-product';
      render();
      modal.hidden = false;
      fitStage();
      lockPageScroll();
      window.requestAnimationFrame(updateDesignScrollCue);
      window.requestAnimationFrame(() => focusDialog(dialog));
    };
    const close = () => {
      if (modal.hidden) return;
      modal.hidden = true;
      unlockPageScroll();
      restoreDialogFocus(returnFocus && returnFocus !== document.body ? returnFocus : configure);
      returnFocus = null;
    };
    modal.addEventListener('keydown', event => trapDialogKeydown(event, dialog, close));
    configure.addEventListener('click', open);
    modal.querySelectorAll('[data-balloon-close]').forEach(button => button.addEventListener('click', close));
    confirm.addEventListener('click', () => {
      const item = balloonCartItem(data, selected);
      if (!item) {
        alert('This balloon price is still being refreshed. Please reload the page and try again.');
        return;
      }
      // A balloon card in the shop (home, collections): the set goes straight into the cart.
      if (source.dataset.balloonContext === 'shop') {
        close();
        addShopItems(source.closest('[data-addon-shop-card]'), balloonCartItems(item));
        return;
      }
      syncBalloonItemAcrossSources(source, data, item);
      close();
      if (source.dataset.balloonContext === 'direct-product') {
        window.requestAnimationFrame(() => source.closest('form')?.requestSubmit());
      }
    });
    clear?.addEventListener('click', () => {
      document.querySelectorAll('[data-balloon-builder-source]').forEach(otherSource => {
        const otherJSON = otherSource.querySelector('[data-balloon-builder-json]');
        if (!otherJSON) return;
        try {
          const otherData = JSON.parse(otherJSON.textContent);
          if (String(otherData.productId) === String(data.productId)) clearBalloonItemFromSource(otherSource);
        } catch(e) {
          console.warn('Dopamine balloon source could not be cleared', e);
        }
      });
      selected = [];
      close();
    });
    render();
    if (source.dataset.balloonContext === 'direct-product' && new URLSearchParams(window.location.search).get('configure') === 'balloons') {
      window.requestAnimationFrame(open);
    }
  };

  const normalizeVaseInput = (value) => {
    const rawLines = String(value || '').replace(/\r/g, '').split('\n');
    const lines = rawLines.length > 2
      ? [rawLines[0], rawLines.slice(1).join(' ')]
      : rawLines;
    let remaining = 24;
    return lines.slice(0, 2).map(line => {
      const clean = line.replace(/[\t ]+/g, ' ');
      const characters = Array.from(clean).slice(0, remaining);
      remaining -= characters.length;
      return characters.join('');
    }).join('\n');
  };

  const finishedVaseInscription = (value) => normalizeVaseInput(value)
    .split('\n')
    .map(line => line.trim())
    .filter(Boolean)
    .join('\n');

  const vaseCharacterCount = (value) => Array.from(String(value || '').replace(/\n/g, '')).length;

  const vasePreviewLines = (value) => {
    const text = finishedVaseInscription(value);
    if (!text) return ['Your words'];
    if (text.includes('\n')) return text.split('\n').slice(0, 2);
    const characters = Array.from(text);
    if (characters.length <= 14) return [text];
    const words = text.split(/\s+/).filter(Boolean);
    if (words.length === 1 && characters.length <= 16) return [text];
    if (words.length === 1) {
      const midpoint = Math.ceil(characters.length / 2);
      return [characters.slice(0, midpoint).join(''), characters.slice(midpoint).join('')];
    }
    let best = null;
    for (let index = 1; index < words.length; index += 1) {
      const first = words.slice(0, index).join(' ');
      const second = words.slice(index).join(' ');
      const score = Math.abs(Array.from(first).length - Array.from(second).length);
      if (!best || score < best.score) best = { first, second, score };
    }
    return best ? [best.first, best.second] : [text];
  };

  const vasePairingFromModal = (modal, data) => {
    if (!data?.pairingRequired) return null;
    const target = modal.querySelector('[data-vase-target]:checked');
    if (!target) return null;
    return {
      targetKey: target.value,
      targetProductId: target.dataset.vaseTargetProduct || target.value,
      targetVariantId: target.dataset.vaseTargetVariant || '',
      targetTitle: String(target.dataset.vaseTargetTitle || 'Arrangement').trim(),
      targetFormat: 'arrangement',
      setup: 'lettering',
      orderLabel: 'Attach raised lettering to the existing vase; keep the flowers and container as ordered'
    };
  };

  const vaseCartItem = (data, inscription, pairing = null, options = {}) => {
    const text = finishedVaseInscription(inscription);
    if (!text || !data?.variantId || (data.pairingRequired && !pairing)) return null;
    const layoutLines = vasePreviewLines(text);
    const layoutText = layoutLines.join('\n');
    const style = options.style === 'Classic' ? 'Classic' : 'Script';
    const color = ['White', 'Black', 'Blush pink'].includes(options.color) ? options.color : 'Black';
    return {
      id: Number(data.variantId), quantity: 1, price: Number(data.price || 0),
      inscription: layoutText, lettering: style, color, image: data.image || '',
      targetKey: pairing?.targetKey || '', targetTitle: pairing?.targetTitle || '',
      targetFormat: pairing?.targetFormat || '', setup: 'lettering',
      properties: {
        'Vase inscription': layoutText,
        'Vase lettering': style,
        'Lettering color': color,
        'Lettering placement': 'Centered on the existing vase',
        ...(pairing ? {
          'Lettering for': pairing.targetTitle,
          'Lettering setup': pairing.orderLabel,
          '_Vase pairing': JSON.stringify({ version: 2, ...pairing })
        } : {}),
        '_Lettering only': 'Yes',
        '_Vase design': JSON.stringify({ version: 7, kind: 'lettering', inscription: layoutText, lines: layoutLines, lettering: style, color, placement: 'centered', container: 'unchanged' })
      }
    };
  };

  const applyVaseItemToSource = (source, item, data = {}) => {
    source._vaseItem = item;
    const button = source.querySelector('[data-vase-configure]');
    const onTile = setGiftTile(source, { meta: `“${vasePreviewLines(item.inscription).join(' ')}” · ${money(item.price)}`, picked: true });
    if (!onTile && button) {
      if (!button.dataset.vaseOriginalLabel) button.dataset.vaseOriginalLabel = button.textContent.trim();
      button.textContent = data.copy?.edit || 'Edit lettering';
    }
    const card = source.closest('[data-addon-card]');
    if (card) {
      card._vaseItem = item;
      card.classList.add('is-picked');
      const price = card.querySelector('[data-addon-price]');
      if (price) price.textContent = money(item.price);
      const media = card.querySelector('[data-addon-media]');
      if (media) {
        if (card._vaseOriginalMedia == null) card._vaseOriginalMedia = media.innerHTML;
        const preview = document.createElement('div');
        const previewText = document.createElement('span');
        preview.className = 'addon-card__vase-preview';
        preview.dataset.lettering = item.lettering.toLowerCase();
        preview.dataset.letteringColor = item.color === 'Blush pink' ? 'pink' : item.color.toLowerCase();
        previewText.textContent = vasePreviewLines(item.inscription).join('\n');
        preview.appendChild(previewText);
        media.replaceChildren(preview);
      }
      card.closest('[data-addon-modal]')?.dispatchEvent(new CustomEvent('vase:configured'));
    }
    source.dispatchEvent(new CustomEvent('vase:configured', { bubbles: true, detail: item }));
  };

  const clearVaseItemFromSource = (source) => {
    source._vaseItem = null;
    const button = source.querySelector('[data-vase-configure]');
    if (!setGiftTile(source, { picked: false }) && button?.dataset.vaseOriginalLabel) button.textContent = button.dataset.vaseOriginalLabel;
    const card = source.closest('[data-addon-card]');
    if (card) {
      card._vaseItem = null;
      card.classList.remove('is-picked');
      const media = card.querySelector('[data-addon-media]');
      if (media && card._vaseOriginalMedia != null) media.innerHTML = card._vaseOriginalMedia;
      card.closest('[data-addon-modal]')?.dispatchEvent(new CustomEvent('vase:configured'));
    }
    source.dispatchEvent(new CustomEvent('vase:configured', { bubbles: true, detail: null }));
  };

  const syncVaseItemAcrossSources = (source, data, item) => {
    document.querySelectorAll('[data-vase-builder-source]').forEach(otherSource => {
      const otherJSON = otherSource.querySelector('[data-vase-builder-json]');
      if (!otherJSON) return;
      try {
        const otherData = JSON.parse(otherJSON.textContent);
        if (String(otherData.productId) === String(data.productId)) applyVaseItemToSource(otherSource, item, otherData);
      } catch(e) {
        console.warn('Dopamine vase source could not be synchronized', e);
      }
    });
    if (!source._vaseItem) applyVaseItemToSource(source, item, data);
  };

  const initVaseBuilder = (source) => {
    if (!source || source.dataset.vaseBuilderReady === 'true') return;
    const json = source.querySelector('[data-vase-builder-json]');
    const modal = source.querySelector('[data-vase-builder]');
    const configure = source.querySelector('[data-vase-configure]');
    if (!json || !modal || !configure) return;
    let data;
    try { data = JSON.parse(json.textContent); }
    catch(e) {
      console.warn('Dopamine vase builder data is invalid', e);
      return;
    }
    source.dataset.vaseBuilderReady = 'true';
    if (modal.parentElement !== document.body) document.body.appendChild(modal);
    const input = modal.querySelector('[data-vase-text]');
    const previewLines = Array.from(modal.querySelectorAll('[data-vase-preview-line]'));
    const count = modal.querySelector('[data-vase-character-count]');
    const confirm = modal.querySelector('[data-vase-confirm]');
    const confirmLabel = modal.querySelector('[data-vase-confirm-label]');
    const clear = modal.querySelector('[data-vase-clear]');
    const targetInputs = Array.from(modal.querySelectorAll('[data-vase-target]'));
    const styleInputs = Array.from(modal.querySelectorAll('[data-vase-style]'));
    const colorInputs = Array.from(modal.querySelectorAll('[data-vase-color]'));
    const model = modal.querySelector('[data-vase-model]');
    const previewNote = modal.querySelector('.vase-builder__preview-note');
    const originalPreviewNote = previewNote?.textContent || '';
    const pairingError = modal.querySelector('[data-vase-pairing-error]');
    const body = modal.querySelector('.vase-builder__body');
    const done = modal.querySelector('[data-vase-done]');
    const dialog = modal.querySelector('[role="dialog"]') || modal;
    let returnFocus = null;
    let focusTimer;
    const finishEditing = () => {
      modal.classList.remove('is-editing');
      if (body) body.scrollTop = 0;
      setAppHeight();
      // Safari finishes its keyboard/toolbar animation after the blur event.
      window.clearTimeout(focusTimer);
      focusTimer = window.setTimeout(setAppHeight, 350);
    };

    const setPreview = () => {
      const value = normalizeVaseInput(input?.value || '');
      if (input && input.value !== value) {
        const caret = Math.min(input.selectionStart || value.length, value.length);
        input.value = value;
        input.setSelectionRange(caret, caret);
      }
      const lines = vasePreviewLines(value);
      if (model) {
        model.dataset.lettering = modal.querySelector('[data-vase-style]:checked')?.value.toLowerCase() || 'script';
        const color = modal.querySelector('[data-vase-color]:checked')?.value || 'Black';
        model.dataset.letteringColor = color === 'Blush pink' ? 'pink' : color.toLowerCase();
        if (previewNote) previewNote.textContent = color === 'White' ? (data.copy?.whitePreviewNote || originalPreviewNote) : originalPreviewNote;
      }
      previewLines.forEach((line, index) => {
        const lineValue = lines[index] || '';
        const length = Math.max(4, Array.from(lineValue).length);
        line.textContent = lineValue;
        line.toggleAttribute('hidden', !lineValue);
        line.setAttribute('y', String(lines.length > 1 ? (index === 0 ? 43 : 83) : 63));
        line.style.fontSize = `${Math.max(25, Math.min(39, 430 / length))}px`;
      });
      if (count) count.textContent = `${vaseCharacterCount(value)} / 24`;
      if (confirm) {
        const finishedValue = finishedVaseInscription(value);
        const pairing = vasePairingFromModal(modal, data);
        const hasTarget = !data.pairingRequired || Boolean(modal.querySelector('[data-vase-target]:checked'));
        const ready = Boolean(finishedValue && (!data.pairingRequired || pairing));
        confirm.disabled = !ready;
        confirm.dataset.cartReady = ready && source.dataset.vaseContext === 'direct-product' ? 'true' : 'false';
        const priceLabel = money(data.price);
        confirmLabel.textContent = !finishedValue
          ? data.copy.enterMessage
          : !hasTarget
            ? data.copy.chooseFlowers
            : data.pairingRequired && !pairing
              ? data.copy.chooseFlowers
              : (data.copy?.chooseBox || 'Save lettering · [price]').replace('[price]', priceLabel);
        if (pairingError) pairingError.hidden = true;
      }
    };

    const open = () => {
      setAppHeight();
      const current = source._vaseItem;
      if (input) input.value = current?.inscription || '';
      if (current?.targetKey) {
        targetInputs.forEach(target => { target.checked = target.value === current.targetKey; });
      } else if (targetInputs.length > 1) {
        targetInputs.forEach(target => { target.checked = false; });
      }
      styleInputs.forEach(option => { option.checked = option.value === (current?.lettering || 'Script'); });
      colorInputs.forEach(option => { option.checked = option.value === (current?.color || 'Black'); });
      if (source.dataset.vaseContext === 'product-addon') {
        const variant = source.closest('form')?.querySelector('input[name="id"]')?.value || '';
        targetInputs.forEach(target => { target.dataset.vaseTargetVariant = variant; });
      }
      if (clear) clear.hidden = !current;
      setPreview();
      modal.hidden = false;
      modal.classList.remove('is-editing');
      if (body) body.scrollTop = 0;
      lockPageScroll();
      returnFocus = document.activeElement;
      // Computers go straight to the text field; phones and tablets (touch) get the dialog itself,
      // so the keyboard does not jump up over the preview before the customer has seen it.
      if (window.matchMedia('(min-width: 761px) and (hover: hover) and (pointer: fine)').matches) {
        window.setTimeout(() => input?.focus({ preventScroll: true }), 80);
      } else {
        window.requestAnimationFrame(() => focusDialog(dialog));
      }
    };
    const close = () => {
      input?.blur();
      finishEditing();
      modal.hidden = true;
      unlockPageScroll();
      restoreDialogFocus(returnFocus && returnFocus !== document.body ? returnFocus : configure);
      returnFocus = null;
    };
    configure.addEventListener('click', open);
    input?.addEventListener('input', setPreview);
    input?.addEventListener('focus', () => {
      window.clearTimeout(focusTimer);
      modal.classList.add('is-editing');
      if (body) body.scrollTop = 0;
      setAppHeight();
      window.requestAnimationFrame(() => {
        if (!modal.hidden && document.activeElement === input && body) {
          const fieldRect = input.getBoundingClientRect();
          const bodyRect = body.getBoundingClientRect();
          body.scrollTop += Math.max(0, fieldRect.bottom - bodyRect.bottom + 12);
        }
      });
    });
    input?.addEventListener('blur', finishEditing);
    done?.addEventListener('click', () => input?.blur());
    modal.addEventListener('keydown', event => trapDialogKeydown(event, dialog, close));
    [...targetInputs, ...styleInputs, ...colorInputs].forEach(option => option.addEventListener('change', setPreview));
    modal.querySelectorAll('[data-vase-example]').forEach(button => button.addEventListener('click', () => {
      input.value = button.dataset.vaseExample;
      setPreview();
    }));
    modal.querySelectorAll('[data-vase-close]').forEach(button => button.addEventListener('click', close));
    confirm?.addEventListener('click', () => {
      const pairing = vasePairingFromModal(modal, data);
      const item = vaseCartItem(data, input?.value, pairing, { style: modal.querySelector('[data-vase-style]:checked')?.value, color: modal.querySelector('[data-vase-color]:checked')?.value });
      if (!item) {
        if (pairingError) pairingError.hidden = false;
        return;
      }
      syncVaseItemAcrossSources(source, data, item);
      close();
      if (source.dataset.vaseContext === 'direct-product') {
        window.requestAnimationFrame(() => source.closest('form')?.requestSubmit());
      }
    });
    clear?.addEventListener('click', () => {
      document.querySelectorAll('[data-vase-builder-source]').forEach(otherSource => {
        const otherJSON = otherSource.querySelector('[data-vase-builder-json]');
        if (!otherJSON) return;
        try {
          const otherData = JSON.parse(otherJSON.textContent);
          if (String(otherData.productId) === String(data.productId)) clearVaseItemFromSource(otherSource);
        } catch(e) {
          console.warn('Dopamine vase source could not be cleared', e);
        }
      });
      close();
    });
    setPreview();
  };

  // ---- Plush friends (snippets/plush-picker.liquid) ----
  // Every friend is a variant of the Plush Friend product, named "Highland Cow · 7 in"; its
  // tracked stock caps how many can be picked, so a one-off can only be picked once. On a
  // flower page the friends go into the cart in the same request as the flowers; on an
  // add-on card they count like any other pick of the add-on popup.
  const MAX_PLUSH_PER_FRIEND = 10;
  const plushFill = (template, values) => Object.entries(values)
    .reduce((text, [key, value]) => text.split(`[${key}]`).join(String(value)), String(template || ''));
  const plushSelectionCount = (selection) => selection.reduce((sum, item) => sum + item.quantity, 0);
  const plushSelectionTotal = (selection) => selection.reduce((sum, item) => sum + (item.price * item.quantity), 0);
  const plushCartItems = (selection, data) => selection.map(item => ({
    id: Number(item.id),
    quantity: item.quantity,
    properties: {
      '_Plush friend': 'picker',
      ...(data.pairedWith ? { '_Paired with': data.pairedWith } : {})
    }
  }));

  const applyPlushToSource = (source, selection) => {
    const data = source._plushData || {};
    const count = plushSelectionCount(selection);
    const total = plushSelectionTotal(selection);
    source._plushSelection = count ? selection : null;
    source._plushItems = count ? plushCartItems(selection, data) : null;
    setGiftTile(source, {
      meta: `${count} ${count === 1 ? 'friend' : 'friends'} · ${money(total)}`,
      picked: count > 0,
      images: selection.map(item => item.image)
    });
    const card = source.closest('[data-addon-card]');
    if (card) {
      card._plushItems = source._plushItems;
      card._plushTotal = total;
      card.classList.toggle('is-picked', count > 0);
      const price = card.querySelector('[data-addon-price]');
      if (price) {
        if (price.dataset.plushOriginalPrice == null) price.dataset.plushOriginalPrice = price.textContent.trim();
        price.textContent = count ? money(total) : price.dataset.plushOriginalPrice;
      }
      const media = card.querySelector('[data-addon-media]');
      if (media) {
        if (card._plushOriginalMedia == null) card._plushOriginalMedia = media.innerHTML;
        if (count) {
          media.replaceChildren(...selection.slice(0, 3).map((item, index) => {
            const image = document.createElement('img');
            image.src = item.image;
            image.alt = item.name;
            image.className = 'addon-card__balloon-preview';
            image.style.setProperty('--preview-index', String(index));
            return image;
          }));
        } else {
          media.innerHTML = card._plushOriginalMedia;
        }
      }
      const open = source.querySelector('[data-plush-open]');
      if (open) {
        if (open.dataset.plushOriginalLabel == null) open.dataset.plushOriginalLabel = open.textContent.trim();
        open.textContent = count ? (data.copy?.tileEdit || 'Edit') : open.dataset.plushOriginalLabel;
      }
      card.closest('[data-addon-modal]')?.dispatchEvent(new CustomEvent('plush:configured'));
    }
    source.dispatchEvent(new CustomEvent('plush:configured', { bubbles: true, detail: { selection } }));
  };

  // After the flowers and friends are in the cart: the tile says so, and the add-on popup
  // that opens next does not offer the same friends a second time.
  const markPlushAdded = (source) => {
    const data = source._plushData || {};
    applyPlushToSource(source, []);
    const meta = source.querySelector('[data-gift-tile-meta]');
    if (meta && data.copy?.added) meta.textContent = data.copy.added;
    source.classList.add('is-added');
    document.querySelectorAll('[data-plush-addon-card]').forEach(card => {
      if (!card.classList.contains('is-picked')) card.classList.add('is-added-elsewhere');
    });
  };

  const initPlushPicker = (source) => {
    if (!source || source.dataset.plushPickerReady === 'true') return;
    const json = source.querySelector('[data-plush-picker-json]');
    const modal = source.querySelector('[data-plush-picker]');
    const openButton = source.querySelector('[data-plush-open]');
    if (!json || !modal || !openButton) return;
    let data;
    try {
      data = JSON.parse(json.textContent);
    } catch(e) {
      console.warn('Dopamine plush picker data is invalid', e);
      return;
    }
    const copy = data.copy || {};
    const friends = (Array.isArray(data.friends) ? data.friends : [])
      .map(friend => {
        const [titleName, titleDetail] = String(friend.title || '').split(' · ');
        const stock = friend.stock == null ? null : Math.max(0, Number(friend.stock) || 0);
        return {
          id: String(friend.id || ''),
          name: friend.name || titleName || 'Plush friend',
          size: friend.detail ?? titleDetail ?? '',
          price: Number(friend.price || 0),
          image: friend.image || '',
          stock
        };
      })
      .filter(friend => friend.id && (friend.stock === null || friend.stock > 0));
    if (!friends.length) {
      source.hidden = true;
      return;
    }
    setGiftTileShowcase(source, friends);
    setAddonCardShowcase(source, friends);
    source.dataset.plushPickerReady = 'true';
    source._plushData = data;
    if (modal.parentElement !== document.body) document.body.appendChild(modal);
    const grid = modal.querySelector('[data-plush-grid]');
    const summary = modal.querySelector('[data-plush-summary]');
    const totalEl = modal.querySelector('[data-plush-total]');
    const confirm = modal.querySelector('[data-plush-confirm]');
    const confirmLabel = modal.querySelector('[data-plush-confirm-label]');
    const clear = modal.querySelector('[data-plush-clear]');
    const dialog = modal.querySelector('[role="dialog"]') || modal;
    const limitOf = friend => (friend.stock === null ? MAX_PLUSH_PER_FRIEND : Math.min(friend.stock, MAX_PLUSH_PER_FRIEND));
    let counts = new Map();
    let returnFocus = null;
    const selection = () => friends.filter(friend => (counts.get(friend.id) || 0) > 0)
      .map(friend => ({ ...friend, quantity: counts.get(friend.id) }));

    const cards = friends.map(friend => {
      const card = document.createElement('div');
      card.className = 'plush-card';
      const add = document.createElement('button');
      add.type = 'button';
      add.className = 'plush-card__add';
      add.setAttribute('aria-label', plushFill(copy.addLabel || 'Add [name]', { name: friend.name }));
      const media = document.createElement('span');
      media.className = 'plush-card__media';
      if (friend.image) {
        const image = document.createElement('img');
        image.src = friend.image;
        image.alt = '';
        image.loading = 'lazy';
        image.decoding = 'async';
        media.appendChild(image);
      }
      const name = document.createElement('strong');
      name.className = 'plush-card__name';
      name.textContent = friend.name;
      const meta = document.createElement('span');
      meta.className = 'plush-card__meta';
      const size = document.createElement('em');
      size.textContent = friend.size;
      size.hidden = !friend.size;
      const price = document.createElement('b');
      price.textContent = moneyWhole(friend.price);
      meta.append(size, price);
      add.append(media, name, meta);
      if (friend.stock !== null && friend.stock <= 3) {
        const stock = document.createElement('span');
        stock.className = 'plush-card__stock';
        stock.textContent = friend.stock === 1 ? (copy.lastOne || 'Last one') : plushFill(copy.onlyLeft || 'Only [count] left', { count: friend.stock });
        add.appendChild(stock);
      }
      const countBadge = document.createElement('span');
      countBadge.className = 'plush-card__count';
      countBadge.hidden = true;
      countBadge.setAttribute('aria-hidden', 'true');
      const minus = document.createElement('button');
      minus.type = 'button';
      minus.className = 'plush-card__minus';
      minus.hidden = true;
      minus.textContent = '−';
      minus.setAttribute('aria-label', plushFill(copy.removeLabel || 'Remove one [name]', { name: friend.name }));
      add.addEventListener('click', () => {
        const current = counts.get(friend.id) || 0;
        if (current >= limitOf(friend)) {
          card.classList.remove('is-bump');
          void card.offsetWidth;
          card.classList.add('is-bump');
          return;
        }
        counts.set(friend.id, current + 1);
        render();
      });
      minus.addEventListener('click', () => {
        const current = counts.get(friend.id) || 0;
        if (current <= 1) counts.delete(friend.id);
        else counts.set(friend.id, current - 1);
        render();
        if (!counts.get(friend.id)) add.focus({ preventScroll: true });
      });
      card.append(add, countBadge, minus);
      grid.appendChild(card);
      return { friend, card, add, countBadge, minus };
    });

    const render = () => {
      cards.forEach(({ friend, card, add, countBadge, minus }) => {
        const count = counts.get(friend.id) || 0;
        card.classList.toggle('is-picked', count > 0);
        card.classList.toggle('is-full', count >= limitOf(friend));
        add.setAttribute('aria-pressed', count > 0 ? 'true' : 'false');
        countBadge.hidden = count < 1;
        countBadge.textContent = String(count);
        minus.hidden = count < 1;
      });
      const picked = selection();
      const count = plushSelectionCount(picked);
      const total = plushSelectionTotal(picked);
      totalEl.textContent = money(total);
      summary.textContent = count
        ? picked.map(item => `${item.quantity > 1 ? `${item.quantity}× ` : ''}${item.name}`).join(', ')
        : (copy.empty || 'Tap a friend to add it');
      confirm.disabled = count === 0;
      confirm.dataset.cartReady = 'false';
      confirmLabel.textContent = count === 0
        ? (copy.empty || 'Tap a friend to add it')
        : count === 1
          ? plushFill(copy.confirmOne || 'Add [name] · [price]', { name: picked[0].name, price: money(total) })
          : plushFill(copy.confirmMany || 'Add [count] friends · [price]', { count, price: money(total) });
    };

    const open = () => {
      setAppHeight();
      returnFocus = document.activeElement;
      counts = new Map((source._plushSelection || []).map(item => [item.id, item.quantity]));
      if (clear) clear.hidden = !source._plushSelection;
      render();
      modal.hidden = false;
      lockPageScroll();
      const body = modal.querySelector('.plush-picker__body');
      if (body) body.scrollTop = 0;
      window.requestAnimationFrame(() => focusDialog(dialog));
    };
    const close = () => {
      if (modal.hidden) return;
      modal.hidden = true;
      unlockPageScroll();
      restoreDialogFocus(returnFocus && returnFocus !== document.body ? returnFocus : openButton);
      returnFocus = null;
    };
    openButton.addEventListener('click', () => {
      source.classList.remove('is-added');
      open();
    });
    modal.addEventListener('keydown', event => trapDialogKeydown(event, dialog, close));
    modal.querySelectorAll('[data-plush-close]').forEach(button => button.addEventListener('click', close));
    confirm.addEventListener('click', () => {
      // A plush card in the shop (home, collections): the friends go straight into the cart.
      if (source.dataset.plushContext === 'shop') {
        const picked = selection();
        close();
        if (picked.length) addShopItems(source.closest('[data-addon-shop-card]'), plushCartItems(picked, data));
        return;
      }
      applyPlushToSource(source, selection());
      close();
    });
    clear?.addEventListener('click', () => {
      applyPlushToSource(source, []);
      close();
    });
    render();
  };

  // Shopify answers a failed cart/add.js with {"description": "..."}; postJSON puts that
  // body in the error message.
  const cartErrorDescription = (error) => {
    const raw = String(error?.message || '');
    try {
      const parsed = JSON.parse(raw);
      return String(parsed.description || parsed.message || '').trim();
    } catch(e) {
      return raw.length < 160 ? raw.trim() : '';
    }
  };

  // One sold-out pick makes Shopify reject the whole cart/add.js request, so when the
  // combined request fails, add every pick on its own (a balloon set stays together with
  // its upgrade lines) and report exactly which ones could not be added.
  const addAddonGroupsToCart = async (groups, post) => {
    const pending = (groups || []).filter(group => group && group.items && group.items.length);
    if (!pending.length) return { added: [], failed: [] };
    try {
      return { added: [await post(pending.flatMap(group => group.items))], failed: [] };
    } catch(error) {
      const added = [];
      const failed = [];
      for (const group of pending) {
        try { added.push(await post(group.items)); }
        catch(groupError) { failed.push({ group, reason: cartErrorDescription(groupError) }); }
      }
      return { added, failed };
    }
  };

  const addonCardName = (card) => {
    const title = card.querySelector('h3')?.textContent.trim() || 'Add-on';
    const checked = card.querySelector('[data-addon-variant]:checked');
    const option = checked?.closest('label')?.querySelector('[data-addon-variant-title]')?.textContent.trim()
      || checked?.closest('label')?.textContent.trim() || '';
    return option ? `${title} (${option})` : title;
  };

  const addonItemsForCard = (card) => {
    if (card._balloonItem) return balloonCartItems(card._balloonItem);
    if (card._vaseItem) {
      return [{ id: Number(card._vaseItem.id), quantity: 1, properties: card._vaseItem.properties }];
    }
    if (card._plushItems?.length) return card._plushItems;
    const id = Number(selectedVariantIdForCard(card));
    return id ? [{ id, quantity: 1 }] : [];
  };

  const addonFailureMessage = (result) => {
    const names = result.failed.map(failure => `“${failure.group.name}”`);
    const list = names.length > 1 ? `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}` : names[0];
    const reason = result.failed.length === 1 && result.failed[0].reason ? ` ${result.failed[0].reason}` : ' It may have just sold out.';
    const rest = result.added.length ? ' Your other picks are in the cart.' : '';
    return `Couldn't add ${list}.${reason.endsWith('.') ? reason : `${reason}.`}${rest} Press the button again to continue.`;
  };

  // ---- Add-ons as cards in the shop (snippets/addon-shop-card.liquid; owner, 2026-10-14: "the
  // configurators must open straight on click"). A card opens its picker right where it is; what
  // is chosen goes into the cart on its own (as on the add-on's own page before), and the shopper
  // lands in the cart. Balloon and plush cards confirm through their pickers ('shop' context).
  const addShopItems = async (card, items) => {
    const list = (items || []).filter(item => item && item.id);
    if (!card || !list.length) return false;
    const error = card.querySelector('[data-addon-shop-error]');
    const sheetError = document.querySelector(`[data-addon-sheet-for="${card.dataset.handle}"] [data-addon-sheet-error]`);
    [error, sheetError].forEach(el => { if (el) { el.hidden = true; el.textContent = ''; } });
    card.classList.add('is-adding');
    try {
      const added = await postJSON(root + 'cart/add.js', { items: list });
      measureItemsAdded(added);
      await refreshCartCount();
      window.location.href = root + 'cart';
      return true;
    } catch (failure) {
      console.warn('Dopamine add-on could not be added', failure);
      const text = cartErrorDescription(failure) || card.dataset.failed || 'This could not be added just now. Please try again.';
      [error, sheetError].forEach(el => { if (el) { el.textContent = text; el.hidden = false; } });
      return false;
    } finally {
      card.classList.remove('is-adding');
    }
  };

  const initAddonShopCard = (card) => {
    if (!card || card.dataset.addonShopReady === 'true') return;
    card.dataset.addonShopReady = 'true';
    const adding = card.dataset.adding || 'Adding…';
    // One option: the button adds it.
    const addButton = card.querySelector('[data-addon-shop-add]');
    addButton?.addEventListener('click', async () => {
      if (addButton.disabled) return;
      const label = addButton.textContent;
      addButton.disabled = true;
      addButton.textContent = adding;
      const ok = await addShopItems(card, [{ id: Number(addButton.dataset.variantId), quantity: 1 }]);
      if (!ok) {
        addButton.disabled = false;
        addButton.textContent = label;
      }
    });
    // Options (macarons 4 / 8 / 16, petals...): a small sheet, the smallest option chosen.
    const sheet = card.querySelector('[data-addon-sheet]');
    const openButton = card.querySelector('[data-addon-shop-open]');
    if (!sheet || !openButton) return;
    sheet.dataset.addonSheetFor = card.dataset.handle || '';
    document.body.appendChild(sheet);
    const dialog = sheet.querySelector('[role="dialog"]') || sheet;
    const price = sheet.querySelector('[data-addon-sheet-price]');
    const add = sheet.querySelector('[data-addon-sheet-add]');
    const addLabel = add ? add.textContent.trim() : 'Add to cart';
    const chosen = () => sheet.querySelector('input[type="radio"]:checked');
    const showChoice = () => {
      const input = chosen();
      const cents = Number(input?.dataset.price || 0);
      if (price) price.textContent = money(cents);
      if (add) add.textContent = input ? `${addLabel} · ${money(cents)}` : addLabel;
    };
    let returnFocus = null;
    const close = () => {
      if (sheet.hidden) return;
      sheet.hidden = true;
      unlockPageScroll();
      restoreDialogFocus(returnFocus && returnFocus !== document.body ? returnFocus : openButton);
      returnFocus = null;
    };
    const open = () => {
      setAppHeight();
      returnFocus = document.activeElement;
      showChoice();
      sheet.hidden = false;
      lockPageScroll();
      window.requestAnimationFrame(() => focusDialog(dialog));
    };
    openButton.addEventListener('click', open);
    sheet.addEventListener('change', showChoice);
    sheet.addEventListener('keydown', event => trapDialogKeydown(event, dialog, close));
    sheet.querySelectorAll('[data-addon-sheet-close]').forEach(button => button.addEventListener('click', close));
    add?.addEventListener('click', async () => {
      const input = chosen();
      if (!input || add.disabled) return;
      add.disabled = true;
      add.textContent = adding;
      const ok = await addShopItems(card, [{ id: Number(input.value), quantity: 1 }]);
      if (!ok) {
        add.disabled = false;
        showChoice();
      }
    });
    card._openAddonSheet = open;
  };

  // The add-ons' own pages send shoppers to the add-ons collection with ?open=<handle>
  // (layout/theme.liquid): that card's picker opens by itself.
  const openAddonFromUrl = () => {
    const params = new URLSearchParams(window.location.search);
    const handle = params.get('open');
    if (!handle) return;
    const card = Array.from(document.querySelectorAll('[data-addon-shop-card]')).find(item => item.dataset.handle === handle);
    params.delete('open');
    const rest = params.toString();
    window.history.replaceState(window.history.state, '', `${window.location.pathname}${rest ? `?${rest}` : ''}${window.location.hash}`);
    if (!card) return;
    card.scrollIntoView({ block: 'center' });
    const trigger = card.querySelector('[data-balloon-configure], [data-plush-open], [data-addon-shop-open]');
    if (trigger && !trigger.disabled) window.requestAnimationFrame(() => trigger.click());
    else card.querySelector('[data-addon-shop-add]')?.focus({ preventScroll: true });
  };

  // options.beforeCheckout (the cart): runs before either popup button leaves for checkout and
  // returns false to stay on the cart. It is told whether this popup already added lines.
  // options.onDismiss (the product page): runs when the shopper closes the popup (×, the backdrop,
  // Escape) before it has added anything.
  const initAddonsModal = (scope, options = {}) => {
    const modal = scope.querySelector('[data-addon-modal]');
    if (!modal) return null;
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }
    const dialog = modal.querySelector('[role="dialog"]') || modal;
    let returnFocus = null;
    let errorEl = modal.querySelector('[data-addon-error]');
    if (!errorEl) {
      errorEl = document.createElement('p');
      errorEl.className = 'addon-modal__error';
      errorEl.dataset.addonError = '';
      errorEl.setAttribute('role', 'alert');
      errorEl.hidden = true;
      (modal.querySelector('.addon-modal__foot') || dialog).prepend(errorEl);
    }
    const showAddonError = (text) => {
      errorEl.textContent = text || '';
      errorEl.hidden = !text;
    };
    const totalEl = modal.querySelector('[data-addon-total]');
    const list = modal.querySelector('.addon-list');
    const listScrollCue = modal.querySelector('[data-addon-scroll-cue]');
    const redirectMode = modal.dataset.addonRedirect || 'cart';
    const continueUrl = withCampaignParams(modal.dataset.continueUrl || (redirectMode === 'checkout' ? root + 'checkout' : root + 'cart'));
    const continueTextDefault = modal.dataset.continueText || (redirectMode === 'checkout' ? 'Add selected & checkout' : 'Continue');
    const updateListScrollCue = () => {
      if (!list || !listScrollCue) return;
      const remaining = list.scrollHeight - list.clientHeight - list.scrollTop;
      const atEnd = list.scrollHeight <= list.clientHeight + 6 || remaining <= 6;
      listScrollCue.hidden = atEnd;
      list.closest('.addon-list-shell')?.classList.toggle('is-scroll-end', atEnd);
    };
    list?.addEventListener('scroll', rafThrottle(updateListScrollCue), { passive: true });
    listScrollCue?.addEventListener('click', () => {
      list.scrollBy({ top: Math.max(170, list.clientHeight * .62), behavior: 'smooth' });
    });
    window.addEventListener('resize', rafThrottle(updateListScrollCue), { passive: true });
    const closeModal = ({ dismissed = true } = {}) => {
      if (modal.hidden) return;
      modal.hidden = true;
      unlockPageScroll();
      // After Add to cart the button that opened the popup was disabled (focus fell to the
      // page), so go back to the Add / Checkout button instead of losing the place.
      const opener = returnFocus && returnFocus !== document.body ? returnFocus : scope.querySelector('[data-add-button], [data-checkout-review-addons]');
      restoreDialogFocus(opener);
      returnFocus = null;
      if (dismissed && !addedToCart && typeof options.onDismiss === 'function') options.onDismiss();
    };
    modal.addEventListener('keydown', event => trapDialogKeydown(event, dialog, closeModal));
    const updateTotal = () => {
      let total = 0;
      modal.querySelectorAll('[data-addon-card].is-picked').forEach(card => { total += selectedVariantPriceForCard(card); });
      if (totalEl) totalEl.textContent = money(total);
      modal.querySelectorAll('[data-free-delivery-meter]').forEach(meter => {
        updateFreeDeliveryMeter(meter, Number(meter.dataset.currentSubtotal || 0) + total);
      });
    };
    modal.addEventListener('balloon:configured', updateTotal);
    modal.addEventListener('vase:configured', updateTotal);
    modal.addEventListener('plush:configured', updateTotal);
    // Set once this popup has put a line in the cart (the cart form's quantity boxes are stale then).
    let addedToCart = false;
    // The cart's checks and save (recipient, gift message, From, date, note) before checkout.
    // Without them the meter's "Choose a little extra" popup went to checkout with none of the
    // gift details or the date saved (audit 2026-10-12).
    const readyForCheckout = async () => {
      if (redirectMode !== 'checkout' || typeof options.beforeCheckout !== 'function') return true;
      try {
        return await options.beforeCheckout({ cartChanged: addedToCart });
      } catch(e) {
        console.warn('Dopamine cart save before checkout failed', e);
        showAddonError(e && e.customerMessage ? e.customerMessage : 'We could not save your delivery details, so checkout has not started. Check your connection and try again.');
        return false;
      }
    };
    const redirectAfterAddons = async () => {
      if (redirectMode === 'checkout') measureCheckoutStarted();
      if (redirectMode === 'checkout') {
        try {
          await saveTransactionalSmsConsent();
        } catch(e) {
          console.warn('Dopamine transactional SMS consent save failed', e);
        }
      }
      window.location.href = continueUrl;
    };
    modal.addEventListener('click', async (event) => {
      if (event.target.matches('[data-addon-close]') || event.target.classList.contains('addon-modal__backdrop')) {
        closeModal();
      }
      const pick = event.target.closest('[data-addon-pick]');
      if (pick) {
        const card = pick.closest('[data-addon-card]');
        card.classList.toggle('is-picked');
        pick.textContent = card.classList.contains('is-picked') ? 'Added' : (pick.dataset.pickLabel || 'Add');
        updateTotal();
      }
      const skip = event.target.closest('[data-addons-skip]');
      if (skip) {
        if (skip.disabled) return;
        const skipText = skip.textContent;
        skip.disabled = true;
        skip.textContent = 'Opening checkout...';
        showAddonError('');
        if (!(await readyForCheckout())) {
          skip.disabled = false;
          skip.textContent = skipText;
          return;
        }
        await redirectAfterAddons();
        return;
      }
      const cont = event.target.closest('[data-addons-continue]');
      if (cont) {
        if (cont.disabled) return;
        cont.disabled = true;
        cont.textContent = 'Adding...';
        showAddonError('');
        // Check and save the cart first: a missing recipient or date sends the customer back to
        // the cart before anything is added.
        if (!(await readyForCheckout())) {
          cont.disabled = false;
          cont.textContent = continueTextDefault;
          return;
        }
        const groups = Array.from(modal.querySelectorAll('[data-addon-card].is-picked')).map(card => ({
          card,
          name: addonCardName(card),
          items: addonItemsForCard(card).filter(item => item.id)
        }));
        try {
          const result = await addAddonGroupsToCart(groups, items => postJSON(root + 'cart/add.js', { items }));
          if (result.added.length) addedToCart = true;
          result.added.forEach(measureItemsAdded);
          await refreshCartCount();
          if (result.failed.length) {
            // Leave the popup open: un-pick what failed so a second press simply continues.
            // A plush card also forgets its friends, so a second press never repeats them.
            const resetPlushCard = card => {
              const plushSource = card.querySelector('[data-plush-picker-source]');
              if (plushSource) applyPlushToSource(plushSource, []);
            };
            result.failed.forEach(({ group }) => {
              group.card.classList.remove('is-picked');
              group.card.classList.add('is-add-failed');
              const pickButton = group.card.querySelector('[data-addon-pick]');
              if (pickButton) pickButton.textContent = pickButton.dataset.pickLabel || 'Add';
              resetPlushCard(group.card);
            });
            groups.filter(group => !result.failed.some(failure => failure.group === group)).forEach(group => {
              group.card.classList.remove('is-picked');
              const pickButton = group.card.querySelector('[data-addon-pick]');
              if (pickButton) pickButton.textContent = pickButton.dataset.pickLabel || 'Add';
              resetPlushCard(group.card);
            });
            updateTotal();
            showAddonError(addonFailureMessage(result));
            cont.disabled = false;
            cont.textContent = continueTextDefault;
            cont.focus({ preventScroll: true });
            return;
          }
          await redirectAfterAddons();
        } catch(e) {
          cont.disabled = false;
          cont.textContent = continueTextDefault;
          showAddonError('Could not add add-ons. Please check your connection and try again.');
        }
      }
    });
    modal.addEventListener('touchmove', (event) => {
      if (!event.target.closest('.addon-list')) event.preventDefault();
    }, { passive: false });
    modal.addEventListener('change', (event) => {
      const input = event.target.closest('[data-addon-variant]');
      if (!input) return;
      const card = input.closest('[data-addon-card]');
      syncAddonVariantCard(card, input);
      updateTotal();
    });
    return {
      open(){
        setAppHeight();
        returnFocus = document.activeElement;
        showAddonError('');
        modal.hidden = false;
        if (list) list.scrollTop = 0;
        lockPageScroll();
        updateTotal();
        window.requestAnimationFrame(updateListScrollCue);
        window.requestAnimationFrame(() => focusDialog(dialog));
      },
      close: () => closeModal({ dismissed: false })
    };
  };

  // The reserved-time-window fee follows the window chosen in the cart: one fee line for a reserved
  // window (it carries the window in _For delivery / pickup window, as the order sync expects),
  // none for Standard. relabel: also fix the window on an existing fee line (the cart's window
  // choice and checkout do; the page-load check only adds and removes). A cart with nothing else
  // in it has no fee. cart: the cart as just read (saves asking Shopify again). Returns true when
  // the cart changed.
  const ensureExactFee = async (feeVariantId, windowLabel, { relabel = false, cart: knownCart = null } = {}) => {
    const cart = knownCart || await getCart();
    const items = cart.items || [];
    const feeItems = items.filter(isExactFeeItem);
    const properties = {
      '_Dopamine service fee': 'Reserved time window',
      '_For delivery / pickup window': windowLabel || 'Reserved time window'
    };
    let changed = false;
    const removeLines = async (lines) => {
      for (const item of lines) {
        await postJSON(root + 'cart/change.js', { id: item.key, quantity: 0 });
        changed = true;
      }
    };
    if (!isExactWindowValue(windowLabel) || !items.some(item => !isExactFeeItem(item))) {
      await removeLines(feeItems);
      return changed;
    }
    if (!feeItems.length) {
      if (!feeVariantId) throw new Error('Time-window fee product unavailable.');
      await postJSON(root + 'cart/add.js', { items: [{ id: Number(feeVariantId), quantity: 1, properties }] });
      return true;
    }
    const [first, ...extra] = feeItems;
    const label = String(first.properties?.['_For delivery / pickup window'] || '');
    if (Number(first.quantity) !== 1 || (relabel && label !== properties['_For delivery / pickup window'])) {
      await postJSON(root + 'cart/change.js', relabel ? { id: first.key, quantity: 1, properties } : { id: first.key, quantity: 1 });
      changed = true;
    }
    // Keys of the other lines stay valid when one line changes.
    await removeLines(extra);
    return changed;
  };

  // The window the cart is set to: the "When" step's choice (a cart attribute), else, in a cart
  // filled before 2026-10-14, the window an item was added with on the old product page.
  const cartWindowValue = (cart) => {
    const attributes = cart?.attributes || {};
    const chosen = attributes['Delivery / pickup window'] || attributes['delivery / pickup window'] || '';
    if (chosen) return String(chosen);
    const windowItem = (cart?.items || []).find(item => !isExactFeeItem(item) && itemTimeWindow(item));
    return windowItem ? String(itemTimeWindow(windowItem)) : '';
  };

  // Page load: the fee line matches the cart's window, from the cart the header count just read.
  // Returns true when the cart changed (it is then redrawn in place, no reload).
  const reconcileExactFeeInCart = async (cart) => {
    const cartSection = document.querySelector('[data-cart-section]');
    if (!cartSection || !cart) return false;
    const feeVariantId = Number(cartSection.dataset.exactFeeVariant || 0);
    try {
      return await ensureExactFee(feeVariantId, cartWindowValue(cart), { cart });
    } catch (error) {
      console.warn('Dopamine exact delivery fee reconciliation failed', error);
      return false;
    }
  };

  // Page load: premium balloon-design lines match their balloon sets. Returns true when the cart changed.
  const reconcileBalloonUpgradesInCart = async (cart) => {
    if (!document.querySelector('[data-cart-section]') || !cart) return false;
    try {
      const expected = new Map();
      for (const item of cart.items || []) {
        if (isBalloonUpgradeItem(item)) continue;
        const properties = item.properties || {};
        const group = String(properties['_Balloon group'] || '');
        const raw = String(properties['_Balloon upgrades'] || '');
        if (!group || !raw) continue;
        let upgrades = [];
        try { upgrades = JSON.parse(raw); } catch(e) { upgrades = []; }
        for (const upgrade of upgrades) {
          const variantId = Number(upgrade?.id || 0);
          const units = Math.max(1, Number(upgrade?.quantity || 1));
          if (!variantId) continue;
          expected.set(`${group}|${variantId}`, {
            id: variantId,
            quantity: units * Math.max(1, Number(item.quantity || 1)),
            properties: {
              'For balloon design': String(upgrade.design || 'Premium balloon design'),
              '_Balloon group': group,
              '_Balloon design charge': String(upgrade.charge || ''),
              '_Balloon units per set': String(units)
            }
          });
        }
      }

      const existing = new Map();
      for (const item of (cart.items || []).filter(isBalloonUpgradeItem)) {
        const group = String(item.properties?.['_Balloon group'] || '');
        existing.set(`${group}|${Number(item.variant_id || item.id || 0)}`, item);
      }
      let changed = false;
      const missing = [];
      for (const [key, spec] of expected) {
        const item = existing.get(key);
        if (!item) missing.push(spec);
        else if (Number(item.quantity || 0) !== spec.quantity) {
          await postJSON(root + 'cart/change.js', { id: item.key, quantity: spec.quantity });
          changed = true;
        }
      }
      if (missing.length) {
        await postJSON(root + 'cart/add.js', { items: missing });
        changed = true;
      }
      for (const [key, item] of existing) {
        if (expected.has(key)) continue;
        await postJSON(root + 'cart/change.js', { id: item.key, quantity: 0 });
        changed = true;
      }
      return changed;
    } catch (error) {
      console.warn('Dopamine balloon upgrade reconciliation failed', error);
      return false;
    }
  };

  // The cart page once loaded: balloon lines, then the fee line, in step with the cart the header
  // count read (one cart.js for all three, where it used to be five); a fix redraws the cart in
  // place instead of reloading the page.
  const reconcileCartOnLoad = async (cartPromise) => {
    if (!document.querySelector('[data-cart-section] [data-cart-form]')) return;
    let cart = await cartPromise;
    if (!cart) return;
    await cartWrites.run(async () => {
      let changed = await reconcileBalloonUpgradesInCart(cart);
      if (changed) cart = await getCart();
      changed = (await reconcileExactFeeInCart(cart)) || changed;
      if (changed) await refreshCartSection();
    }, { quiet: true }).catch(error => console.warn('Dopamine cart check on load failed', error));
  };

  const initProductGallery = (section, onChange) => {
    const viewport = section.querySelector('[data-product-gallery-viewport]');
    if (!viewport) return null;
    const gallery = viewport.closest('.product-gallery');
    const slides = Array.from(viewport.children);
    if (!slides.length) return null;
    const dots = Array.from(gallery.querySelectorAll('[data-product-gallery-thumb]'));
    const counter = gallery.querySelector('[data-gallery-counter]');
    const hover = window.matchMedia('(hover: hover) and (pointer: fine)');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const controller = new AbortController();
    const signal = controller.signal;
    let active = 0, timer = null, scrollFrame = null;
    const stop = () => { if (timer !== null) window.clearInterval(timer); timer = null; };
    const sync = (index) => {
      active = Math.max(0, Math.min(slides.length - 1, index));
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-current', i === active);
        if (i === active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (counter) counter.textContent = `${active + 1} / ${slides.length}`;
      onChange?.(slides[active]);
    };
    const show = (target, behavior = 'smooth') => {
      const index = slides.indexOf(target);
      if (index < 0) return;
      sync(index);
      viewport.scrollTo({ left: target.offsetLeft - slides[0].offsetLeft, behavior: reduced.matches ? 'auto' : behavior });
    };
    dots.forEach((dot, index) => dot.addEventListener('click', event => {
      event.preventDefault(); stop(); show(slides[index]);
    }, { signal }));
    gallery.querySelectorAll('[data-gallery-step]').forEach(button => button.addEventListener('click', () => {
      stop(); show(slides[(active + Number(button.dataset.galleryStep) + slides.length) % slides.length]);
    }, { signal }));
    const modelTrigger = gallery.querySelector('[data-product-3d-trigger]');
    modelTrigger?.addEventListener('click', event => {
      const model = slides.find(slide => slide.hasAttribute('data-product-model-slide'));
      if (model) { event.preventDefault(); stop(); show(model); }
    }, { signal });
    viewport.setAttribute('tabindex', '0');
    viewport.addEventListener('keydown', event => {
      if (event.target !== viewport || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault(); stop();
      show(slides[(active + (event.key === 'ArrowRight' ? 1 : -1) + slides.length) % slides.length]);
    }, { signal });
    viewport.addEventListener('scroll', () => {
      if (scrollFrame !== null) return;
      scrollFrame = window.requestAnimationFrame(() => {
        scrollFrame = null;
        const left = viewport.scrollLeft + slides[0].offsetLeft;
        const nearest = slides.reduce((best, slide, i) => Math.abs(slide.offsetLeft - left) < Math.abs(slides[best].offsetLeft - left) ? i : best, 0);
        sync(nearest);
      });
    }, { passive:true, signal });
    gallery.addEventListener('pointerenter', event => {
      stop();
      if (!hover.matches || reduced.matches || event.pointerType === 'touch' || slides.length < 2 || slides[active].hasAttribute('data-product-model-slide')) return;
      timer = window.setInterval(() => {
        if (document.hidden || !gallery.isConnected) return stop();
        const photos = slides.filter(slide => slide.hasAttribute('data-product-image-slide'));
        if (photos.length > 1) show(photos[(photos.indexOf(slides[active]) + 1) % photos.length]);
      }, 2200);
    }, { signal });
    gallery.addEventListener('pointerleave', stop, { signal });
    gallery.addEventListener('pointerdown', stop, { signal });
    gallery.addEventListener('focusin', stop, { signal });
    reduced.addEventListener('change', stop, { signal });
    document.addEventListener('visibilitychange', stop, { signal });
    const resize = new ResizeObserver(() => show(slides[active], 'auto'));
    resize.observe(viewport);
    section.addEventListener('shopify:section:unload', () => {
      stop(); resize.disconnect(); controller.abort();
      if (scrollFrame !== null) window.cancelAnimationFrame(scrollFrame);
    }, { once:true });
    // The caller selects the variant photo after initializing the product form.
    dots[0]?.classList.add('is-current');
    dots[0]?.setAttribute('aria-current', 'true');
    return { show };
  };

  // Product page, step "Delivery or pickup": the same-day line counts down to the 6 PM HST
  // cutoff (and names the next day after it), each minute and when the tab comes back.
  const initSameDayCountdown = (scope) => {
    const countdown = scope.querySelector('[data-same-day-countdown]');
    if (!countdown) return;
    const text = countdown.querySelector('[data-same-day-countdown-text]') || countdown;
    const copy = countdown.dataset;
    const update = () => {
      const result = sameDayCountdown({ copy: { open: copy.countdownOpen, local: copy.countdownLocal, closed: copy.countdownClosed, tomorrow: copy.countdownTomorrow } });
      text.textContent = result.text;
      countdown.classList.toggle('is-open', result.open);
    };
    update();
    const now = new Date();
    window.setTimeout(() => {
      update();
      window.setInterval(update, 60000);
    }, Math.max(1000, 60000 - (now.getSeconds() * 1000 + now.getMilliseconds()) + 50));
    document.addEventListener('visibilitychange', () => { if (!document.hidden) update(); });
  };

  // Floating Add to cart (owner, 2026-10-14: "the button should float at the bottom so nobody
  // has to look for it"). Pressing it presses the form's own Add button (the same checks, add-ons
  // popup and cart code; initProductForm decides what a press does). While it shows,
  // html.pdp-buybar-on keeps room under the page and lifts the Live chat bubble above it by
  // --pdp-buybar-lift (dopamine-rebrand.css, "Floating Add to cart").
  // Owner, 2026-10-14 (later): "the button is already visible and the floating bar overlaps it".
  // It never sits over the real button now: on phones it hides as soon as any part of the
  // quantity row + Add button ([data-pdp-buy]) is on screen; on computers (two columns, from
  // 981 px) as soon as any part of the buy box (the form) is, so it only shows once the shopper
  // has scrolled past the whole form.
  const initProductBuybar = (section, form) => {
    const bar = section.querySelector('[data-pdp-buybar]');
    const anchor = form.querySelector('[data-add-button]');
    if (!bar || !anchor) return null;
    const html = document.documentElement;
    const button = bar.querySelector('[data-buybar-add]');
    const labelEl = bar.querySelector('[data-buybar-label]') || button;
    const variantEl = bar.querySelector('[data-buybar-variant]');
    const priceEl = bar.querySelector('[data-buybar-price]');
    const compareEl = bar.querySelector('[data-buybar-compare]');
    const messageEl = bar.querySelector('[data-buybar-message]');
    const buyBlock = form.querySelector('[data-pdp-buy]') || anchor;
    // Phones (owner, 2026-10-14: the first screen must show the title, the price and the first
    // block): while the price is on screen the bar would only repeat it, so it waits until the
    // price has scrolled away.
    const priceRow = section.querySelector('.product-price-row');
    const wide = typeof window.matchMedia === 'function' ? window.matchMedia('(min-width: 981px)') : null;
    const onScreen = new Map();
    let pressHandler = null;
    const setLift = () => {
      if (!bar.hidden) html.style.setProperty('--pdp-buybar-lift', `${Math.ceil(bar.getBoundingClientRect().height)}px`);
    };
    const update = () => {
      const isWide = Boolean(wide && wide.matches);
      const watched = isWide ? form : buyBlock;
      const priceInView = Boolean(priceRow && onScreen.get(priceRow));
      // Phones: the Live chat bubble stays away from the first screen (it sat on the title).
      html.classList.toggle('pdp-first-screen', !isWide && priceInView);
      const show = !onScreen.get(watched) && (isWide || !priceInView);
      if (bar.hidden !== show) return;
      bar.hidden = !show;
      html.classList.toggle('pdp-buybar-on', show);
      setLift();
    };
    if ('IntersectionObserver' in window) {
      // Any part on screen counts (threshold 0, no margin): the bar is gone before it could cover it.
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => onScreen.set(entry.target, entry.isIntersecting));
        update();
      }, { threshold: 0 });
      observer.observe(buyBlock);
      if (buyBlock !== form) observer.observe(form);
      if (priceRow) observer.observe(priceRow);
      if (wide) {
        if (typeof wide.addEventListener === 'function') wide.addEventListener('change', update);
        else if (typeof wide.addListener === 'function') wide.addListener(update);
      }
    } else {
      update();
    }
    if ('ResizeObserver' in window) new ResizeObserver(setLift).observe(bar);
    window.addEventListener('resize', rafThrottle(setLift), { passive: true });
    button?.addEventListener('click', () => pressHandler?.());
    return {
      onPress(handler) { pressHandler = handler; },
      // The form button's words; the bar stays pressable while a step still needs an answer
      // (pressing it then shows that step), and only stops for sold out or while adding.
      mirror(text, _formButtonDisabled, { soldOut = false, busy = false } = {}) {
        if (labelEl) labelEl.textContent = text;
        if (button) button.disabled = Boolean(soldOut || busy);
      },
      price(priceText, compareText = '', variantLabel = '') {
        if (variantEl) {
          variantEl.textContent = variantLabel ? `${variantLabel} · ` : '';
        }
        if (priceEl) priceEl.textContent = priceText;
        if (compareEl) {
          compareEl.textContent = compareText;
          compareEl.hidden = !compareText;
        }
      },
      say(text) {
        if (!messageEl) return;
        messageEl.textContent = text || '';
        messageEl.hidden = !text;
        setLift();
      }
    };
  };

  // Design D2 (owner, 2026-10-14): one line under the size cards says how big the chosen size is
  // ("Small is about 8″ × 3″", snippets/product-size-step.liquid data-size-note on each radio).
  const initSizeNote = (form) => {
    const line = form.querySelector('[data-size-note-line]');
    if (!line) return;
    const update = () => {
      const chosen = form.querySelector('.pdp-step--size input[data-option-input]:checked');
      const text = (chosen && chosen.dataset.sizeNote) || '';
      line.textContent = text;
      line.hidden = !text;
    };
    form.addEventListener('change', (event) => {
      if (event.target && event.target.matches && event.target.matches('input[data-option-input]')) update();
    });
  };

  const initProductForm = (section) => {
    const form = section.querySelector('[data-product-form]');
    const productJSON = section.querySelector('[data-product-json]');
    if (!form || !productJSON) return;
    const modelSlides = Array.from(section.querySelectorAll('[data-product-model-slide]'));
    const activateModel = (slide) => {
      if (!slide) return;
      const viewer = slide.querySelector('model-viewer');
      if (viewer?.dopamineModelViewerUi?.play) viewer.dopamineModelViewerUi.play();
      else slide.dataset.activateModel = 'true';
    };
    if (modelSlides.length && window.Shopify?.loadFeatures) {
      window.Shopify.loadFeatures([{
        name: 'model-viewer-ui',
        version: '1.0',
        onLoad: (errors) => {
          if (errors || !window.Shopify?.ModelViewerUI) return;
          modelSlides.forEach((slide) => {
            const viewer = slide.querySelector('model-viewer');
            if (!viewer || viewer.dopamineModelViewerUi) return;
            viewer.dopamineModelViewerUi = new window.Shopify.ModelViewerUI(viewer);
            if (slide.dataset.activateModel === 'true') {
              viewer.dopamineModelViewerUi.play();
              delete slide.dataset.activateModel;
            }
          });
        }
      }]);
    }
    const modelTrigger = section.querySelector('[data-product-3d-trigger]');
    modelTrigger?.addEventListener('click', (event) => {
      const targetId = decodeURIComponent((modelTrigger.getAttribute('href') || '').replace(/^#/, ''));
      const target = targetId ? document.getElementById(targetId) : null;
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      activateModel(target);
      window.history.replaceState({}, '', `#${targetId}`);
    });
    const product = JSON.parse(productJSON.textContent);
    const hiddenId = form.querySelector('input[name="id"]');
    const priceEl = section.querySelector('[data-price]');
    const compareEl = section.querySelector('[data-compare]');
    const addButton = form.querySelector('[data-add-button]');
    const addButtonText = addButton?.querySelector('[data-add-button-text]');
    const message = section.querySelector('[data-form-message]');
    const signaturePicker = form.querySelector('[data-signature-letter]');
    const signatureInputs = Array.from(form.querySelectorAll('[data-signature-letter-input]'));
    const signatureStatus = form.querySelector('[data-signature-letter-status]');
    const balloonPicker = form.querySelector('[data-balloon-style]');
    const balloonInputs = Array.from(form.querySelectorAll('[data-balloon-style-input]'));
    const balloonStatus = form.querySelector('[data-balloon-style-status]');
    const directBalloonBuilder = form.querySelector('[data-balloon-builder-source][data-balloon-context="direct-product"]');
    const addonBalloonBuilder = form.querySelector('[data-balloon-builder-source][data-balloon-context="product-addon"]');
    const directVaseBuilder = form.querySelector('[data-vase-builder-source][data-vase-context="direct-product"]');
    const addonVaseBuilder = form.querySelector('[data-vase-builder-source][data-vase-context="product-addon"]');
    const addonPlushPicker = form.querySelector('[data-plush-picker-source][data-plush-context="product-addon"]');
    // Balloon set page: step 1 is "Choose your balloons", a button that opens the builder.
    const balloonStepButton = form.querySelector('[data-pdp-balloon-open]');
    const balloonStepSummary = form.querySelector('[data-pdp-balloon-summary]');
    const galleryViewport = section.querySelector('[data-product-gallery-viewport]');
    const imageSlides = Array.from(section.querySelectorAll('[data-product-image-slide]'));
    const galleryThumbs = Array.from(section.querySelectorAll('[data-product-gallery-thumb]'));
    let productGallery = null;
    // Balloons or a lettered vase chosen in "Add a gift" go into the cart through the add-ons
    // popup that opens after Add to cart (it shows them picked, Continue adds them). Closed with
    // ×, the backdrop or Escape instead, the popup dropped them although the shopper had chosen
    // them on the page (audit 2026-10-25): they are added then, and the form says so.
    let pageGiftsWaiting = false;
    const addPageGiftsOnDismiss = async () => {
      if (!pageGiftsWaiting) return;
      pageGiftsWaiting = false;
      const balloonItem = addonBalloonBuilder?._balloonItem || null;
      const vaseItem = addonVaseBuilder?._vaseItem || null;
      const items = [
        ...(balloonItem ? balloonCartItems(balloonItem) : []),
        ...(vaseItem ? [{ id: Number(vaseItem.id), quantity: 1, properties: vaseItem.properties }] : [])
      ];
      if (!items.length) return;
      const what = balloonItem && vaseItem ? 'Your balloons and lettered vase' : (balloonItem ? 'Your balloons' : 'Your lettered vase');
      try {
        measureItemsAdded(await postJSON(root + 'cart/add.js', { items }));
        await refreshCartCount();
        say(`${what} ${balloonItem ? 'are' : 'is'} in the cart with the flowers.`);
      } catch (error) {
        const reason = cartErrorDescription(error);
        say(`The flowers are in the cart, but ${what.toLowerCase()} could not be added${reason ? `: ${reason.replace(/\.$/, '')}` : ''}. Please choose again.`);
      }
    };
    const modal = initAddonsModal(section, { onDismiss: addPageGiftsOnDismiss });
    initSameDayCountdown(section);
    const buybar = initProductBuybar(section, form);
    initSizeNote(form);
    // Shown at the form's message and, while the form is off screen, on the floating bar too.
    const say = (text) => {
      if (message) message.textContent = text || '';
      buybar?.say(text);
    };
    const optionFieldsets = Array.from(form.querySelectorAll('[data-option-index]'));
    const currentOptions = () => optionFieldsets.map(fs => {
      const checked = fs.querySelector('input[type="radio"]:checked');
      return checked ? checked.value : null;
    });
    const findVariant = () => {
      if (!optionFieldsets.length) return product.variants.find(v => String(v.id) === String(hiddenId.value)) || product.variants.find(v => v.available) || product.variants[0];
      const opts = currentOptions();
      return product.variants.find(v => v.options.every((value, index) => value === opts[index]));
    };
    const variantRoleKey = (value) => String(value || '')
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
    const variantRoleKeys = (variant) => {
      if (!variant) return [];
      const values = [...(variant.options || []), variant.title || ''];
      return [...new Set(values.map(variantRoleKey).filter(Boolean))];
    };
    const variantImageIds = (variant) => {
      if (!variant) return [];
      const ids = [
        variant.featured_media?.id,
        variant.featured_media?.preview_image?.id,
        variant.featured_image?.id,
        variant.image_id
      ];
      return [...new Set(ids.map(value => value == null ? '' : String(value)).filter(Boolean))];
    };
    const variantDisplayLabel = (variant) => {
      if (!variant) return '';
      const options = (variant.options || [])
        .map(value => String(value || '').trim())
        .filter(value => value && !/^default title$/i.test(value));
      const label = options.length ? options.join(' / ') : String(variant.title || '').trim();
      return /^default title$/i.test(label) ? '' : label;
    };
    const slideMatchesVariant = (slide, variant) => {
      if (!slide || !variant) return false;
      const imageIds = variantImageIds(variant);
      if (imageIds.some(id => id === String(slide.dataset.mediaId || '') || id === String(slide.dataset.imageId || ''))) return true;
      const role = variantRoleKey(slide.dataset.mediaRole || '');
      return Boolean(role && variantRoleKeys(variant).includes(role));
    };
    const variantSlide = (variant) => {
      if (!variant || !imageSlides.length) return null;
      const imageIds = variantImageIds(variant);
      if (imageIds.length) {
        const byImage = imageSlides.find(slide => imageIds.includes(String(slide.dataset.mediaId || '')) || imageIds.includes(String(slide.dataset.imageId || '')));
        if (byImage) return byImage;
      }
      const roles = variantRoleKeys(variant);
      if (roles.length) {
        const byRole = imageSlides.find(slide => roles.includes(variantRoleKey(slide.dataset.mediaRole || '')));
        if (byRole) return byRole;
      }
      return null;
    };
    const setCurrentProductSlide = (target, behavior = 'smooth') => {
      if (!target) return;
      if (productGallery) { productGallery.show(target, behavior); return; }
      if (galleryViewport) galleryViewport.scrollTo({ left: target.offsetLeft, behavior });
      galleryThumbs.forEach((thumb) => {
        const isCurrent = Number(thumb.dataset.mediaIndex) === Number(target.dataset.mediaIndex);
        thumb.classList.toggle('is-current', isCurrent);
        if (isCurrent) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
    };
    const updateVariantBadge = (variant, targetSlide = null) => {
      const label = variantDisplayLabel(variant);
      imageSlides.forEach(slide => {
        const badge = slide.querySelector('[data-product-media-badge]');
        if (!badge) return;
        if (label && slide === targetSlide && slideMatchesVariant(slide, variant)) {
          badge.textContent = label;
          badge.hidden = false;
        } else {
          badge.hidden = true;
        }
      });
    };
    const showVariantPhoto = (variant, behavior = 'smooth') => {
      const target = variantSlide(variant);
      if (!target) {
        updateVariantBadge(variant, null);
        return;
      }
      setCurrentProductSlide(target, behavior);
      updateVariantBadge(variant, target);
    };
    const selectedBalloonStyle = () => {
      const selected = balloonInputs.find(input => input.checked);
      return selected ? String(selected.dataset.balloonStyleKey || selected.value || '').toLowerCase() : '';
    };
    const balloonVariant = (style) => {
      if (!style) return null;
      const needle = style.toLowerCase();
      return product.variants.find((variant) => {
        const values = [...(variant.options || []), variant.title || ''];
        return values.some(value => String(value).toLowerCase().includes(needle));
      }) || product.variants[0] || null;
    };
    const balloonStyleFromVariant = (variant) => {
      if (!variant) return '';
      const values = [...(variant.options || []), variant.title || ''].map(value => String(value || '').toLowerCase());
      return ['congratulations', 'love', 'birthday', 'neutral'].find(style => values.some(value => value.includes(style))) || '';
    };
    const selectVariantInputs = (variant) => {
      if (!variant) return;
      optionFieldsets.forEach((fieldset, index) => {
        const desiredValue = variant.options?.[index];
        const matchingInput = Array.from(fieldset.querySelectorAll('[data-option-input]')).find(input => input.value === desiredValue);
        if (matchingInput) matchingInput.checked = true;
      });
    };
    const showBalloonPhoto = (style, behavior = 'smooth') => {
      if (!style || !galleryViewport || !imageSlides.length) return;
      const marker = `balloon-style-${style}`;
      let targetIndex = imageSlides.findIndex(slide => String(slide.dataset.mediaAlt || '').includes(marker));
      if (targetIndex < 0) {
        const fallbackMap = imageSlides.length >= 4
          ? { neutral: 0, birthday: 1, love: 2, congratulations: 3 }
          : { neutral: 0, birthday: 0, love: 1, congratulations: Math.min(2, imageSlides.length - 1) };
        targetIndex = fallbackMap[style] ?? 0;
      }
      const target = imageSlides[Math.max(0, Math.min(targetIndex, imageSlides.length - 1))];
      if (!target) return;
      setCurrentProductSlide(target, behavior);
      updateVariantBadge(findVariant(), target);
    };
    const syncBalloonPicker = () => {
      if (!balloonPicker) return;
      const style = selectedBalloonStyle();
      balloonPicker.classList.toggle('has-selection', Boolean(style));
      if (balloonStatus && style) {
        const selectedInput = balloonInputs.find(input => input.checked);
        const label = selectedInput?.value || style;
        const template = balloonStatus.dataset.selectedTemplate || '[style] balloons selected.';
        balloonStatus.textContent = template.replace('[style]', label);
      }
    };
    const selectedSignatureLetter = () => {
      const selected = signatureInputs.find(input => input.checked);
      return selected ? selected.value : '';
    };
    const syncSignaturePicker = () => {
      if (!signaturePicker) return;
      const letter = selectedSignatureLetter();
      signaturePicker.classList.toggle('has-selection', Boolean(letter));
      if (signatureStatus) {
        const requiredText = signatureStatus.dataset.requiredText || 'Choose one letter to continue.';
        const selectedTemplate = signatureStatus.dataset.selectedTemplate || 'Letter [letter] selected.';
        signatureStatus.textContent = letter ? selectedTemplate.replace('[letter]', letter) : requiredText;
      }
    };
    const syncAddButton = (variant) => {
      if (!addButton) return;
      const setLabel = (label) => {
        if (addButtonText) addButtonText.textContent = label;
        else addButton.textContent = label;
        // The floating bar shows the same words and state as the form's own button.
        buybar?.mirror(label, addButton.disabled, { soldOut: !variant || variant.available === false });
      };
      if (!variant || variant.available === false) {
        addButton.disabled = true;
        setLabel(variant ? (section.dataset.mobileSoldOutLabel || 'Sold out') : 'Unavailable');
        return;
      }
      const needsSignature = signatureInputs.length > 0 && !selectedSignatureLetter();
      const needsBalloonStyle = balloonInputs.length > 0 && !selectedBalloonStyle();
      const needsBalloonBuilder = Boolean(directBalloonBuilder && !directBalloonBuilder._balloonItem);
      const needsVaseBuilder = Boolean(directVaseBuilder && !directVaseBuilder._vaseItem);
      addButton.disabled = needsSignature || needsBalloonStyle || needsVaseBuilder;
      setLabel(needsSignature
        ? (addButton.dataset.signatureLabel || 'Choose a letter')
        : needsBalloonBuilder
          ? (balloonStepButton?.textContent.trim() || 'Choose balloons')
        : needsVaseBuilder
          ? 'Add your words'
        : (addButton.dataset.addDefaultLabel || 'Add to cart'));
    };
    // The step that still needs an answer, brought into view and outlined for a moment.
    const showStep = (element, focusTarget = null) => {
      const step = element?.closest?.('[data-pdp-step]') || element;
      if (!step) return;
      step.classList.remove('is-attention');
      void step.offsetWidth;
      step.classList.add('is-attention');
      window.setTimeout(() => step.classList.remove('is-attention'), 2600);
      step.scrollIntoView({ behavior: 'smooth', block: 'center' });
      focusTarget?.focus({ preventScroll: true });
    };
    const updateVariant = (overrideVariant = null, options = {}) => {
      const variant = overrideVariant || findVariant();
      if (!variant) {
        syncAddButton(null);
        updateVariantBadge(null, null);
        return;
      }
      hiddenId.value = variant.id;
      const priceText = directBalloonBuilder
        ? (directBalloonBuilder._balloonItem ? money(directBalloonBuilder._balloonItem.price) : `From ${money(variant.price)}`)
        : money(variant.price);
      const compareText = !directBalloonBuilder && variant.compare_at_price && variant.compare_at_price > variant.price ? money(variant.compare_at_price) : '';
      if (priceEl) priceEl.textContent = priceText;
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) { compareEl.textContent = money(variant.compare_at_price); compareEl.hidden = false; }
        else { compareEl.hidden = true; }
      }
      buybar?.price(priceText, compareText, optionFieldsets.length ? variantDisplayLabel(variant) : '');
      syncAddButton(variant);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
      showVariantPhoto(variant, options.behavior || 'smooth');
    };
    form.addEventListener('change', (event) => {
      if (event.target.matches('[data-option-input]')) updateVariant(null, { behavior: 'smooth' });
      if (event.target.matches('[data-signature-letter-input]')) {
        syncSignaturePicker();
        syncAddButton(findVariant());
      }
      if (event.target.matches('[data-balloon-style-input]')) {
        const style = selectedBalloonStyle();
        const variant = balloonVariant(style);
        selectVariantInputs(variant);
        syncBalloonPicker();
        updateVariant(variant, { behavior: 'smooth' });
      }
    });
    productGallery = initProductGallery(section, target => updateVariantBadge(findVariant(), target));
    form.addEventListener('balloon:configured', (event) => {
      if (event.target === directBalloonBuilder && balloonStepButton) {
        const item = directBalloonBuilder._balloonItem;
        if (balloonStepSummary) balloonStepSummary.textContent = item ? `${item.count} balloons · ${money(item.price)}` : (balloonStepSummary.dataset.defaultText || '');
        if (!balloonStepButton.dataset.defaultLabel) balloonStepButton.dataset.defaultLabel = balloonStepButton.textContent.trim();
        balloonStepButton.textContent = item ? (balloonStepButton.dataset.editLabel || 'Change balloons') : balloonStepButton.dataset.defaultLabel;
      }
      syncAddButton(findVariant());
    });
    balloonStepButton?.addEventListener('click', () => directBalloonBuilder?.querySelector('[data-balloon-configure]')?.click());
    form.addEventListener('vase:configured', () => syncAddButton(findVariant()));
    // The floating bar's button when the form's own button cannot be pressed yet: take the
    // shopper to the step that needs an answer instead of doing nothing.
    const showMissingStep = () => {
      if (signatureInputs.length && !selectedSignatureLetter()) {
        syncSignaturePicker();
        say(signatureStatus?.dataset.requiredText || 'Choose one letter to continue.');
        showStep(signaturePicker, signatureInputs[0]);
        return true;
      }
      if (directBalloonBuilder && !directBalloonBuilder._balloonItem) {
        directBalloonBuilder.querySelector('[data-balloon-configure]')?.click();
        return true;
      }
      return false;
    };
    buybar?.onPress(() => {
      if (addButton && !addButton.disabled) addButton.click();
      else showMissingStep();
    });
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      say('');
      if (signatureInputs.length && !selectedSignatureLetter()) {
        syncSignaturePicker();
        syncAddButton(findVariant());
        say(signatureStatus?.dataset.requiredText || 'Choose one letter to continue.');
        showStep(signaturePicker, signatureInputs[0]);
        return;
      }
      if (balloonInputs.length && !selectedBalloonStyle()) {
        syncBalloonPicker();
        syncAddButton(findVariant());
        showStep(balloonPicker, balloonInputs[0]);
        return;
      }
      if (directBalloonBuilder && !directBalloonBuilder._balloonItem) {
        directBalloonBuilder.querySelector('[data-balloon-configure]')?.click();
        return;
      }
      if (directVaseBuilder && !directVaseBuilder._vaseItem) {
        directVaseBuilder.querySelector('[data-vase-configure]')?.click();
        return;
      }
      if (addButton) {
        addButton.disabled = true;
        if (addButtonText) addButtonText.textContent = 'Adding...';
        else addButton.textContent = 'Adding...';
        buybar?.mirror(section.dataset.mobileAddingLabel || 'Adding...', true, { busy: true });
      }
      const plushItems = addonPlushPicker?._plushItems?.length ? addonPlushPicker._plushItems : null;
      try {
        const formData = new FormData(form);
        if (addonVaseBuilder?._vaseItem) {
          const item = addonVaseBuilder._vaseItem;
          const pairing = JSON.parse(item.properties['_Vase pairing']);
          pairing.targetVariantId = String(formData.get('id') || '');
          item.properties['_Vase pairing'] = JSON.stringify(pairing);
        }
        if (directBalloonBuilder?._balloonItem) {
          formData.set('id', String(directBalloonBuilder._balloonItem.id));
          Object.entries(directBalloonBuilder._balloonItem.properties || {}).forEach(([name, value]) => {
            formData.set(`properties[${name}]`, String(value));
          });
        }
        if (directVaseBuilder?._vaseItem) {
          formData.set('id', String(directVaseBuilder._vaseItem.id));
          Object.entries(directVaseBuilder._vaseItem.properties || {}).forEach(([name, value]) => {
            formData.set(`properties[${name}]`, String(value));
          });
        }
        let addedItem;
        if (directBalloonBuilder?._balloonItem) {
          const properties = {};
          for (const [name, value] of formData.entries()) {
            const match = String(name).match(/^properties\[(.+)\]$/);
            if (match && String(value).trim()) properties[match[1]] = String(value);
          }
          const balloonItem = {
            ...directBalloonBuilder._balloonItem,
            properties: { ...directBalloonBuilder._balloonItem.properties, ...properties }
          };
          addedItem = await postJSON(root + 'cart/add.js', {
            items: balloonCartItems(balloonItem, formData.get('quantity'))
          });
        } else if (plushItems) {
          // Flowers and plush friends in one request: Shopify adds all of it or nothing, so
          // a friend that sold out a moment ago never leaves the flowers in the cart alone.
          const properties = {};
          for (const [name, value] of formData.entries()) {
            const match = String(name).match(/^properties\[(.+)\]$/);
            if (match && String(value).trim()) properties[match[1]] = String(value);
          }
          addedItem = await postJSON(root + 'cart/add.js', {
            items: [
              { id: Number(formData.get('id')), quantity: Math.max(1, Number.parseInt(formData.get('quantity'), 10) || 1), properties },
              ...plushItems
            ]
          });
          markPlushAdded(addonPlushPicker);
        } else {
          const res = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: formData });
          if (!res.ok) throw new Error(await res.text());
          addedItem = await res.json();
        }
        measureItemsAdded(addedItem);
        if (addonBalloonBuilder?._balloonItem && !modal) {
          const balloonItem = addonBalloonBuilder._balloonItem;
          const balloonAdded = await postJSON(root + 'cart/add.js', {
            items: balloonCartItems(balloonItem)
          });
          measureItemsAdded(balloonAdded);
        }
        if (addonVaseBuilder?._vaseItem && !modal) {
          const vaseItem = addonVaseBuilder._vaseItem;
          const vaseAdded = await postJSON(root + 'cart/add.js', {
            items: [{ id: Number(vaseItem.id), quantity: 1, properties: vaseItem.properties }]
          });
          measureItemsAdded(vaseAdded);
        }
        // The day and the time window are chosen in the cart's "When" step.
        await refreshCartCount();
        if (modal) {
          pageGiftsWaiting = Boolean(addonBalloonBuilder?._balloonItem || addonVaseBuilder?._vaseItem);
          modal.open();
        } else window.location.href = withCampaignParams(root + 'cart');
      } catch(e) {
        const reason = plushItems ? cartErrorDescription(e) : '';
        say(plushItems
          ? `Nothing was added${reason ? `: ${reason.replace(/\.$/, '')}` : ''}. A plush friend may have just sold out; choose again in Plush friends.`
          : 'Could not add this item. Please refresh and try again.');
      } finally {
        updateVariant(null, { behavior: 'auto' });
      }
    });
    syncSignaturePicker();
    syncBalloonPicker();
    if (balloonInputs.length) {
      const variant = findVariant() || balloonVariant(selectedBalloonStyle() || 'neutral');
      const style = balloonStyleFromVariant(variant) || selectedBalloonStyle() || 'neutral';
      const matchingStyleInput = balloonInputs.find(input => String(input.dataset.balloonStyleKey || '').toLowerCase() === style);
      if (matchingStyleInput) matchingStyleInput.checked = true;
      selectVariantInputs(variant);
      syncBalloonPicker();
      updateVariant(variant, { behavior: 'auto' });
    } else {
      updateVariant(null, { behavior: 'auto' });
    }
    const viewedVariant = findVariant();
    if (viewedVariant) {
      measureOpenAIPixel('contents_viewed', {
        type: 'contents',
        amount: Math.round(Number(viewedVariant.price || 0)),
        currency,
        contents: [{
          id: String(viewedVariant.id),
          name: product.title,
          content_type: 'product',
          quantity: 1,
          amount: Math.round(Number(viewedVariant.price || 0)),
          currency
        }]
      });
    }
  };

  // Quantity − / +: on the product page the box simply changes; on the cart the line changes in
  // place (queueCartLineQuantity below): at once on screen, saved a moment later, so a few quick
  // taps are one request.
  document.addEventListener('click', async (event) => {
    const plus = event.target.closest('[data-qty-plus]');
    const minus = event.target.closest('[data-qty-minus]');
    if (!plus && !minus) return;
    const wrap = event.target.closest('[data-qty-control]');
    const input = wrap && wrap.querySelector('input');
    if (!input) return;
    const step = plus ? 1 : -1;
    const min = Number(input.min || 0);
    const nextQty = Math.max(min, Number(input.value || 0) + step);
    input.value = nextQty;
    const line = event.target.closest('[data-cart-line]');
    const key = (wrap && wrap.dataset.cartLineKey) || (line && line.dataset.lineKey);
    if (!key || !line) {
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    event.preventDefault();
    // The form hears that something changed (Checkout saves again); the line itself is saved here.
    input.dispatchEvent(new Event('input', { bubbles: true }));
    queueCartLineQuantity(line, key, nextQty);
  });

  // ---- The cart changes in place (owner, 2026-10-14: "choosing a time reloads the whole page",
  // "removing something freezes"). A time, a quantity or a removal is one Ajax Cart API request
  // (two when the time-window fee line is added or relabelled) that also brings back this
  // section's new HTML (Shopify's Section Rendering API, `sections`). Only the lines, the totals
  // and the free-delivery meter are swapped, so scroll, focus and anything typed stay. Writes go
  // one at a time, in order, as Shopify's cart expects; "Updating…" shows on the total meanwhile.
  const cartSectionElement = () => document.querySelector('[data-cart-section]');
  const cartSectionId = () => cartSectionElement()?.dataset.sectionId || '';
  const isCartJson = (data) => Boolean(data && Array.isArray(data.items) && 'item_count' in data);

  let cartBusyHolds = 0;
  const showCartBusy = () => {
    const section = cartSectionElement();
    if (!section) return;
    const busy = cartBusyHolds > 0;
    const summary = section.querySelector('.cart-summary');
    if (summary) {
      summary.classList.toggle('is-updating', busy);
      if (busy) summary.setAttribute('aria-busy', 'true');
      else summary.removeAttribute('aria-busy');
    }
    section.querySelectorAll('[data-cart-updating]').forEach(el => { el.hidden = !busy; });
  };
  const holdCartBusy = () => {
    let held = true;
    cartBusyHolds += 1;
    showCartBusy();
    return () => {
      if (!held) return;
      held = false;
      cartBusyHolds -= 1;
      showCartBusy();
    };
  };

  let cartWriteChain = Promise.resolve();
  const cartWrites = {
    // quiet: no "Updating…" (a saved day does not change the total).
    run(task, { quiet = false } = {}) {
      const release = quiet ? () => {} : holdCartBusy();
      const result = cartWriteChain.then(task);
      cartWriteChain = result.catch(() => {}).then(release);
      return result;
    },
    idle() { return cartWriteChain; }
  };

  // POST to the Ajax Cart API; Shopify's own refusal ("description") becomes the error's message.
  const cartRequest = async (path, body) => {
    const isForm = typeof FormData !== 'undefined' && body instanceof FormData;
    const res = await fetch(root + path, {
      method: 'POST',
      headers: isForm ? { 'Accept': 'application/json' } : { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: isForm ? body : JSON.stringify(body)
    });
    const data = await res.json().catch(() => null);
    if (!res.ok) {
      const error = new Error((data && (data.description || data.message)) || `Cart request failed (${res.status})`);
      error.status = res.status;
      throw error;
    }
    return data || {};
  };

  // Asks Shopify to send this section's new HTML with its answer, drawn for this cart page.
  const withCartSections = (payload) => {
    const id = cartSectionId();
    if (!id) return payload;
    if (typeof FormData !== 'undefined' && payload instanceof FormData) {
      payload.append('sections', id);
      payload.append('sections_url', window.location.pathname);
      return payload;
    }
    return { ...payload, sections: id, sections_url: window.location.pathname };
  };

  const adoptedChildren = (node) => Array.from(node.childNodes).map(child => document.adoptNode(child));

  // The lines: a line that stays keeps its picture (no flash of a photo decoded again), and focus
  // goes back to the same button of the same line (to the list when the line is gone).
  const swapCartLines = (current, next) => {
    const active = document.activeElement;
    const activeLine = active && current.contains(active) ? active.closest('.cart-line[data-line-key]') : null;
    const role = activeLine ? ['[data-qty-minus]', '[data-qty-plus]', '[data-cart-qty-input]', '.remove-link'].find(selector => active.matches(selector)) : null;
    const pictures = new Map();
    current.querySelectorAll('.cart-line[data-line-key]').forEach(line => pictures.set(line.dataset.lineKey, line.querySelector('.cart-line__media')));
    const holder = document.createElement('div');
    holder.append(...adoptedChildren(next));
    const pictureSrc = media => (media && media.querySelector('img') ? media.querySelector('img').getAttribute('src') : '');
    holder.querySelectorAll('.cart-line[data-line-key]').forEach(line => {
      const old = pictures.get(line.dataset.lineKey);
      const fresh = line.querySelector('.cart-line__media');
      if (old && fresh && pictureSrc(old) === pictureSrc(fresh)) fresh.replaceWith(old);
    });
    current.replaceChildren(...Array.from(holder.childNodes));
    if (!activeLine) return;
    const again = Array.from(current.querySelectorAll('.cart-line[data-line-key]')).find(line => line.dataset.lineKey === activeLine.dataset.lineKey);
    ((again && role && again.querySelector(role)) || current).focus({ preventScroll: true });
  };

  const replaceFromSection = (selector, scope, next) => {
    const now = scope.querySelector(selector);
    const fresh = next.querySelector(selector);
    if (now && fresh) now.replaceWith(document.adoptNode(fresh));
  };

  // Draws the cart from the section HTML Shopify sent back. false: nothing to draw.
  const renderCartSection = (html, cart = null) => {
    const section = cartSectionElement();
    if (!section || !html) return false;
    const next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-section]');
    if (!next) return false;
    ['data-has-custom-vase', 'data-vase-target-ready', 'data-exact-fee-variant'].forEach(name => section.setAttribute(name, next.getAttribute(name) || ''));
    const form = section.querySelector('[data-cart-form]');
    const nextForm = next.querySelector('[data-cart-form]');
    if (!form || !nextForm) {
      // Nothing left in the cart: its empty state, as a reload would show it.
      section.replaceChildren(...adoptedChildren(next));
    } else {
      const lines = form.querySelector('.cart-lines');
      const nextLines = nextForm.querySelector('.cart-lines');
      if (lines && nextLines) swapCartLines(lines, nextLines);
      replaceFromSection('[data-cart-totals]', form, nextForm);
      replaceFromSection('.cart-summary [data-free-delivery-meter]', form, nextForm);
      // The add-ons popup lives under <body> (initAddonsModal moved it): its meter gets the new subtotal.
      const nextModalMeter = next.querySelector('.free-delivery-meter--modal');
      document.querySelectorAll('[data-cart-addon-modal] [data-free-delivery-meter]').forEach(meter => {
        if (nextModalMeter) meter.dataset.currentSubtotal = nextModalMeter.dataset.currentSubtotal || '0';
        updateFreeDeliveryMeter(meter);
      });
    }
    showCartBusy();
    const fullCart = isCartJson(cart) ? cart : null;
    if (fullCart) document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = displayCartCount(fullCart); });
    // The first-order note (snippets/first-order-popup.liquid) says again what is left to the minimum.
    document.dispatchEvent(new CustomEvent('df:cart-updated', { detail: { cart: fullCart } }));
    return true;
  };

  const refreshCartSection = async () => {
    const id = cartSectionId();
    if (!id) return false;
    const [sections, cart] = await Promise.all([
      fetch(`${root}cart?sections=${encodeURIComponent(id)}`, { headers: { 'Accept': 'application/json' } }).then(res => (res.ok ? res.json() : null)),
      getCart().catch(() => null)
    ]);
    return renderCartSection(sections && sections[id], cart);
  };

  // A change's answer: draw the section Shopify sent with it, or ask for it when none came.
  const showCartAnswer = async (answer) => {
    const id = cartSectionId();
    if (!renderCartSection(answer && answer.sections && answer.sections[id], answer)) await refreshCartSection();
  };

  const sayCartLinesProblem = (text) => {
    const status = document.querySelector('[data-cart-section] [data-cart-lines-status]');
    if (!status) return;
    status.textContent = text || '';
    status.hidden = !text;
  };

  // A line on its way out fades and folds up while the cart saves.
  const foldCartLine = (line) => {
    if (!line || line.classList.contains('is-removing')) return;
    line.style.height = `${line.offsetHeight}px`;
    line.classList.add('is-removing');
    void line.offsetHeight;
    window.requestAnimationFrame(() => line.classList.add('is-folded'));
  };
  const unfoldCartLine = (line) => {
    line.classList.remove('is-removing', 'is-folded', 'is-pending');
    line.style.height = '';
  };

  // The quantities to send: a balloon set takes its premium-design lines with it, and the
  // time-window fee goes when nothing else is left (it never stays alone in a cart).
  const cartLineUpdates = (form, quantities) => {
    const updates = { ...quantities };
    const lineInputs = Array.from(form.querySelectorAll('.cart-lines [data-line-key]'));
    Object.entries(quantities).forEach(([key, quantity]) => {
      if (Number(quantity) > 0) return;
      const set = lineInputs.find(el => el.matches('[data-balloon-line]') && el.dataset.lineKey === key);
      const group = set && set.dataset.balloonGroup;
      if (group) lineInputs.filter(el => el.matches('[data-balloon-line]') && el.dataset.balloonGroup === group).forEach(el => { updates[el.dataset.lineKey] = 0; });
    });
    const left = lineInputs.filter(el => !el.matches('[data-exact-fee-line]')).map(el => el.dataset.lineKey)
      .filter(key => !Object.prototype.hasOwnProperty.call(updates, key) || Number(updates[key]) > 0);
    if (!left.length) lineInputs.filter(el => el.matches('[data-exact-fee-line]')).forEach(el => { updates[el.dataset.lineKey] = 0; });
    return updates;
  };

  const pendingLineQuantities = new Map();
  let lineFlushTimer = 0;
  let lineFlushHold = null;

  const flushCartLines = async () => {
    const form = document.querySelector('[data-cart-section] [data-cart-form]');
    const quantities = Object.fromEntries(pendingLineQuantities);
    pendingLineQuantities.clear();
    if (!form || !Object.keys(quantities).length) return;
    const updates = cartLineUpdates(form, quantities);
    // What was typed (recipient, card, day, note) goes along, so it is kept if the shopper leaves.
    const formData = cartFormData(form, { quantities: false });
    Object.entries(updates).forEach(([key, quantity]) => formData.append(`updates[${key}]`, String(quantity)));
    try {
      await showCartAnswer(await cartRequest('cart/update.js', withCartSections(formData)));
    } catch (error) {
      console.warn('Dopamine cart line change failed', error);
      form.querySelectorAll('.cart-line[data-line-key]').forEach(line => {
        if (!Object.prototype.hasOwnProperty.call(quantities, line.dataset.lineKey)) return;
        unfoldCartLine(line);
        const input = line.querySelector('[data-cart-qty-input]');
        if (input && line.dataset.lineQuantity) input.value = line.dataset.lineQuantity;
      });
      // Shopify's own words when it refuses a quantity ("only 2 left"), otherwise ours.
      sayCartLinesProblem(error.status === 422 && error.message ? error.message : (cartSectionElement()?.dataset.updateFailed || 'We could not update your cart. Please check your connection and try again.'));
    }
  };

  const startCartLineFlush = () => {
    window.clearTimeout(lineFlushTimer);
    lineFlushTimer = 0;
    const release = lineFlushHold;
    lineFlushHold = null;
    const done = cartWrites.run(flushCartLines);
    if (release) release();
    return done;
  };

  // − / +, a typed quantity and Remove: the line changes on screen at once and a few quick taps
  // become one save (350 ms after the last); 0 removes the line.
  const queueCartLineQuantity = (line, key, quantity) => {
    if (!line.closest('[data-cart-form]')) return;
    sayCartLinesProblem('');
    const next = Math.max(0, Math.floor(Number(quantity) || 0));
    pendingLineQuantities.set(key, next);
    if (next === 0) foldCartLine(line);
    else line.classList.add('is-pending');
    if (!lineFlushHold) lineFlushHold = holdCartBusy();
    window.clearTimeout(lineFlushTimer);
    lineFlushTimer = window.setTimeout(startCartLineFlush, next === 0 ? 0 : 350);
  };

  // Checkout and the add-ons popup wait for every change still on its way.
  const settleCartWrites = async () => {
    if (lineFlushTimer || pendingLineQuantities.size) await startCartLineFlush().catch(() => {});
    await cartWrites.idle();
  };

  // Remove: the line fades and folds at once. The link stays the way without JavaScript.
  document.addEventListener('click', (event) => {
    const remove = event.target.closest('[data-cart-form] a.remove-link');
    if (!remove || event.defaultPrevented || event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const line = remove.closest('[data-cart-line]');
    const key = line && line.dataset.lineKey;
    if (!key || !cartSectionId()) return;
    event.preventDefault();
    queueCartLineQuantity(line, key, 0);
  });

  // "Is this a gift?" switched off: what was typed stays in the hidden fields (switching it back on
  // brings it back), but the cart saves the gift fields blank and "Is a gift" as No, so the order
  // is not a gift and no card or envelope is printed (audit 2026-10-12).
  // One "Is a gift" value either way (the hidden "No" and the ticked "Yes" share the name).
  const GIFT_ATTRIBUTE_NAMES = ['Recipient name', 'Gift message', 'Gift from', 'Gift anonymous'];
  const applyGiftChoice = (form, formData) => {
    const toggle = form && form.querySelector('[data-gift-order-toggle]');
    if (!toggle) return formData;
    if (toggle.checked) {
      formData.set('attributes[Is a gift]', 'Yes');
      return formData;
    }
    GIFT_ATTRIBUTE_NAMES.forEach(name => formData.set(`attributes[${name}]`, ''));
    formData.set('attributes[Is a gift]', 'No');
    return formData;
  };

  // The cart form as Shopify should save it. quantities: false leaves the quantity boxes out:
  // Shopify matches updates[] to cart lines by position, so once the add-ons popup has added a
  // line those positions are stale.
  const cartFormData = (form, { quantities = true } = {}) => {
    const formData = applyGiftChoice(form, new FormData(form));
    if (!quantities) formData.delete('updates[]');
    return formData;
  };

  // Saves recipient, gift message, delivery date and note before checkout. A failed save
  // must stop checkout: otherwise the order arrives without those details. sections: also bring
  // back the cart section's new HTML ("Update cart" redraws the cart in place).
  const updateCartFromForm = async (form, options = {}) => {
    if (!form) return null;
    const formData = cartFormData(form, options);
    if (options.sections) withCartSections(formData);
    const res = await fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: formData });
    if (!res.ok) throw new Error(`Cart update failed (${res.status})`);
    return res.json();
  };

  const isoLocal = (date) => {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  };

  const deliveryTimeZone = 'Pacific/Honolulu';
  const sameDayCutoffHour = 18;
  const CLOSED_FULFILLMENT_DATES = Object.freeze(['2026-10-25']);
  const isClosedFulfillmentDate = (iso) => CLOSED_FULFILLMENT_DATES.includes(iso);
  const nextAvailableFulfillmentDate = (date) => {
    const available = new Date(date);
    while (isClosedFulfillmentDate(isoLocal(available))) available.setDate(available.getDate() + 1);
    return available;
  };
  let hawaiiClockFormat = null;
  const getHawaiiNow = (instant = new Date()) => {
    // Built once: the calendar asks for the Hawaii clock for every day it draws.
    hawaiiClockFormat = hawaiiClockFormat || new Intl.DateTimeFormat('en-US', {
      timeZone: deliveryTimeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23'
    });
    const parts = hawaiiClockFormat.formatToParts(instant).reduce((acc, part) => {
      if (part.type !== 'literal') acc[part.type] = part.value;
      return acc;
    }, {});
    return {
      year: Number(parts.year),
      month: Number(parts.month),
      day: Number(parts.day),
      hour: Number(parts.hour),
      minute: Number(parts.minute)
    };
  };

  const getMinimumDeliveryDate = (instant = new Date()) => {
    const now = getHawaiiNow(instant);
    const min = new Date(now.year, now.month - 1, now.day);
    if (now.hour >= sameDayCutoffHour) min.setDate(min.getDate() + 1);
    min.setHours(0, 0, 0, 0);
    return nextAvailableFulfillmentDate(min);
  };

  const getMinimumDeliveryIso = () => isoLocal(getMinimumDeliveryDate());

  const getMinimumDeliveryDateForInput = (input, instant = new Date()) => {
    const minimum = getMinimumDeliveryDate(instant);
    const leadDays = Math.max(0, Number(input?.dataset?.minLeadDays || 0));
    if (!leadDays) return minimum;
    const now = getHawaiiNow(instant);
    const leadMinimum = new Date(now.year, now.month - 1, now.day);
    leadMinimum.setDate(leadMinimum.getDate() + leadDays);
    leadMinimum.setHours(0, 0, 0, 0);
    return nextAvailableFulfillmentDate(leadMinimum > minimum ? leadMinimum : minimum);
  };

  const formatDateLabel = (iso) => {
    if (!iso) return '';
    const [y, m, d] = iso.split('-').map(Number);
    if (!y || !m || !d) return '';
    return new Intl.DateTimeFormat(document.documentElement.lang || 'en-US', { weekday: 'short', month: 'long', day: 'numeric' }).format(new Date(y, m - 1, d));
  };

  const hawaiiTodayIso = (instant = new Date()) => {
    const now = getHawaiiNow(instant);
    return isoLocal(new Date(now.year, now.month - 1, now.day));
  };

  const fillTemplate = (template, values) => Object.entries(values)
    .reduce((text, [key, value]) => text.split(`[${key}]`).join(String(value)), String(template || ''));

  const closedFulfillmentMessage = (iso, input) => fillTemplate(
    input?.dataset?.dateUnavailable || 'Delivery and pickup are unavailable on [date]. Please choose another day.',
    { date: formatDateLabel(iso) }
  );

  // Windows are stored as text ("9 AM - 12 PM", "Standard 12 PM - 7 PM"); read the hours
  // from that text so a window renamed in the theme editor keeps working.
  const parseWindowRange = (value) => {
    const text = String(value || '').toLowerCase().replace(/[–—−]/g, '-');
    const match = text.match(/(\d{1,2})(?::(\d{2}))?\s*(am|pm)\s*(?:-|to)\s*(\d{1,2})(?::(\d{2}))?\s*(am|pm)/);
    if (!match) return null;
    const minutes = (hour, minute, meridiem) => ((Number(hour) % 12) + (meridiem === 'pm' ? 12 : 0)) * 60 + Number(minute || 0);
    return { start: minutes(match[1], match[2], match[3]), end: minutes(match[4], match[5], match[6]) };
  };

  // The last minute of today (Hawaii time, minutes after midnight) before which a window can still
  // be booked, keyed by the window's start-end minutes. Owner, 2026-10-14: a window stays open
  // until one hour after it starts (3 PM - 6 PM until 4 PM, 12 PM - 3 PM until 1 PM), and the
  // 6 PM same-day cutoff closes today for everything (Standard and 6 PM - 9 PM). The same table
  // as WINDOW_LAST_CHANCE_MINUTES in lib/order-schedule.js (the server's validateSchedule);
  // test/order-schedule.test.js keeps the two equal.
  const WINDOW_LAST_CHANCE_MINUTES = Object.freeze({
    '720-1140': 18 * 60, // Standard 12 PM - 7 PM
    '540-720': 10 * 60, // 9 AM - 12 PM
    '720-900': 13 * 60, // 12 PM - 3 PM
    '900-1080': 16 * 60, // 3 PM - 6 PM
    '1080-1260': 18 * 60 // 6 PM - 9 PM
  });
  const windowLastChance = (windowValue) => {
    const cutoff = sameDayCutoffHour * 60;
    const range = parseWindowRange(windowValue);
    if (!range) return cutoff;
    const key = `${range.start}-${range.end}`;
    if (Object.prototype.hasOwnProperty.call(WINDOW_LAST_CHANCE_MINUTES, key)) return WINDOW_LAST_CHANCE_MINUTES[key];
    // A window the table does not know (an old label): the same rule, one hour after it starts.
    return Math.min(range.start + 60, cutoff);
  };

  // Can this window still be booked for dateIso (Hawaii time)? Only today can be too late: before
  // the window's last chance and before the 6 PM same-day cutoff. Every later day takes every window.
  const timeWindowOpen = (windowValue, dateIso, options = {}) => {
    const instant = options.now || new Date();
    if (isClosedFulfillmentDate(dateIso)) return false;
    if (!dateIso || dateIso !== hawaiiTodayIso(instant)) return true;
    const clock = getHawaiiNow(instant);
    const nowMinutes = clock.hour * 60 + clock.minute;
    return nowMinutes < Math.min(windowLastChance(windowValue), sameDayCutoffHour * 60);
  };

  // Days on which a window has no room left (the staff app limits 9 AM - 12 PM), fetched once
  // per page. Shoppers only see the window as not available that day; if the request fails,
  // nothing is limited and the staff see the extra order on their board.
  let windowAvailability = { windows: [] };
  let windowAvailabilityRequest = null;
  const loadWindowAvailability = () => {
    const url = String((window.DF_DELIVERY || {}).availabilityUrl || '');
    if (!url || typeof fetch !== 'function') return Promise.resolve(windowAvailability);
    if (!windowAvailabilityRequest) {
      windowAvailabilityRequest = fetch(url, { credentials: 'omit' })
        .then(response => (response.ok ? response.json() : null))
        .then(data => {
          if (data && data.ok && Array.isArray(data.windows)) windowAvailability = data;
          return windowAvailability;
        })
        .catch(() => windowAvailability);
    }
    return windowAvailabilityRequest;
  };

  const windowBookedOn = (windowValue, dateIso) => {
    if (!dateIso) return false;
    const range = parseWindowRange(windowValue);
    if (!range) return false;
    return windowAvailability.windows.some(entry => Number(entry.start) * 60 === range.start
      && Number(entry.end) * 60 === range.end
      && Array.isArray(entry.closed) && entry.closed.includes(dateIso));
  };

  // The time chosen in the cart's "When" step. A day with no room in that window (the staff app
  // limits 9 AM - 12 PM) is greyed out in the cart calendar. A window that has gone by for today
  // is not: the owner wants every window offered, and the step explains it instead.
  const chosenCartWindow = (form) => form?.querySelector?.('input[data-cart-window]:checked') || null;
  const windowsBlockDate = (input, iso) => {
    if (isClosedFulfillmentDate(iso)) return true;
    const chosen = chosenCartWindow(input?.form);
    return Boolean(chosen && windowBookedOn(chosen.value, iso));
  };

  const zonedClockParts = (instant, timeZone) => {
    const options = { weekday: 'short', year: 'numeric', month: '2-digit', day: '2-digit', hour: 'numeric', minute: '2-digit', hourCycle: 'h12' };
    if (timeZone) options.timeZone = timeZone;
    return new Intl.DateTimeFormat('en-US', options).formatToParts(instant).reduce((acc, part) => {
      if (part.type !== 'literal') acc[part.type] = part.value;
      return acc;
    }, {});
  };

  // The cutoff in the visitor's own clock ("9 PM", "9:30 PM", "Thu 1 PM"), or '' when that
  // is the same as Hawaii time.
  const localCutoffLabel = (cutoff, timeZone) => {
    const hawaii = zonedClockParts(cutoff, deliveryTimeZone);
    const local = zonedClockParts(cutoff, timeZone);
    const sameDay = local.year === hawaii.year && local.month === hawaii.month && local.day === hawaii.day;
    if (sameDay && local.hour === hawaii.hour && local.minute === hawaii.minute) return '';
    const time = `${local.hour}${local.minute === '00' ? '' : `:${local.minute}`} ${local.dayPeriod || ''}`.trim();
    return sameDay ? time : `${local.weekday} ${time}`;
  };

  const sameDayCountdown = (options = {}) => {
    const instant = options.now || new Date();
    const copy = options.copy || {};
    const leadDays = Math.max(0, Number(options.leadDays || 0));
    // Owner, 2026-10-14: the next day is "tomorrow" in words; a later day keeps its weekday and date.
    const nextIso = isoLocal(getMinimumDeliveryDateForInput({ dataset: { minLeadDays: leadDays } }, instant));
    const tomorrow = new Date(`${hawaiiTodayIso(instant)}T12:00:00`);
    tomorrow.setDate(tomorrow.getDate() + 1);
    const next = nextIso === isoLocal(tomorrow) ? (copy.tomorrow || 'tomorrow') : formatDateLabel(nextIso);
    if (leadDays > 0) return { open: false, text: fillTemplate(copy.madeToOrder || 'Made to order: earliest delivery [date].', { date: next }) };
    const clock = getHawaiiNow(instant);
    const left = sameDayCutoffHour * 60 - (clock.hour * 60 + clock.minute);
    if (left <= 0 || isClosedFulfillmentDate(hawaiiTodayIso(instant))) return { open: false, text: fillTemplate(copy.closed || 'Same-day delivery is closed for today. Next available: [date].', { date: next }) };
    const hours = Math.floor(left / 60);
    const minutes = left % 60;
    const time = hours ? `${hours} h${minutes ? ` ${minutes} min` : ''}` : `${minutes} min`;
    const cutoff = new Date(`${hawaiiTodayIso(instant)}T${String(sameDayCutoffHour).padStart(2, '0')}:00:00-10:00`);
    const localTime = localCutoffLabel(cutoff, options.timeZone);
    const local = localTime ? fillTemplate(copy.local || ' ([time] your time)', { time: localTime }) : '';
    return { open: true, text: fillTemplate(copy.open || 'Order within [time] for same-day delivery · cutoff 6 PM HST[local]', { time, local }) };
  };

  // Weekly Sale ends Sunday 23:59:59 in Honolulu, whatever the visitor's own time zone.
  const weeklySaleDeadline = (instant = new Date()) => {
    const clock = getHawaiiNow(instant);
    const day = new Date(Date.UTC(clock.year, clock.month - 1, clock.day));
    const sundayEnd = (offset) => {
      const date = new Date(day);
      date.setUTCDate(date.getUTCDate() + offset);
      return new Date(`${date.toISOString().slice(0, 10)}T23:59:59-10:00`);
    };
    const daysUntilSunday = (7 - day.getUTCDay()) % 7;
    const deadline = sundayEnd(daysUntilSunday);
    return deadline > instant ? deadline : sundayEnd(daysUntilSunday + 7);
  };

  const initGiftLivePreview = (form) => {
    const preview = form.querySelector('[data-gift-live-preview]');
    if (!preview) return;
    const recipientInput = form.querySelector('[data-recipient-name]');
    const messageInput = form.querySelector('#GiftMessage');
    const recipientText = preview.querySelector('[data-preview-recipient]');
    const messageText = preview.querySelector('[data-preview-message]');
    const recipientTexts = preview.querySelectorAll('[data-preview-recipient]');
    const messageTexts = preview.querySelectorAll('[data-preview-message]');
    const cards = preview.querySelectorAll('[data-preview-card]');
    const recipientActions = preview.querySelectorAll('[data-preview-recipient-action]');
    const messageActions = preview.querySelectorAll('[data-preview-message-action]');
    const variantButtons = preview.querySelectorAll('[data-preview-variant-option]');
    const recipientFallback = recipientText ? recipientText.textContent.trim() : 'Their name';
    const messageFallback = messageText ? messageText.textContent.trim() : 'Your note will appear here';
    const update = () => {
      const recipientValue = recipientInput ? (recipientInput.value.trim() || recipientFallback) : recipientFallback;
      const messageValue = messageInput ? (messageInput.value.trim() || messageFallback) : messageFallback;
      recipientTexts.forEach(node => { node.textContent = recipientValue; });
      messageTexts.forEach(node => { node.textContent = messageValue; });
    };
    const setMode = (mode) => {
      const isMessage = mode === 'message';
      preview.classList.toggle('is-message-mode', isMessage);
      preview.classList.toggle('is-recipient-mode', !isMessage);
      cards.forEach(card => {
        card.setAttribute('aria-hidden', isMessage ? 'false' : 'true');
        card.tabIndex = isMessage ? 0 : -1;
      });
    };
    const setVariant = (variant) => {
      preview.setAttribute('data-preview-variant', variant);
      variantButtons.forEach(button => {
        button.setAttribute('aria-pressed', button.dataset.previewVariantOption === variant ? 'true' : 'false');
      });
    };
    cards.forEach(card => card.setAttribute('aria-hidden', 'true'));
    variantButtons.forEach(button => {
      button.addEventListener('click', () => {
        setVariant(button.dataset.previewVariantOption || 'box');
        update();
      });
    });
    if (recipientInput) {
      ['focus', 'input'].forEach(eventName => recipientInput.addEventListener(eventName, () => {
        setMode('recipient');
        update();
      }));
    }
    if (messageInput) {
      ['focus', 'input'].forEach(eventName => messageInput.addEventListener(eventName, () => {
        setMode('message');
        update();
      }));
    }
    recipientActions.forEach(action => action.addEventListener('click', () => {
      setMode('recipient');
      if (recipientInput) recipientInput.focus();
    }));
    messageActions.forEach(action => action.addEventListener('click', () => {
      setMode('message');
      if (messageInput) messageInput.focus();
    }));
    setVariant(preview.getAttribute('data-preview-variant') || 'box');
    setMode(messageInput && messageInput.value.trim() ? 'message' : 'recipient');
    update();
  };

  const giftMessages = {
    birthday: [
      "Happy birthday! I hope today brings you the kind of happiness that stays with you long after the candles are gone. You deserve a year filled with good people, unexpected adventures, quiet moments of peace, and plenty of reasons to laugh until your cheeks hurt.",
      "Wishing you the happiest birthday and a beautiful year ahead. May it bring more of what makes you feel alive, less of what weighs you down, and countless little moments that remind you just how loved and appreciated you truly are.",
      "Another year of you is absolutely worth celebrating! I hope your birthday feels warm, joyful, and completely your own — full of favorite things, favorite people, and the kind of memories you will still be smiling about months from now.",
      "Happy birthday! These flowers are a small celebration of the color, warmth, and joy you bring into the lives around you. I hope this next chapter surprises you in all the best ways and gives you even more reasons to be proud of the life you are creating.",
      "Today is about celebrating the wonderful person you are and everything that makes you one of a kind. I hope you feel surrounded by love, spoiled in all the right ways, and excited for every beautiful possibility waiting for you this year.",
      "Happy birthday to someone who deserves so much more than one day of celebration. May the year ahead be generous with you — bringing meaningful moments, exciting opportunities, deep belly laughs, and the confidence to keep choosing what makes you genuinely happy."
    ],
    love: [
      "I may not always find the perfect words, but loving you has made my life warmer, brighter, and more meaningful than I ever imagined. These flowers are a small reminder that I choose you, appreciate you, and feel incredibly lucky to have you beside me.",
      "For the person who makes ordinary days feel special. Thank you for the laughter, the comfort, the patience, and all the little things you do without even realizing how much they mean to me. I love the life we are building together.",
      "You are my favorite thought in the middle of a busy day and my favorite place to come home to. I hope these flowers remind you that you are deeply loved — not only today, but in all the quiet moments in between.",
      "There are a thousand small reasons I love you: the way you understand me, the way you make me laugh, and the way the world feels a little easier when you are near. These flowers are for all of those reasons and so many more.",
      "Life with you is made of moments I never want to take for granted — long conversations, ridiculous jokes, quiet evenings, and the comfort of simply being together. I love you for who you are and for who I get to be when I am with you.",
      "If I could send you every beautiful thing that reminds me of you, one gift would never be enough. So let this be a small beginning: a little color, a lot of love, and a reminder that having you in my life means more than I can say."
    ],
    anniversary: [
      "Happy anniversary to us. I am grateful for every chapter we have already written — the beautiful moments, the hard ones that made us stronger, and all the ordinary days that became special simply because we shared them. I would choose you all over again.",
      "Another year, another collection of memories, and still so much to look forward to. Thank you for being my partner, my safe place, and the person I want beside me for every adventure still ahead. Happy anniversary, with all my love.",
      "Today is a celebration of everything we have built together: the trust, the laughter, the lessons, and the love that keeps growing through every season. I am so proud of us and so excited for all the life we have yet to share.",
      "Happy anniversary! Loving you has taught me that the best relationships are created in a thousand small choices — listening, showing up, forgiving, laughing, and choosing each other again. Thank you for making those choices with me every day.",
      "From our favorite memories to the plans we have not made yet, every part of this journey means more because it is ours. Thank you for filling my life with love, partnership, and so many reasons to look forward to tomorrow.",
      "One date on the calendar could never hold everything this anniversary means to me. It carries all our conversations, adventures, challenges, inside jokes, and quiet moments of understanding. I am endlessly grateful that this is our story — and that it is still unfolding."
    ],
    proposal: [
      "I love the life we have already shared, and I cannot imagine the chapters ahead without you beside me. You are my favorite person, my safest place, and the one I want to keep choosing. Will you marry me?",
      "Every ordinary day feels more meaningful with you in it. I want the adventures, the quiet mornings, the hard conversations, and every beautiful surprise still ahead — together. Will you marry me?",
      "You have made my world warmer, brighter, and more honest than I knew it could be. I do not just want this moment with you; I want a lifetime of moments like it. Will you marry me?"
    ],
    sympathy: [
      "Holding you and your family in my thoughts during this deeply difficult time. I hope the love surrounding you, and the memories you carry, bring moments of comfort when you need them most. Please know that you do not have to walk through this alone.",
      "Words can feel far too small for a loss like this. I am sending these flowers with heartfelt sympathy and with the hope that they offer a quiet reminder of how many people care for you and are keeping you close in their thoughts.",
      "May the memories of a life so meaningful remain a source of comfort and strength in the days ahead. Thinking of you with tenderness, respect, and sincere sympathy, and sending love to everyone who is grieving this loss.",
      "There is no right way or timeline for grief. Please be gentle with yourself and know that you are surrounded by people who care. I am thinking of you, remembering with you, and sending quiet support for all the difficult moments ahead.",
      "With deepest sympathy as you honor and remember someone so dearly loved. I hope that, in time, the memories that hurt today will also bring warmth and remind you of the beautiful difference this life made in so many others.",
      "Sending love and heartfelt condolences to you and your family. May you find comfort in one another, strength in the care of those around you, and peace in the memories that will always keep your loved one close."
    ],
    thank_you: [
      "Thank you for showing up with such generosity and care. What you did may have felt simple to you, but it made a real difference to me. I hope these flowers brighten your day the way your kindness brightened mine.",
      "Some kindness stays with you long after the moment has passed, and yours certainly will. Thank you for your time, thoughtfulness, and the way you made everything feel a little easier. I appreciate you more than I can properly put into words.",
      "This gift comes with a very heartfelt thank you. Your support meant so much, especially when I needed it most, and I will not forget it. I feel incredibly lucky to know someone as thoughtful, dependable, and genuinely kind as you.",
      "Thank you for being the kind of person who notices, cares, and goes the extra mile. The world feels better because of people like you, and my world is certainly better for having you in it. Please enjoy this small token of my appreciation.",
      "I wanted to send more than a quick thank-you text, because what you did deserved something thoughtful. Your help, patience, and generosity meant a great deal to me. I hope these flowers remind you just how appreciated you truly are.",
      "Gratitude is sometimes difficult to fit into words, but I hope this comes close: thank you for your kindness, your time, and the care you put into everything you do. It did not go unnoticed, and it meant more to me than you know."
    ],
    just_because: [
      "There is no special date and no big reason — I simply thought of you and wanted to make your day a little brighter. Sometimes the best surprises are the ones that say, out of nowhere, you matter to me and I am glad you are in my life.",
      "These flowers reminded me of you: bright, beautiful, and impossible not to notice. I hope they bring a little color to your space and a smile to your day. You deserve lovely things even when there is nothing particular to celebrate.",
      "Just a small interruption to your regularly scheduled day: someone is thinking about you, appreciating you, and hoping something unexpectedly beautiful arrives at exactly the right moment. No occasion required — being you is reason enough.",
      "I wanted to send you something that would last longer than a text and feel a little more special than an emoji. I hope these flowers make you pause, smile, and remember that you are loved, thought about, and never as far away as you might feel.",
      "Life gets busy, and sometimes we forget to say the things that matter while there is no occasion demanding it. So here it is: I appreciate you, I am grateful for you, and I hope this unexpected gift makes an ordinary day feel a bit more beautiful.",
      "Consider this gift a delivery of good energy with no strings attached. Keep it somewhere you will see it often, and let it remind you that someone out here thinks you are wonderful and wanted you to have a genuinely lovely day."
    ],
    get_well: [
      "Thinking of you and sending a little color for the days when everything feels slower than usual. Take all the time you need to rest and recover. I hope each new day brings more comfort, more strength, and one small reason to smile.",
      "I am sorry you are going through this and wish I could make the difficult parts easier. For now, I am sending flowers, warm thoughts, and a reminder that you are cared for. Please focus on resting and let the people around you help.",
      "Wishing you patience on the slow days, strength on the hard days, and plenty of peaceful moments in between. Recovery is not always a straight line, so be gentle with yourself and remember that there are many people cheering you on.",
      "These flowers come with no expectation except that you take good care of yourself. Rest when you need to, accept help when it is offered, and know that you are missed, loved, and thought about more often than you probably realize.",
      "Sending you a bright little reminder that the world is waiting for you, but there is absolutely no rush. Give yourself the same patience and kindness you would give someone you love. I am thinking of you and hoping today feels a bit easier.",
      "I hope these flowers bring some warmth to your room and make the day feel less clinical and a little more like home. You have a whole team of people wishing you comfort, steady progress, and all the rest you need along the way."
    ]
  };

  const initGiftGenerator = (form) => {
    const wrap = form.querySelector('[data-gift-generator]');
    const textarea = form.querySelector('#GiftMessage');
    if (!wrap || !textarea) return;
    const generate = wrap.querySelector('[data-gift-generate]');
    const menu = wrap.querySelector('[data-gift-menu]');
    const options = wrap.querySelectorAll('[data-gift-category-option]');
    const refresh = wrap.querySelector('[data-gift-refresh]');
    const defaultLabel = generate ? generate.textContent.trim() : 'Generate';
    let lastKey = 'birthday';
    let lastIndex = -1;
    const categoryLabel = (key) => {
      const option = Array.from(options).find(item => (item.value || item.getAttribute('value')) === key);
      return option ? option.textContent.trim() : defaultLabel;
    };
    const setGenerateLabel = (key) => {
      if (!generate) return;
      generate.textContent = categoryLabel(key);
      generate.classList.add('is-selected');
      generate.setAttribute('aria-label', `${categoryLabel(key)} messages`);
    };
    const closeMenu = () => {
      if (!menu) return;
      menu.hidden = true;
      if (generate) generate.setAttribute('aria-expanded', 'false');
    };
    const openMenu = () => {
      if (!menu) return;
      menu.hidden = false;
      if (generate) generate.setAttribute('aria-expanded', 'true');
    };
    const pickMessage = (forcedKey) => {
      const key = forcedKey || lastKey;
      const messages = giftMessages[key] || giftMessages.birthday;
      let index = Math.floor(Math.random() * messages.length);
      if (messages.length > 1 && index === lastIndex) index = (index + 1) % messages.length;
      lastKey = key;
      lastIndex = index;
      setGenerateLabel(key);
      textarea.value = messages[index];
      textarea.dispatchEvent(new Event('input', { bubbles: true }));
      textarea.focus();
      closeMenu();
      if (refresh) refresh.hidden = false;
    };
    if (generate) {
      generate.addEventListener('click', () => {
        if (!menu) return;
        menu.hidden ? openMenu() : closeMenu();
      });
    }
    options.forEach(option => {
      option.addEventListener('click', () => {
        lastIndex = -1;
        pickMessage(option.value || option.getAttribute('value'));
      });
    });
    if (refresh) refresh.addEventListener('click', () => pickMessage(lastKey));
    document.addEventListener('click', (event) => {
      if (!wrap.contains(event.target)) closeMenu();
    });
  };

  const initWeeklyDropTimer = () => {
    const output = document.querySelector('[data-weekly-timer]');
    if (!output) return;
    const update = () => {
      const now = new Date();
      const remaining = weeklySaleDeadline(now) - now;
      const totalMinutes = Math.max(0, Math.floor(remaining / 60000));
      const days = Math.floor(totalMinutes / 1440);
      const hours = Math.floor((totalMinutes % 1440) / 60);
      const minutes = totalMinutes % 60;
      if (days > 0) output.textContent = `${days}d ${hours}h left`;
      else if (hours > 0) output.textContent = `${hours}h ${minutes}m left`;
      else output.textContent = `${minutes}m left`;
    };
    update();
    setInterval(update, 60000);
  };

  const initDatePickers = () => {
    document.querySelectorAll('[data-date-picker]').forEach(picker => {
      if (picker.dataset.datePickerInitialized === 'true') return;
      const input = document.getElementById(picker.dataset.target || '');
      const button = picker.querySelector('[data-date-picker-toggle]');
      const panel = picker.querySelector('[data-date-picker-panel]');
      const scrim = picker.querySelector('.df-date-picker__scrim');
      const closeButtons = picker.querySelectorAll('[data-date-picker-close]');
      const label = picker.querySelector('[data-date-picker-label]');
      const grid = picker.querySelector('[data-date-grid]');
      const monthLabel = picker.querySelector('[data-date-month]');
      const closureNote = picker.querySelector('[data-date-closure-note]');
      const prev = picker.querySelector('[data-date-prev]');
      const next = picker.querySelector('[data-date-next]');
      if (!input || !button || !panel || !grid || !monthLabel) return;
      picker.dataset.datePickerInitialized = 'true';
      // Keep the calendar outside cart/checkout containers that clip overflow.
      if (scrim && scrim.parentNode !== document.body) document.body.appendChild(scrim);
      if (panel.parentNode !== document.body) document.body.appendChild(panel);
      const placeholderText = label.textContent;
      let minDate = getMinimumDeliveryDateForInput(input);
      let minIso = isoLocal(minDate);
      if (input.value && input.value < minIso && !isClosedFulfillmentDate(input.value)) input.value = '';
      let view = input.value ? new Date(`${input.value}T12:00:00`) : new Date(minDate);
      view.setDate(1);

      const setLabel = () => {
        label.textContent = input.value ? formatDateLabel(input.value) : placeholderText;
      };
      const closePanel = (restoreFocus = false) => {
        panel.hidden = true;
        panel.setAttribute('aria-hidden', 'true');
        if (scrim) {
          scrim.hidden = true;
          scrim.setAttribute('aria-hidden', 'true');
        }
        picker.classList.remove('is-open');
        button.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('date-picker-open');
        document.body.classList.remove('date-picker-open');
        if (restoreFocus) button.focus({ preventScroll: true });
      };
      const openPanel = () => {
        render();
        panel.hidden = false;
        panel.setAttribute('aria-hidden', 'false');
        if (scrim) {
          scrim.hidden = false;
          scrim.setAttribute('aria-hidden', 'false');
        }
        picker.classList.add('is-open');
        button.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('date-picker-open');
        document.body.classList.add('date-picker-open');
        window.requestAnimationFrame(() => panel.focus({ preventScroll: true }));
      };
      const render = () => {
        minDate = getMinimumDeliveryDateForInput(input);
        minIso = isoLocal(minDate);
        if (input.value && input.value < minIso && !isClosedFulfillmentDate(input.value)) {
          input.value = '';
          setLabel();
        }
        const minMonth = new Date(minDate.getFullYear(), minDate.getMonth(), 1);
        if (view < minMonth) view = new Date(minMonth);
        const y = view.getFullYear();
        const m = view.getMonth();
        monthLabel.textContent = new Intl.DateTimeFormat(document.documentElement.lang || 'en-US', { month: 'long', year: 'numeric' }).format(view);
        grid.innerHTML = '';
        const first = new Date(y, m, 1);
        const last = new Date(y, m + 1, 0);
        const offset = (first.getDay() + 6) % 7;
        // Owner, 2026-10-14: "only add a light highlight of today so people see it at once".
        const todayIso = hawaiiTodayIso();
        for (let i = 0; i < offset; i++) grid.insertAdjacentHTML('beforeend', '<span></span>');
        for (let d = 1; d <= last.getDate(); d++) {
          const date = new Date(y, m, d);
          const iso = isoLocal(date);
          const disabled = date < minDate || windowsBlockDate(input, iso);
          const selected = input.value === iso;
          const day = document.createElement('button');
          day.type = 'button';
          day.textContent = String(d);
          day.disabled = disabled;
          day.setAttribute('aria-label', isClosedFulfillmentDate(iso) ? closedFulfillmentMessage(iso, input) : formatDateLabel(iso));
          if (isClosedFulfillmentDate(iso)) {
            day.title = closedFulfillmentMessage(iso, input);
            day.classList.add('is-closed');
            const status = document.createElement('small');
            status.className = 'df-date-picker__closed-label';
            status.textContent = input.dataset.dateClosedLabel || 'Closed';
            status.setAttribute('aria-hidden', 'true');
            day.appendChild(status);
          }
          if (iso === todayIso) {
            day.classList.add('is-today');
            day.setAttribute('aria-current', 'date');
          }
          if (selected) {
            day.classList.add('is-selected');
            day.setAttribute('aria-pressed', 'true');
          }
          day.addEventListener('click', () => {
            if (day.disabled || isClosedFulfillmentDate(iso)) return;
            input.value = iso;
            label.textContent = formatDateLabel(iso);
            input.removeAttribute('aria-invalid');
            closePanel(true);
            // The product page re-checks its time windows against the chosen day.
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
          grid.appendChild(day);
        }
        if (closureNote) {
          const monthPrefix = `${y}-${String(m + 1).padStart(2, '0')}-`;
          const closedDays = CLOSED_FULFILLMENT_DATES.filter(iso => iso.startsWith(monthPrefix) && iso >= todayIso);
          closureNote.textContent = closedDays.map(iso => closedFulfillmentMessage(iso, input)).join(' ');
          closureNote.hidden = closedDays.length === 0;
        }
        if (prev) {
          const prevMonth = new Date(y, m - 1, 1);
          prev.disabled = prevMonth < new Date(minDate.getFullYear(), minDate.getMonth(), 1);
        }
      };

      button.addEventListener('click', () => {
        if (panel.hidden) openPanel();
        else closePanel(true);
      });
      closeButtons.forEach(closeButton => closeButton.addEventListener('click', () => closePanel(true)));
      if (prev) prev.addEventListener('click', () => { view.setMonth(view.getMonth() - 1); render(); });
      if (next) next.addEventListener('click', () => { view.setMonth(view.getMonth() + 1); render(); });
      document.addEventListener('click', (event) => {
        const clickedToggle = picker.contains(event.target);
        const clickedPanel = panel.contains(event.target);
        if (!panel.hidden && !clickedToggle && !clickedPanel && event.target !== scrim) closePanel();
      });
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape' && !panel.hidden) closePanel(true);
      });
      // Drop a date that is no longer possible after the daily cutoff.
      input._dfDatePickerRefresh = () => {
        const before = input.value;
        if (input.value && input.value < isoLocal(getMinimumDeliveryDateForInput(input)) && !isClosedFulfillmentDate(input.value)) input.value = '';
        setLabel();
        if (!panel.hidden) render();
        if (before !== input.value) input.dispatchEvent(new Event('change', { bubbles: true }));
      };
      setLabel();
      render();
      // Cart: days with no room in a line's window go grey once the staff app has answered.
      if (input.form?.querySelector('[data-cart-window]')) loadWindowAvailability().then(() => render());
    });
  };

  const validateDeliveryDateForCheckout = (form) => {
    const input = form.querySelector('input[name="attributes[Delivery date]"]');
    if (!input) return true;
    const error = form.querySelector('[data-date-error]');
    const minDate = getMinimumDeliveryDateForInput(input);
    const minIso = isoLocal(minDate);
    let message = '';
    if (!input.value) {
      message = 'Choose a delivery date. Same-day delivery closes at 6 PM HST.';
    } else if (isClosedFulfillmentDate(input.value)) {
      message = closedFulfillmentMessage(input.value, input);
    } else if (input.value < minIso) {
      input.value = '';
      message = 'This date is no longer available. Choose a later date. Same-day delivery closes at 6 PM HST.';
    }
    // The time window against this date is the "When" step's own check (validateScheduleForCheckout).
    if (!message) {
      input.removeAttribute('aria-invalid');
      if (error) error.hidden = true;
      return true;
    }
    input.setAttribute('aria-invalid', 'true');
    if (error) {
      error.textContent = message;
      error.hidden = false;
    }
    // validateCartForCheckout brings the shopper to the calendar button.
    return false;
  };

  // "3 PM - 6 PM" as people read it: "3 PM – 6 PM"; the Standard window by its hours.
  const windowDisplayName = (value) => String(value || '').replace(/^standard\s*/i, '').replace(/\s*-\s*/g, ' – ').trim();

  // Minutes after midnight as a clock: 960 → "4 PM", 810 → "1:30 PM".
  const minutesClockLabel = (minutes) => {
    const hour = Math.floor(minutes / 60);
    const minute = minutes % 60;
    return `${hour % 12 || 12}${minute ? `:${String(minute).padStart(2, '0')}` : ''} ${hour < 12 ? 'AM' : 'PM'}`;
  };

  // Design D (owner, 2026-10-14): each time card in the cart says, for today, "Too late today"
  // once it can no longer be booked, or "Book by 4 PM" while a reserved window still can
  // (the same table as the checkout check, WINDOW_LAST_CHANCE_MINUTES; Standard and 6 – 9 PM close
  // with the 6 PM cutoff, which the countdown already names). With no day chosen yet the cards
  // speak about today until the cutoff; another day takes every window, so no card says anything.
  const markCartWindows = (step, dateIso, now = new Date()) => {
    const copy = step.dataset;
    const cutoff = sameDayCutoffHour * 60;
    const clock = getHawaiiNow(now);
    const nowMinutes = clock.hour * 60 + clock.minute;
    const today = hawaiiTodayIso(now);
    const forToday = !isClosedFulfillmentDate(dateIso || today) && (dateIso ? dateIso === today : nowMinutes < cutoff);
    step.querySelectorAll('input[data-cart-window]').forEach(input => {
      const card = input.closest('.delivery-choice-card');
      const note = card && card.querySelector('[data-window-note]');
      if (!note) return;
      let text = '';
      let kind = '';
      if (forToday) {
        const last = Math.min(windowLastChance(input.value), cutoff);
        if (nowMinutes >= last) {
          text = copy.windowLate || 'Too late today';
          kind = 'late';
        } else if (last < cutoff) {
          text = fillTemplate(copy.windowBookBy || 'Book by [time]', { time: minutesClockLabel(last) });
          kind = 'soon';
        }
      }
      note.textContent = text;
      note.hidden = !text;
      card.classList.toggle('is-late', kind === 'late');
      card.classList.toggle('is-soon', kind === 'soon');
    });
  };

  // The one line under the time cards: "Today, Wednesday, October 14 · 12 PM – 7 PM · Included".
  const cartScheduleSummary = (step, dateIso, chosen, now = new Date()) => {
    if (!step || !dateIso || !chosen || isClosedFulfillmentDate(dateIso)) return '';
    const copy = step.dataset;
    const [y, m, d] = dateIso.split('-').map(Number);
    if (!y || !m || !d) return '';
    const day = new Intl.DateTimeFormat(document.documentElement.lang || 'en-US', { weekday: 'long', month: 'long', day: 'numeric' }).format(new Date(y, m - 1, d));
    const today = hawaiiTodayIso(now);
    const tomorrow = new Date(`${today}T12:00:00`);
    tomorrow.setDate(tomorrow.getDate() + 1);
    const prefix = dateIso === today ? (copy.summaryToday || 'Today') : dateIso === isoLocal(tomorrow) ? (copy.summaryTomorrow || 'Tomorrow') : '';
    const card = chosen.closest('.delivery-choice-card');
    const time = (card && card.querySelector('small') && card.querySelector('small').textContent.trim()) || windowDisplayName(chosen.value);
    const price = (card && card.querySelector('[data-window-price]') && card.querySelector('[data-window-price]').textContent.trim()) || '';
    // The hours and the price never break across lines (no-break spaces, and a word joiner after
    // the dash, where browsers would otherwise still break).
    const keep = text => text.replace(/ /g, ' ').replace(/–/g, '–⁠');
    return [prefix ? `${prefix}, ${day}` : day, keep(time), keep(price)].filter(Boolean).join(' · ');
  };

  // What is wrong with the cart's day + time, or '' (Hawaii clock): today's window past its last
  // chance (WINDOW_LAST_CHANCE_MINUTES), or a window with no room that day (the Morning limit;
  // the words never mention a limit). The date itself is validateDeliveryDateForCheckout's.
  const scheduleProblem = (form, now = new Date()) => {
    const step = form?.querySelector?.('[data-cart-schedule]');
    const chosen = chosenCartWindow(form);
    const dateInput = form?.querySelector?.('input[name="attributes[Delivery date]"]');
    const date = dateInput?.value || '';
    if (!step || !date) return '';
    if (isClosedFulfillmentDate(date)) return closedFulfillmentMessage(date, dateInput);
    if (!chosen) return '';
    const copy = step.dataset;
    const name = windowDisplayName(chosen.value);
    if (!timeWindowOpen(chosen.value, date, { now })) {
      return fillTemplate(copy.windowPassed || 'Today’s [window] time has already started. Please choose a later time or another day.', { window: name });
    }
    if (windowBookedOn(chosen.value, date)) {
      return fillTemplate(copy.windowNotAvailable || '[window] is not available on this day. Please choose another time or another day.', { window: name });
    }
    return '';
  };

  // Shows (or clears) the problem right at the time choice: the message, the step outlined, and
  // Checkout marked as waiting (it still answers a press by bringing the shopper here).
  const showScheduleProblem = (form, text) => {
    const step = form.querySelector('[data-cart-schedule]');
    if (!step) return;
    const message = step.querySelector('[data-schedule-message]');
    const windows = step.querySelector('[data-cart-windows]');
    if (message) {
      message.textContent = text || '';
      message.hidden = !text;
    }
    step.classList.toggle('is-attention', Boolean(text));
    if (windows) {
      if (text) windows.setAttribute('aria-invalid', 'true');
      else windows.removeAttribute('aria-invalid');
    }
    const section = form.closest('[data-cart-section]') || document;
    section.querySelectorAll('[data-checkout-review-addons]').forEach(button => {
      button.classList.toggle('is-waiting', Boolean(text));
      if (text) button.setAttribute('aria-describedby', 'CartScheduleBlocked');
      else button.removeAttribute('aria-describedby');
    });
    const blocked = section.querySelector('[data-checkout-blocked]');
    if (blocked) blocked.hidden = !text;
  };

  // validateCartForCheckout scrolls to the step and focuses the chosen time.
  const validateScheduleForCheckout = (form) => {
    const problem = scheduleProblem(form);
    showScheduleProblem(form, problem);
    return !problem;
  };

  // The requests that save a new time, from the fee lines the page shows (data-exact-fee-line).
  // Standard: one update.js that saves the form's details and drops the fee line. A reserved time:
  // update.js, then the fee line added (add.js) or moved to the new window (change.js), or nothing
  // more when it already carries this window. The last request brings back the section's HTML.
  // The fee line carries the window in _For delivery / pickup window, as the order sync expects.
  const cartWindowRequests = async (form, feeVariantId, windowValue) => {
    const fees = Array.from(form.querySelectorAll('[data-exact-fee-line]')).map(input => ({
      key: input.dataset.lineKey, window: input.dataset.feeWindow || '', quantity: Number(input.dataset.feeQuantity || 1)
    }));
    const reserved = isExactWindowValue(windowValue);
    const [first, ...extra] = reserved ? fees : [null, ...fees];
    const formData = cartFormData(form, { quantities: false });
    extra.forEach(fee => formData.append(`updates[${fee.key}]`, '0'));
    if (!reserved || (first && first.window === windowValue && first.quantity === 1)) {
      return cartRequest('cart/update.js', withCartSections(formData));
    }
    if (!first && !feeVariantId) throw new Error('Time-window fee product unavailable.');
    const properties = { '_Dopamine service fee': 'Reserved time window', '_For delivery / pickup window': windowValue };
    await cartRequest('cart/update.js', formData);
    return first
      ? cartRequest('cart/change.js', withCartSections({ id: first.key, quantity: 1, properties }))
      : cartRequest('cart/add.js', withCartSections({ items: [{ id: Number(feeVariantId), quantity: 1, properties }] }));
  };

  // The cart's "When" step (owner, 2026-10-14): the day and the time window are chosen here. Every
  // window is always offered; a time that has gone by for today is explained at the choice and
  // Checkout waits (checked on open, on a change, each half minute, when the tab comes back and
  // right before checkout, always in Hawaii time). A new window is saved at once and in place
  // (owner, 2026-10-14: "choosing a time reloads the whole page"): the cart attribute "Delivery /
  // pickup window" (the order sync reads it before any line property) and the reserved-window fee
  // line (cartWindowRequests), then the lines and totals are redrawn from the section Shopify sends
  // back. The choice shows at once, "Saving your time…" and then the new total right under it; if
  // Shopify refuses, the time the cart has comes back with a friendly line. A new day is saved too.
  const initCartSchedule = (form) => {
    const step = form.querySelector('[data-cart-schedule]');
    if (!step) return null;
    const section = form.closest('[data-cart-section]');
    const feeVariantId = Number(section?.dataset.exactFeeVariant || 0);
    const dateInput = form.querySelector('input[name="attributes[Delivery date]"]');
    const dateError = form.querySelector('[data-date-error]');
    const windows = Array.from(step.querySelectorAll('input[data-cart-window]'));
    const status = step.querySelector('[data-schedule-status]');
    const copy = step.dataset;
    const state = { checkoutStarted: false, savedWindow: chosenCartWindow(form)?.value || '' };
    let statusTimer = 0;
    const say = (text, kind = '') => {
      if (!status) return;
      window.clearTimeout(statusTimer);
      status.textContent = text || '';
      status.classList.toggle('is-error', kind === 'error');
      if (kind === 'done') statusTimer = window.setTimeout(() => { status.textContent = ''; }, 6000);
    };
    // A day that is no longer possible (today after 6 PM, or a day gone by) is dropped by the
    // calendar; say so instead of leaving an empty date.
    const sayDateClosed = () => {
      if (!dateInput || !dateError) return;
      dateError.textContent = step.dataset.dateClosed || 'That day is no longer available. Same-day orders close at 6 PM HST. Please choose another day.';
      dateError.hidden = false;
      dateInput.setAttribute('aria-invalid', 'true');
    };
    // Design D: the notes on the time cards and the one-line summary follow every check.
    const summary = step.querySelector('[data-schedule-summary]');
    const paintWindows = (problem) => {
      const day = dateInput?.value || '';
      markCartWindows(step, day);
      if (!summary) return;
      const text = problem ? '' : cartScheduleSummary(step, day, chosenCartWindow(form));
      summary.textContent = text;
      summary.hidden = !text;
    };
    const check = () => {
      const before = dateInput?.value || '';
      dateInput?._dfDatePickerRefresh?.();
      if (before && dateInput && !dateInput.value) sayDateClosed();
      if (dateInput?.value) validateDeliveryDateForCheckout(form);
      const problem = scheduleProblem(form);
      showScheduleProblem(form, problem);
      paintWindows(problem);
    };
    // The cart came back with a saved day the calendar has already dropped (a hidden input's
    // value is its attribute, so the snippet keeps the saved day in data-saved-value).
    if (dateInput && dateInput.dataset.savedValue && !dateInput.value) sayDateClosed();
    // Runs in the cart's write queue: by then a quicker second tap may have chosen another time
    // (only the latest is saved) or gone back to the saved one (nothing to do).
    const saveWindow = async () => {
      const chosen = chosenCartWindow(form);
      if (!chosen || chosen.value === state.savedWindow) {
        if (!step.classList.contains('is-saving')) say('');
        return;
      }
      const value = chosen.value;
      step.classList.add('is-saving');
      say(copy.windowSaving || 'Saving your time…');
      try {
        await showCartAnswer(await cartWindowRequests(form, feeVariantId, value));
        state.savedWindow = value;
        const totals = form.querySelector('[data-cart-totals]');
        const total = totals && totals.dataset.totalCents ? money(totals.dataset.totalCents) : '';
        say(total ? fillTemplate(copy.windowSaved || 'Saved. Your total is now [total].', { total }) : '', 'done');
      } catch (error) {
        console.warn('Dopamine cart time window could not be saved', error);
        const saved = windows.find(input => input.value === state.savedWindow);
        if (saved) saved.checked = true;
        check();
        say(copy.windowSaveFailed || 'That time could not be saved. Please check your connection and tap it again.', 'error');
        // Show what the cart really has now (a fee line may have been saved before the refusal).
        await refreshCartSection().catch(() => {});
      } finally {
        step.classList.remove('is-saving');
      }
    };
    windows.forEach(input => input.addEventListener('change', () => {
      check();
      say(copy.windowSaving || 'Saving your time…');
      cartWrites.run(saveWindow).catch(() => {});
    }));
    dateInput?.addEventListener('change', () => {
      check();
      const day = dateInput.value;
      if (!day || isClosedFulfillmentDate(day)) return;
      cartWrites.run(() => cartRequest('cart/update.js', { attributes: { 'Delivery date': day } }), { quiet: true })
        .catch(error => console.warn('Dopamine cart day could not be saved yet; checkout saves it again', error));
    });
    document.addEventListener('visibilitychange', () => { if (!document.hidden) check(); });
    window.addEventListener('focus', check);
    window.addEventListener('pageshow', check);
    window.setInterval(check, 30000);
    loadWindowAvailability().then(check);
    check();
    const api = {
      // Checkout: wait for the changes still on their way, then make sure the fee line matches.
      async beforeCheckout() {
        state.checkoutStarted = true;
        try {
          await cartWrites.idle();
          const chosen = chosenCartWindow(form);
          if (chosen) await ensureExactFee(feeVariantId, chosen.value, { relabel: true });
        } catch(error) {
          state.checkoutStarted = false;
          throw error;
        }
      },
      checkoutStopped() { state.checkoutStarted = false; }
    };
    form._dfCartSchedule = api;
    return api;
  };

  const validateRecipientForCheckout = (form) => {
    const giftToggle = form.querySelector('[data-gift-order-toggle]');
    const recipient = form.querySelector('[data-recipient-name]');
    const error = form.querySelector('[data-recipient-error]');
    if (giftToggle && !giftToggle.checked) {
      if (recipient) recipient.removeAttribute('aria-invalid');
      if (error) error.hidden = true;
      return true;
    }
    if (!recipient) return true;
    if (recipient.value.trim()) {
      recipient.removeAttribute('aria-invalid');
      if (error) error.hidden = true;
      return true;
    }
    recipient.setAttribute('aria-invalid', 'true');
    if (error) error.hidden = false;
    // validateCartForCheckout scrolls here once (focus() plus a second scroll shook iPhones).
    return false;
  };

  const validateCustomVasePairingForCheckout = form => {
    const section = form.closest('[data-cart-section]');
    if (!section) return true;
    const error = form.querySelector('[data-vase-cart-error]');
    const targets = Array.from(section.querySelectorAll('[data-lettering-target]'));
    const missing = Array.from(section.querySelectorAll('[data-lettering-pairing]')).some(line => {
      try {
        const pairing = JSON.parse(line.dataset.letteringPairing);
        return !targets.some(target => pairing.targetKey.includes(':')
          ? target.dataset.lineKey === pairing.targetKey
          : target.dataset.letteringTarget === String(pairing.targetProductId) && (!pairing.targetVariantId || target.dataset.letteringVariant === String(pairing.targetVariantId)));
      } catch (_) { return true; }
    });
    const invalid = missing || (section.dataset.hasCustomVase === 'true' && section.dataset.vaseTargetReady !== 'true');
    if (error) error.hidden = !invalid;
    return !invalid;
  };

  const initGiftOrderToggle = (form) => {
    const toggle = form.querySelector('[data-gift-order-toggle]');
    const fields = form.querySelector('[data-gift-order-fields]');
    const recipient = form.querySelector('[data-recipient-name]');
    const error = form.querySelector('[data-recipient-error]');
    if (!toggle || !fields) return;

    const sync = (event) => {
      fields.hidden = !toggle.checked;
      fields.setAttribute('aria-hidden', toggle.checked ? 'false' : 'true');
      if (recipient) {
        recipient.required = toggle.checked;
        if (!toggle.checked) recipient.removeAttribute('aria-invalid');
      }
      if (!toggle.checked && error) error.hidden = true;
      // Switched on by the shopper: the fields fade in once, in place. Nothing slides, grows or
      // takes focus (a field that focused itself would raise the phone keyboard and move the page).
      fields.classList.toggle('is-opening', Boolean(event && toggle.checked));
    };

    fields.addEventListener('animationend', () => fields.classList.remove('is-opening'));
    toggle.addEventListener('change', sync);
    sync();
  };

  // "From" on the card, or "Send anonymously": the name is cleared and locked (kept in the form,
  // not disabled, so the cart saves the empty value).
  const initGiftFrom = (form) => {
    const input = form.querySelector('[data-gift-from]');
    const anonymous = form.querySelector('[data-gift-anonymous]');
    if (!input || !anonymous) return;
    let typed = input.value;
    const sync = () => {
      if (anonymous.checked) {
        if (input.value) typed = input.value;
        input.value = '';
        input.readOnly = true;
        input.placeholder = 'Anonymous';
      } else {
        input.readOnly = false;
        input.placeholder = 'Your name';
        if (!input.value && typed) input.value = typed;
      }
    };
    anonymous.addEventListener('change', sync);
    sync();
  };

  // While the phone keyboard is up for a cart field, the Live chat bubble steps aside
  // (html.df-cart-typing, assets/dopamine-rebrand.css): iOS moves fixed layers about with the
  // keyboard, and it sat over the field being typed in.
  const cartTypingField = (el) => Boolean(el && el.matches && el.matches('input[type="text"], input[type="email"], input[type="tel"], input[type="number"], textarea'));
  const initCartTyping = (form) => {
    const phone = () => Boolean(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
    form.addEventListener('focusin', (event) => {
      if (phone() && cartTypingField(event.target)) document.documentElement.classList.add('df-cart-typing');
    });
    form.addEventListener('focusout', () => window.setTimeout(() => {
      const active = document.activeElement;
      if (!cartTypingField(active) || !form.contains(active)) document.documentElement.classList.remove('df-cart-typing');
    }, 0));
  };

  const initCartCheckoutAddons = () => {
    const cartSection = document.querySelector('[data-cart-section]');
    if (!cartSection) return;
    const form = cartSection.querySelector('[data-cart-form]');
    const checkoutButton = cartSection.querySelector('[data-checkout-review-addons]');
    const saveError = cartSection.querySelector('[data-checkout-error]');
    const showSaveError = (show, text = '') => {
      if (!saveError) return;
      saveError.hidden = !show;
      if (show) saveError.textContent = text || saveError.dataset.message || 'We could not save your delivery details, so checkout has not started. Check your connection and press Checkout again.';
    };
    // True once Checkout has checked and saved the form; typing anything makes it false again.
    let detailsSaved = false;
    if (form) {
      form.addEventListener('input', () => { detailsSaved = false; });
      form.addEventListener('change', () => { detailsSaved = false; });
    }

    // After the popup closes, take the customer to the first thing to fix.
    const focusFirstCartProblem = () => {
      const recipient = form.querySelector('[data-recipient-name][aria-invalid="true"]');
      const dateInput = form.querySelector('input[name="attributes[Delivery date]"][aria-invalid="true"]');
      const picker = dateInput && dateInput.id ? form.querySelector(`[data-date-picker][data-target="${dateInput.id}"]`) : null;
      const lateWindow = form.querySelector('[data-cart-windows][aria-invalid="true"]') ? chosenCartWindow(form) : null;
      const target = recipient || (picker && (picker.querySelector('[data-date-picker-toggle]') || picker)) || lateWindow || null;
      if (!target) return;
      // A text field on a phone is not focused: the keyboard would pull the page about again.
      const keyboard = target === recipient && typeof target.matches === 'function' && window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
      window.requestAnimationFrame(() => {
        if (target.scrollIntoView) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (target.focus && !keyboard) target.focus({ preventScroll: true });
      });
    };

    // The popup's "Add selected & checkout" / "No thanks, checkout": the same checks and save as
    // the Checkout button. A missing recipient or date closes the popup and shows it in the cart.
    const beforeCheckout = async ({ cartChanged }) => {
      if (!form) return true;
      showSaveError(false);
      if (detailsSaved) return true;
      if (!validateCartForCheckout(form)) {
        if (modal) modal.close();
        focusFirstCartProblem();
        showSaveError(true, 'Add the details marked above, then press Checkout.');
        return false;
      }
      try {
        // A quantity, a removal or a time still on its way is saved first.
        await settleCartWrites();
        await updateCartFromForm(form, { quantities: !cartChanged });
        // The reserved-time-window fee line matches the window just saved.
        await form._dfCartSchedule?.beforeCheckout();
      } catch(e) {
        const error = new Error('Cart save failed');
        error.customerMessage = 'We could not save your delivery details, so checkout has not started. Check your connection and try again.';
        throw error;
      }
      detailsSaved = true;
      return true;
    };

    const modal = initAddonsModal(cartSection, { beforeCheckout });
    // Opening the popup is an optional shopping action, not checkout: nothing is checked here. Its
    // checkout buttons run the cart's checks and save (beforeCheckout above). One listener on the
    // section: the meter with this button is redrawn after every cart change.
    cartSection.addEventListener('click', (event) => {
      if (modal && event.target.closest && event.target.closest('[data-cart-open-addons]')) modal.open();
    });
    if (!form || !checkoutButton) return;

    const goCheckout = () => {
      measureCheckoutStarted();
      window.location.href = root + 'checkout';
    };

    checkoutButton.addEventListener('click', async (event) => {
      event.preventDefault();
      showSaveError(false);
      if (!validateCartForCheckout(form)) return;
      if (checkoutButton.dataset.loading === 'true') return;
      checkoutButton.dataset.loading = 'true';
      const originalText = checkoutButton.textContent;
      const resetButton = () => {
        checkoutButton.disabled = false;
        checkoutButton.textContent = originalText;
        checkoutButton.dataset.loading = 'false';
      };
      checkoutButton.disabled = true;
      checkoutButton.textContent = 'Saving cart...';
      try {
        // A quantity, a removal or a time still on its way is saved first.
        await settleCartWrites();
        await updateCartFromForm(form);
        // After the quantities are saved (they go by line position), the fee line follows the window.
        await form._dfCartSchedule?.beforeCheckout();
      } catch(e) {
        // Never continue without the recipient, gift message, delivery date and time saved.
        console.warn('Dopamine cart save before checkout failed', e);
        form._dfCartSchedule?.checkoutStopped();
        resetButton();
        showSaveError(true);
        return;
      }
      detailsSaved = true;
      await refreshCartCount();
      if (modal && checkoutButton.dataset.checkoutSkipAddons !== 'true') {
        form._dfCartSchedule?.checkoutStopped();
        resetButton();
        modal.open();
      } else {
        goCheckout();
      }
    });
  };

  initRevealProducts();
  initProductCardMedia();
  initMenuDrawer();
  initNavTouch();
  initFloatingHeader();
  initWeeklyDropTimer();
  document.querySelectorAll('[data-balloon-builder-source]').forEach(initBalloonBuilder);
  document.querySelectorAll('[data-vase-builder-source]').forEach(initVaseBuilder);
  document.querySelectorAll('[data-plush-picker-source]').forEach(initPlushPicker);
  document.querySelectorAll('[data-addon-shop-card]').forEach(initAddonShopCard);
  openAddonFromUrl();
  document.querySelectorAll('[data-product-section]').forEach(initProductForm);
  initTransactionalSmsConsent();
  document.querySelectorAll('[data-cart-form]').forEach(form => {
    initGiftOrderToggle(form);
    initGiftFrom(form);
    initGiftLivePreview(form);
    initGiftGenerator(form);
    initCartTyping(form);
    // "Update cart" and the other plain form posts: blank gift fields when the switch is off.
    form.addEventListener('formdata', (event) => applyGiftChoice(form, event.formData));
    // A quantity typed into the box is saved like − / + (when the box is left, or with Enter).
    form.addEventListener('change', (event) => {
      const input = event.target.closest ? event.target.closest('[data-cart-qty-input]') : null;
      const line = input && input.closest('[data-cart-line]');
      if (!line || !line.dataset.lineKey) return;
      const quantity = Number.parseInt(input.value, 10);
      if (!Number.isFinite(quantity) || quantity < 0) {
        input.value = line.dataset.lineQuantity || '1';
        return;
      }
      if (String(quantity) === line.dataset.lineQuantity && !pendingLineQuantities.has(line.dataset.lineKey)) return;
      queueCartLineQuantity(line, line.dataset.lineKey, quantity);
    });
    form.addEventListener('submit', (event) => {
      const submitter = event.submitter;
      // "Update cart" (and Enter in a box) saves the whole form in place, without a reload.
      if ((!submitter || submitter.name === 'update') && cartSectionId()) {
        event.preventDefault();
        // A box being typed in hands its number over first (its change event), then it is saved
        // ahead of the form.
        if (document.activeElement && document.activeElement.matches('[data-cart-qty-input]')) document.activeElement.blur();
        if (lineFlushTimer || pendingLineQuantities.size) startCartLineFlush().catch(() => {});
        cartWrites.run(async () => {
          await showCartAnswer(await updateCartFromForm(form, { sections: true }));
        }).catch(error => {
          console.warn('Dopamine cart update failed', error);
          sayCartLinesProblem(cartSectionElement()?.dataset.updateFailed || 'We could not update your cart. Please check your connection and try again.');
        });
        return;
      }
      if (submitter && submitter.name === 'checkout' && !validateCartForCheckout(form)) {
        event.preventDefault();
      } else if (submitter && submitter.name === 'checkout') {
        measureCheckoutStarted();
      }
    });
  });
  initDatePickers();
  document.querySelectorAll('[data-cart-form]').forEach(initCartSchedule);
  initCartCheckoutAddons();
  document.querySelectorAll('[data-free-delivery-meter]').forEach(meter => updateFreeDeliveryMeter(meter));

  document.querySelectorAll('[data-min-today]').forEach(input => {
    input.min = isoLocal(getMinimumDeliveryDateForInput(input));
  });

  // One cart.js for the header count and, on the cart page, the balloon and fee-line checks.
  reconcileCartOnLoad(refreshCartCount());
})();
